const ar = {
  "swap-crypto-sans-frais": {
    title: "مبادلة العملات المشفرة بدون رسوم إضافية: ما لا يضيفه Lumina وما يشكل التكلفة فعلياً",
    meta: "لا يضيف Lumina رسوم خدمة إضافية خاصة به إلى مبادلتك. اكتشف المكونات الستة التي تشكل تكلفة المبادلة فعلياً: العمولة التجارية المدفوعة من الشريك إلى Lumina، هامش الشريك، رسوم الشبكة، الفرق (spread)، الانزلاق (slippage) وتأثير السعر.",
    body: `قد ترى أحياناً عبارة "مبادلة عملات مشفرة بدون رسوم". هذه الصياغة قد تكون مضللة: فهي تصف غياب رسوم الخدمة الإضافية التي تضيفها المحفظة، وليس غياب أي تكلفة على الإطلاق. تبقى مبادلة العملات المشفرة عملية سوقية تتضمن عدة مكونات للتكلفة، مستقلة عن Lumina.

## الملخص الواضح

لا يضيف Lumina رسوم خدمة إضافية خاصة به إلى مبادلتك. قد تتلقى Lumina عمولة تجارية من شريك التبادل. قد يتضمن العرض شروط تسعير الشريك، والفرق (spread)، والانزلاق (slippage)، وتأثير السعر، ورسوم الشبكة. يتم عرض السعر والمبلغ التقديري المستلم قبل تأكيدك.

## المكونات الستة لتكلفة المبادلة

لفهم ما تدفعه فعلياً، يجب التمييز بين ستة عناصر:

### 1. رسوم الخدمة التي يضيفها Lumina

**لا يضيف** Lumina أي رسوم خدمة إضافية فوق العرض الذي يقدمه شريك التبادل. يعكس المبلغ المعروض عليك بالفعل غياب هذه الزيادة.

### 2. العمولة التجارية التي يتلقاها Lumina

قد تتلقى Lumina عمولة تجارية من شريك التبادل. هذه العمولة لا يضيفها Lumina كبند رسوم منفصل فوق العرض. ومع ذلك، قد تنعكس في شروط التسعير التي يقدمها الشريك.

### 3. رسوم أو هامش شريك التبادل

قد يطبق شريك التبادل رسومه التشغيلية الخاصة وهامشه الخاص. هذه العناصر مدرجة في السعر والمبلغ التقديري المعروضين في العرض قبل تأكيدك.

### 4. رسوم الشبكة (gas fees)

تعوض رسوم الشبكة عمال المناجم أو المدققين الذين يعالجون المعاملة. تختلف حسب البلوكتشين ومدى ازدحامه. بحسب مسار تنفيذ المبادلة، قد تُقدَّر رسوم الشبكة أو تُجمع ضمن المبلغ أو تُعرض في عرض الشريك.

### 5. الفرق (spread)

الفرق (spread) هو الفارق بين سعر الشراء وسعر البيع المعروض من مصدر السيولة. إنه تكلفة ضمنية: لا تراه كبند رسوم، لكنه يؤثر مباشرة على السعر المطبق على مبادلتك.

### 6. الانزلاق (slippage) وتأثير السعر

- **الانزلاق السعري (Slippage)** هو الفرق بين السعر المُقدَّر عند عرض السعر والسعر الذي يُنفَّذ به التبادل فعلياً. يزداد عندما تقل السيولة المتاحة.
- **تأثير السعر** هو الأثر الذي يحدثه طلبك على السعر: كلما زاد مبلغك مقارنة بالسيولة، ساء السعر بالنسبة لك.

يمكن أن يغير هذان العنصران المبلغ النهائي الذي تتلقاه مقارنة بالتقدير الأولي.

## ما يعرضه Lumina قبل تأكيدك

قبل تأكيدك، يعرض Lumina السعر والمبلغ التقديريين الواردين من الشريك، إلى جانب معلومات التسعير المتاحة في العرض. تُعرض رسوم الشبكة عندما يتم تحديدها أو تقديرها من قبل مسار المبادلة المعني.

تحتفظ بالقرار النهائي: بعد الاطلاع على العرض، تختار تأكيد العملية أو إلغائها.

## كيف تقوم بمبادلة في Lumina Wallet

1. افتح علامة التبويب **Swap** في التطبيق.
2. اختر الرمز (token) الذي تريد استبداله والرمز الذي تريد استلامه.
3. أدخل المبلغ المراد استبداله.
4. راجع العرض المعروض: السعر والمبلغ المقدران، بالإضافة إلى معلومات التسعير المتاحة (بما في ذلك رسوم الشبكة عندما يتم تحديدها أو تقديرها).
5. إذا ناسبك العرض، أكد المعاملة. وإلا، ألغِ وقم بالتعديل.

## ما يجب تذكره

مبادلة العملات المشفرة ليست مجانية تماماً أبداً، حتى عندما لا تضيف المحفظة نفسها رسوم خدمة. تعتمد التكلفة الحقيقية على الشريك والشبكة والفرق (spread) والانزلاق (slippage) وتأثير السعر. الممارسة الجيدة تكمن في فحص العرض والمقارنة إذا لزم الأمر والتحقق من كل معلمة قبل التأكيد.

**مستعد للتجربة؟** [قم بتحميل Lumina Wallet](/ar/download) وقم بمبادلتك الأولى مع الحفاظ على التحكم في كل خطوة.`
  },
  "comment-eviter-arnaques-crypto": {
    title: "كيف تتجنب عمليات الاحتيال في العملات المشفرة 2026: الدليل الشامل",
    meta: "اكتشف أكثر عمليات احتيال العملات المشفرة شيوعاً في 2026 (التصيد، Rug Pull، الإيردروب المزيف) وتعلم كيف تتجنبها لحماية أصولك. الدليل الكامل لتأمين محفظتك.",
    body: `عالم العملات المشفرة مثير، لكنه يجذب أيضاً الكثير من المحتالين. في عام 2025، وصلت عمليات احتيال العملات المشفرة إلى مستوى غير مسبوق من التطور، مما كلف المستثمرين مليارات الدولارات [1]. فهم هذه التهديدات هو الخطوة الأولى لحماية أصولك الرقمية.

## أكثر أنواع احتيال العملات المشفرة شيوعاً في 2026

### 1. التصيد الاحتيالي (Phishing)

يبقى التصيد الأسلوب الأكثر استخداماً. ينشئ المحتالون مواقع مزيفة تقلد المنصات الشرعية لإغرائك بإدخال عبارة الاسترداد (seed phrase) أو ربط محفظتك.

> **مثال**: تتلقى بريداً يبدو من MetaMask يطلب التحقق من حسابك عبر رابط. هذا الرابط يوجهك لموقع مستنسخ يسجل بياناتك السرية.

**كيف تتجنبه**:
- لا تنقر أبداً على روابط من رسائل غير مطلوبة.
- تحقق دائماً من عنوان URL.
- **لا تدخل أبداً** عبارة الاسترداد على أي موقع.

### 2. Rug Pull (سحب البساط)

يحدث عندما يطلق فريق تطوير رمزاً جديداً، يجذب المستثمرين لرفع السعر، ثم يسحب فجأة كل السيولة.

**كيف تتجنبه**:
- **ابحث عن الفريق**: فريق مجهول = إنذار خطير.
- **تحقق من السيولة**: هل هي مقفلة؟
- **حلل توزيع الرموز**: تركيز عالٍ = خطر مرتفع.

### 3. إيردروب وهدايا مزيفة

يعد المحتالون برموز مجانية مقابل "رسوم معاملة" أو ربط محفظتك بموقع ضار.

**كيف تتجنبه**:
- الإيردروب الحقيقي **لن يطلب** منك إرسال أموال أو عبارة الاسترداد.
- احذر من الوعود غير الواقعية.

### 4. احتيال موافقات العقود الذكية (Approve/Permit)

توقع معاملة تمنح عقداً ذكياً خبيثاً إذن إنفاق رموزك.

## كيف تحميك Lumina Wallet

| ميزة الأمان | كيف تحميك Lumina |
|---|---|
| **ماسح مكافحة الاحتيال الفوري** | يحلل العناوين والعقود الذكية قبل كل معاملة. |
| **محاكاة المعاملة** | يعرض ما ستفعله المعاملة **قبل** التوقيع. |
| **الحفظ الذاتي (Non-Custodial)** | مفاتيحك الخاصة لا تغادر جهازك أبداً. |

## الخلاصة

باستخدام محفظة آمنة مثل **Lumina Wallet**، تضيف طبقة حماية تقنية أساسية.

**مستعد لحماية عملاتك المشفرة؟** [حمّل Lumina Wallet اليوم](#) وتداول بكل اطمئنان.

---

### المراجع

[1] Chainalysis. (2026). *2026 Crypto Crime Report: Scams*. [https://www.chainalysis.com/blog/crypto-scams-2026/](https://www.chainalysis.com/blog/crypto-scams-2026/)`
  },
  "securiser-wallet-crypto": {
    title: "كيف تؤمّن محفظة العملات المشفرة: 10 خطوات أساسية",
    meta: "تعلم كيف تؤمّن محفظتك المشفرة. احمِ عبارة الاسترداد، استخدم محفظة غير احتجازية وفعّل المصادقة الثنائية.",
    body: `أمان عملاتك المشفرة يعتمد على عاداتك الشخصية أيضاً.

## 1. اختر محفظة غير احتجازية (Non-Custodial)

محفظة **غير احتجازية** مثل **Lumina Wallet** تعني أنك وحدك تملك المفاتيح الخاصة.

> **"Not your keys, not your coins"** هو الشعار الأساسي.

## 2. احمِ عبارة الاسترداد

- **اكتبها على ورق**.
- **اصنع عدة نسخ** في أماكن آمنة مختلفة.
- **لا تشاركها أبداً**.

## 3. استخدم كلمة مرور قوية وفريدة

## 4. فعّل المصادقة الثنائية (2FA)

## 5. احذر من شبكات Wi-Fi العامة

## 6. افصل أموالك: محفظة "ساخنة" و"باردة"

| نوع المحفظة | الاستخدام | مثال |
|---|---|---|
| **محفظة ساخنة** | المعاملات اليومية. | **Lumina Wallet** (موبايل/ويب) |
| **محفظة باردة** | التخزين طويل الأمد. | محفظة أجهزة (Ledger, Trezor) |

## 7. حدّث تطبيقك

## 8. كن متشككاً تجاه التطبيقات اللامركزية الجديدة

**Lumina Wallet** تساعدك بمحاكاة المعاملات.

## 9. إلغاء الموافقات

استخدم [Revoke.cash](https://revoke.cash/) للتحقق وإلغاء الأذونات.

## 10. استخدم محفظة بميزات أمان مدمجة

**Lumina Wallet**: ماسح، محاكاة، دعم متعدد السلاسل.

## الخلاصة

باتباع هذه الخطوات العشر مع **Lumina Wallet**، تقلل المخاطر بشكل كبير.

**مستعد للمستوى التالي من الأمان؟** [حمّل Lumina Wallet](#) وتحكم بالكامل.`
  },
"wallet-non-custodial-guide": {
    title: "ما هي المحفظة غير الاحتجازية؟ الدليل الكامل",
    meta: "افهم الفرق بين المحفظة الاحتجازية وغير الاحتجازية. اكتشف لماذا محفظة مثل Lumina Wallet ضرورية لأمان عملاتك المشفرة.",
    body: `إذا كنت جديداً في عالم العملات المشفرة، فمن المحتمل أنك سمعت بمصطلحي "احتجازية" و"غير احتجازية".

## احتجازية مقابل غير احتجازية: الفرق الجوهري

| نوع المحفظة | من يتحكم بالمفاتيح الخاصة؟ | أمثلة |
|---|---|---|
| **احتجازية** | المنصة (طرف ثالث) | المنصات (Binance, Coinbase) |
| **غير احتجازية** | **أنت** | **Lumina Wallet**, MetaMask, Ledger |

### غير احتجازية: التحكم الكامل والملكية الحقيقية

**Lumina Wallet** تمنحك التحكم الكامل عبر **عبارة استرداد** من 12 أو 24 كلمة.

**المزايا:**
- **تحكم كامل**: أنت بنكك الخاص.
- **أقصى أمان**: لا خطر اختراق المنصة.
- **خصوصية**: لا حاجة لـ KYC.

## Lumina Wallet: الأفضل من العالمين

- **100% غير احتجازية**
- **واجهة بديهية**
- **متعددة السلاسل**: إدارة جميع الأصول في تطبيق واحد.

**مستعد لتكون بنكك الخاص؟** [حمّل Lumina Wallet اليوم](#) واكتشف الملكية الحقيقية للعملات المشفرة.`
  },
  "comparatif-wallets-crypto": {
    title: "مقارنة أفضل محافظ العملات المشفرة 2026",
    meta: "ما هي أفضل محفظة عملات مشفرة في 2026؟ مقارنة شاملة بين Lumina Wallet وMetaMask وTrust Wallet ومحافظ الأجهزة.",
    body: `اختيار المحفظة المناسبة أمر حاسم. هذه المقارنة تحلل أشهر المحافظ في 2026.

## المقارنة: Lumina مقابل MetaMask مقابل Trust Wallet مقابل Ledger

| الميزة | Lumina Wallet | MetaMask | Trust Wallet | Ledger |
| --- | --- | --- | --- | --- |
| **النوع** | غير احتجازية | غير احتجازية | غير احتجازية | غير احتجازية (باردة) |
| **الأمان** | عالٍ جداً (ماسح مكافحة الاحتيال) | عالٍ | عالٍ | الأعلى |
| **متعدد السلاسل** | BTC, ETH, SOL, XRP +10 | شبكات EVM وSolana وBitcoin | جيد | جيد |
| **سهولة الاستخدام** | مصمم للمبتدئين | أكثر تقنية للمبتدئين | سهل | متوسط |
| **مبادلة مدمجة** | نعم (لا تضيف Lumina رسوم خدمة إضافية؛ قد تنطبق أسعار الشريك ورسوم الشبكة والفارق والانزلاق وتأثير السعر) | نعم (0.875%) | نعم | نعم (مع رسوم) |

## الخلاصة

- للإدارة اليومية: **Lumina Wallet**
- للتخزين طويل الأمد: **محفظة أجهزة**
- لخبراء DeFi: **MetaMask**

**مستعد للاختيار؟** [حمّل Lumina Wallet](#) واكتشف تجربة عملات مشفرة جديدة.`
  },
  "guide-debutant-crypto": {
    title: "دليل المبتدئين: كيف تبدأ في العملات المشفرة 2026",
    meta: "تريد البدء في العملات المشفرة لكن لا تعرف من أين؟ هذا الدليل البسيط يشرح كل شيء.",
    body: `عالم العملات المشفرة قد يبدو مخيفاً في البداية. لكن البداية أسهل مما يبدو.

## الخطوة 1: فهم المفاهيم الأساسية

- **البلوكتشين**: سجل رقمي عام ولامركزي وآمن.
- **العملة المشفرة**: أصل رقمي يستخدم التشفير. الأشهر: Bitcoin (BTC) وEthereum (ETH).
- **المحفظة**: تطبيق لتخزين وإرسال واستقبال العملات المشفرة.

## الخطوة 2: شراء عملاتك المشفرة الأولى

عبر **منصة تداول مركزية (CEX)** مثل Coinbase أو Binance أو Kraken.

1. **أنشئ حساباً**.
2. **تحقق من هويتك** (KYC).
3. **أودع أموالاً**.
4. **اشترِ العملة** التي تختارها.

## الخطوة 3: تأمين عملاتك في محفظة غير احتجازية

من **الضروري نقل** عملاتك إلى محفظة تتحكم بها بالكامل مثل **Lumina Wallet**.

1. **حمّل Lumina Wallet**.
2. **أنشئ محفظة جديدة**. سيولّد التطبيق **عبارة استرداد**.
3. **اكتب العبارة على ورق** واحتفظ بها بأمان.
4. **حوّل عملاتك** إلى عنوان Lumina Wallet الجديد.

## الخطوة 4: معاملاتك الأولى

- **إرسال واستقبال**: أرسل عملات عبر عنوان المحفظة.
- **مبادلة**: بادل العملات مباشرة في Lumina Wallet دون رسوم خدمة إضافية من Lumina (تبقى رسوم الشبكة وشروط الشريك سارية).
- **التفاعل مع dApps**: عبر WalletConnect.

## نصائح للمبتدئين

- **استثمر فقط ما تستطيع خسارته**.
- **ابحث بنفسك (DYOR)**.
- **تحلَّ بالصبر**.
- **الأمان أولاً**.

**مستعد لخطواتك الأولى؟** [حمّل Lumina Wallet](#) وانضم إلى ثورة التمويل اللامركزي.`
  },
  "seed-phrase-guide": {
    title: "ما هي عبارة الاسترداد (Seed Phrase)؟",
    meta: "عبارة الاسترداد هي مفتاح محفظتك المشفرة. تعلم ما هي وكيف تعمل وأفضل الممارسات لتخزينها بأمان.",
    body: `في عالم المحافظ غير الاحتجازية، **عبارة الاسترداد** هي أهم مفهوم أمني.

## ما هي عبارة الاسترداد؟

قائمة من **12 إلى 24 كلمة** تُولّد عند إنشاء محفظة غير احتجازية مثل **Lumina Wallet**.

> **مثال**: \`witch collapse practice feed shame open despair creator tenant camp strike\`

## كيف تعمل؟

بناءً على معيار التشفير **BIP-39**:

1. تولّد المحفظة سلسلة أرقام عشوائية.
2. تحول إلى قائمة كلمات من قاموس معياري يضم 2048 كلمة.
3. يُشتق **المفتاح الخاص الرئيسي**.
4. منه تُولّد **مفاتيح خاصة فردية** لكل عملة مشفرة.

## لماذا هي بالغة الأهمية؟

- **عند فقدان الجهاز**: ثبّت Lumina Wallet على جهاز جديد، أدخل العبارة، واسترجع الوصول فوراً.
- **إذا حصل شخص آخر على العبارة**: يمكنه سرقة محفظتك بالكامل.

> **القاعدة الذهبية**: عامل عبارة الاسترداد كسبيكة ذهب.

## كيف تخزنها بأمان

### ما يجب فعله
- **اكتبها على ورق**.
- **اصنع عدة نسخ** في أماكن آمنة مختلفة.
- **استخدم مواد متينة**: نقش على لوح معدني.

### ما لا يجب فعله
- **لا تخزنها رقمياً**.
- **لا تخزنها في السحابة**.
- **لا تشاركها أبداً** مع أي شخص.

**مستعد للسيطرة؟** [حمّل Lumina Wallet](#) واكتشف قوة الحفظ الذاتي.`
  },
  "arnaques-smart-contracts": {
    title: "العقود الذكية: كيف تتجنب احتيال الموافقات (Approve / Permit)",
    meta: "احتيال العقود الذكية (Approve, Permit) في تزايد. تعلم كيف يفرّغ القراصنة محفظتك وكيف يحميك ماسح Lumina Wallet.",
    body: `تعتقد أنك آمن لأنك لا تشارك عبارة الاسترداد أبداً؟ فكر مجدداً. جيل جديد من الاحتيال يستهدف التفاعل مع **العقود الذكية**.

## فهم موافقات الرموز (Approve)

**ما هي الموافقة؟** إذن تمنحه لعقد ذكي لإنفاق كمية معينة من رموزك.

### خطر الموافقات غير المحدودة

العديد من التطبيقات تطلب **موافقات غير محدودة** — تسمح للعقد الذكي بإنفاق كمية لا نهائية من رموزك للأبد.

## احتيال "Permit" والتوقيعات خارج السلسلة

1. موقع خبيث يطلب توقيع رسالة (**بدون رسوم gas**).
2. الرسالة تحتوي تفويض \`Permit\`.
3. القرصان يستخدم التوقيع لإفراغ رموزك.

> **الفخ**: بدون رسوم gas = يبدو آمناً. هذا خطأ.

## كيف تثور Lumina Wallet على أمان المعاملات

| محفظة عادية | Lumina Wallet |
| --- | --- |
| بيانات سداسية غير مفهومة | **تنبيه: أنت على وشك السماح بإنفاق كل USDC الخاصة بك.** |
| "وقّع الرسالة" | **تحذير: هذه الرسالة تأذن بنقل NFT الخاصة بك.** |

## أفضل الممارسات

1. **استخدم محفظة تحاكي المعاملات** مثل **Lumina Wallet**.
2. **كن حذراً جداً** من العروض المغرية.
3. **استخدم محفظة مؤقتة** للتطبيقات غير المعروفة.
4. **ألغِ الموافقات بانتظام** عبر [Revoke.cash](https://revoke.cash/).

**لا توقّع بشكل أعمى بعد اليوم.** [حمّل Lumina Wallet](#) واكتشف أمان المعاملات الحقيقي.`
  },
  "arnaque-smart-contract-trust-wallet-vs-lumina": {
    title: "احتيال العقود الذكية: لماذا محفظتك كالغربال (وكيف تحميك Lumina)",
    meta: "اكتشف من خلال مقارنة صادمة كيف يمكن لاحتيال الموافقة غير المحدودة إفراغ محفظتك. اعرف لماذا تقدم Lumina Wallet حماية لا يملكها الآخرون.",
    body: `> **السياق:** في 13 مارس 2026، [كشفت Le Parisien](https://www.leparisien.fr/faits-divers/arnaque-aux-cryptos-a-paris-les-escrocs-presumes-auraient-depouille-leurs-victimes-de-11-millions-deuros-13-03-2026-D53QN2HAUVFHZGX6YJBD6LKLLA.php) أن شبكة محتالين سرقت **11 مليون يورو من العملات المشفرة**. الأسلوب: مواقع احتيالية وموافقات عقود ذكية مزورة.

---

أكبر شريك في هذا الاحتيال؟ **محفظتك نفسها.** معظم المحافظ تعرض تحذيرات ضعيفة جداً بحيث لا يفهم المستخدم العادي الخطر.

## الاختبار: موقع احتيال حقيقي

اختبرنا موقع احتيال حقيقي: **bitcoin-suisse-verif.com**.

## 1. رد فعل Trust Wallet: الخطر الخفي

Trust Wallet تعرض تأكيد بسيط لإرسال 0 ETH. لا تحذيرات.

## 2. رد فعل Lumina Wallet: الدرع النشط

![تنبيه أمان Lumina Wallet - تم رصد خطر](https://customer-assets.emergentagent.com/job_92eb487e-5db1-496a-be31-c7d8444bed8d/artifacts/9ltapzuw_screenshot_danger.png)

- **تنبيهات واضحة ومرئية**: "خطر - وصول غير محدود" بالأحمر الساطع.
- **شرح بلغة بسيطة**.
- **ردع نشط**: الزر الافتراضي هو "رفض".

## مقارنة مباشرة

| | Trust Wallet | Lumina Wallet |
|---|---|---|
| **تنبيه مرئي** | لا يوجد | خطر بالأحمر الساطع |
| **شرح المخاطر** | لا يوجد | واضح ومباشر |
| **نوع الموافقة** | غير مذكور | "وصول غير محدود لجميع الرموز" |
| **العقد موثق؟** | غير مذكور | تنبيه "عقد غير موثق" |
| **الإجراء الافتراضي** | موافقة | رفض |

> **"نفس الاحتيال، محفظتان، ردتا فعل. واحدة تخذلك، والأخرى تحميك."**

**أمانك بنقرة واحدة.** [حمّل Lumina Wallet اليوم](#) واكتشف راحة البال مع محفظة تعمل حقاً من أجلك.`
  }
,
  "empoisonnement-adresse-arnaque-crypto": {
    title: "تسميم العناوين (Address Poisoning): عملية الاحتيال الجديدة في عالم الكريبتو التي تكلف الملايين",
    meta: "اكتشف كيف يعمل تسميم العناوين (address poisoning)، ولماذا قد يكلفك مجرد نسخ ولصق ملايين، وكيف تحميك محفظة Lumina.",
    body: `## التهديد الخفي للنسخ واللصق

في عالم العملات المشفرة المحموم، حيث كل معاملة ذات أهمية وحيث اليقظة أمر بالغ الأهمية، ينتشر تهديد خفي جديد: **تسميم العنوان (Address Poisoning)**. قد يكلفك مجرد نسخ ولصق، وهي حركة يومية عادية، ملايين الآن. يستهدف هذا التكتيك المتطور من مجرمي الإنترنت حتى المستخدمين الأكثر دراية، محولاً الراحة إلى فخ مدمر. وبينما تستمر عمليات الاحتيال في العملات المشفرة في التزايد والاحتراف، فمن الضروري فهم كيفية عمل هذا الهجوم لاتخاذ تدابير وقائية أفضل.

## ما هو تسميم العنوان (Address Poisoning)؟

تسميم العنوان هو شكل من أشكال الاحتيال حيث يقوم المهاجمون **بالتلاعب بسجل معاملاتك** لخداعك. الهدف هو جعلك ترسل أموالاً إلى عنوان خبيث يشبه بشكل مخادع عنوانًا شرعيًا كنت قد تفاعلت معه من قبل. يستغل مجرمو الإنترنت ضعفًا بشريًا أساسيًا: الميل إلى التحقق من الأحرف الأولى والأخيرة فقط من عنوان طويل ومعقد.

**مثال واقعي:** تخيل أنك ترسل الأموال بانتظام إلى العنوان \\\`0x123...abc\\\`. سيقوم المهاجم بإنشاء عنوان \\\`0x123...abC\\\` (مع تغيير طفيف، غالبًا حرف واحد فقط) وحقنه في سجل معاملاتك. عندما ترغب في إرسال أموال إلى جهة اتصالك المعتادة، قد تقوم، دون قصد، بنسخ عنوان المهاجم بدلاً من العنوان الصحيح.

## كيف يعمل: آلية الاحتيال

العملية بسيطة بشكل مخادع:

### 1. الحقن
يراقب المهاجمون البلوك تشين لتحديد المحافظ النشطة. ثم يرسلون كميات صغيرة جدًا من العملات المشفرة (غالبًا 0 إيثريوم أو جزءًا ضئيلاً من توكن) من عنوان يتحكمون فيه إلى محفظتك. تم تصميم هذا العنوان خصيصًا ليبدو مشابهًا لعنوان كنت قد أجريت معه معاملات بالفعل.

### 2. السجل (التاريخ)
تظهر هذه المعاملة الصغيرة، ولكن الخبيثة، في سجل معاملات محفظتك. غالبًا ما توضع بالقرب من معاملاتك الشرعية، مما يزيد من احتمالية ملاحظتك لها.

### 3. النسخ واللصق
عندما ترغب في إجراء معاملة جديدة إلى جهة اتصالك المعتادة، قد تقوم، عن طريق العادة أو الإهمال، بنسخ عنوان المهاجم من سجل معاملاتك بدلاً من العنوان الصحيح.

### 4. الخسارة
بمجرد إرسال الأموال إلى عنوان المهاجم، فإنها **تُفقد بشكل لا رجعة فيه**. تجعل الطبيعة اللامركزية للبلوك تشين من المستحيل إلغاء المعاملة أو استرداد الأموال.

## العواقب: خسارة لا رجعة فيها

تكمن خطورة تسميم العنوان في طبيعته الخفية ونهائية معاملات البلوك تشين. بمجرد تأكيدك للإرسال إلى عنوان المهاجم، لا يوجد أي سبيل للرجوع. يتم تحويل الأموال وتختفي في متاهات المحافظ الخبيثة، وغالبًا ما يتم غسلها بسرعة، مما يجعل أي استرداد شبه مستحيل.

## كيف تحميك Lumina Wallet: ماسح التدقيق الأمني للعناوين

في مواجهة هذا التهديد المتزايد، تتخذ **Lumina Wallet** موقعها كخط دفاعك الأول. تم تصميم ماسح التدقيق الأمني للعناوين الخاص بنا للكشف عن هذه الفخاخ غير المرئية قبل أن تكلفك الكثير. إليك كيفية عمله:

- **التحقق في الوقت الفعلي**: يخضع كل عنوان تتفاعل معه لتدقيق دقيق وفوري.
- **اكتشاف العناوين الخبيثة**: لا تكتفي Lumina بالتحقق من الصلاحية التقنية (EIP-55) فحسب، بل تقاطع المعلومات مع قواعد بيانات استخبارات التهديدات في الوقت الفعلي (عبر شركاء مثل GoPlus Security) لتحديد العناوين المعروفة بارتباطها بالقوائم السوداء أو التصيد الاحتيالي أو Honeypots.
- **تنبيهات واضحة**: قبل أن توافق على معاملة، توفر لك Lumina مؤشر أمان واضحًا: **أخضر** (آمن)، **أصفر** (حذر)، أو **أحمر** (خطر/محظور). يتيح لك هذا اتخاذ قرار مستنير وتجنب الأخطاء المكلفة.

بفضل Lumina Wallet، تستفيد من حماية استباقية تتجاوز مجرد إدارة المفاتيح الخاصة، مما يحميك من عمليات الاحتيال المتطورة التي تستغل نقاط الضعف البشرية.

## نصائح وقائية لمستخدمي العملات المشفرة

على الرغم من أن Lumina Wallet توفر حماية متقدمة، إلا أن بعض الممارسات الجيدة تظل ضرورية:

- **تحقق دائمًا من العنوان الكامل**: خذ وقتك للتحقق من كل حرف في عنوان الوجهة، وليس فقط البداية والنهاية.
- **قم بإجراء اختبار صغير**: قبل إرسال مبالغ كبيرة، قم بإجراء معاملة اختبار صغيرة للتأكد من أن العنوان صحيح.
- **استخدم المحافظ الآمنة**: فضل المحافظ التي تدمج ميزات أمان متقدمة مثل ماسح العناوين في Lumina Wallet.

## الخلاصة: اليقظة المعززة بالتكنولوجيا

تسميم العنوان هو تذكير صارخ بأن الأمن في فضاء العملات المشفرة معركة مستمرة. ولكن مع الأدوات المناسبة، لست وحدك. تم تصميم **Lumina Wallet** ليكون درعك، حيث يجمع بين التكنولوجيا المتطورة وواجهة سهلة الاستخدام ليوفر لك راحة البال. تصفح عالم العملات المشفرة بثقة تامة، مع العلم أن Lumina Wallet هي خط دفاعك الأول ضد عمليات الاحتيال الحديثة.

[تنزيل Lumina Wallet على Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [تنزيل Lumina Wallet على App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  }
,
  "permit2-arnaques-signature-crypto": {
    title: "Permit2 وعمليات الاحتيال بالتوقيع: احمِ محفظتك من الفخاخ الخفية",
    meta: "افهموا مخاطر توقيعات Permit2 والموافقات غير المحدودة. اكتشفوا كيف يفك Lumina Wallet تشفير كل توقيع لحمايتكم من سارقي المحافظ.",
    body: `## المخاطر الخفية لتوقيعات المعاملات

في بيئة الويب 3 (Web3)، يُعد توقيع المعاملة هو الفعل الأسمى للتحكم. إنها اللحظة التي تمنح فيها موافقتك على إجراء معين على البلوك تشين (blockchain). ومع ذلك، مع تطور البروتوكولات وظهور ميزات جديدة مثل **Permit2**، وجد مجرمو الإنترنت طرقًا لتحويل هذا الفعل الذي يعتمد على الثقة إلى فخ غير مرئي. قد تعتقد أنك توقع معاملة بسيطة، بينما في الواقع، تمنح وصولاً غير محدود لأموالك. أصبح فهم عمليات الاحتيال المرتبطة بالتوقيعات أمرًا ضروريًا لكل مستخدم للعملات المشفرة.

## ما هو Permit2 ولماذا هو مفيد؟

Permit2 هو عقد ذكي مبتكر، صممته **Uniswap** في الأصل، لتبسيط وتحسين إدارة الموافقات على التوكنات. تقليديًا، لكل توكن جديد كنت ترغب في تداوله على منصة تبادل لامركزي (DEX)، كان عليك إجراء معاملة موافقة منفصلة، مما يكلف رسوم غاز ويستغرق وقتًا. يتيح Permit2 تجميع هذه الموافقات وإدارتها عبر توقيعات "خارج السلسلة" (off-chain)، مما يجعل التفاعلات مع التمويل اللامركزي (DeFi) أكثر سلاسة واقتصادية بكثير.

## كيف تعمل عمليات الاحتيال باستخدام Permit2؟

لسوء الحظ، فتحت هذه الكفاءة المتزايدة الباب لأشكال جديدة من التصيد الاحتيالي:

### 1. مواقع ويب أو تطبيقات لامركزية احتيالية
ينشئ المهاجمون منصات تحاكي خدمات التمويل اللامركزي (DeFi) الشهيرة. عندما يحاول المستخدم التفاعل مع هذه المواقع، يُطلب منه توقيع توقيع Permit2.

### 2. توقيعات مضللة
على عكس المعاملة التقليدية، غالبًا ما يتم عرض محتوى توقيع Permit2 على شكل **بيانات سداسية عشرية خام**، وهي غير مفهومة للمستخدم العادي. يستغل المهاجم ذلك لإدخال طلب موافقة غير محدود لعناوينه الخاصة.

### 3. عواقب مدمرة
بمجرد إتمام التوقيع، يحصل المهاجم على الحق في تحويل توكناتك **دون الحاجة إلى توقيع أي معاملة جديدة منك**. يمكن إفراغ محفظتك في لحظة، دون أي إشارة تحذيرية على السلسلة.

## لماذا هو خطير جدًا: التهديد الخفي للموافقات

يكمن الخطر الأكبر لعمليات الاحتيال القائمة على التوقيعات في **عدم وضوحها**. فالتوقيع على Permit2 لا يطلق معاملة فورية على البلوك تشين. بل يمنح تصريحًا يمكن أن يستخدمه المهاجم لاحقًا. بالإضافة إلى ذلك، فإن التعقيد الفني للبيانات الموقعة يجعل من شبه المستحيل على المستخدم غير المطلع فهم التداعيات الحقيقية لفعله. إنه استغلال مباشر للثقة ونقص الشفافية.

## دور Lumina Wallet: فك تشفير المعاملات والتوقيعات

هنا يتدخل **Lumina Wallet** لتحويل الغموض إلى وضوح. إن فك تشفير المعاملات والتوقيعات الخاص بنا هو درعك ضد الفخاخ الخفية:

- **الترجمة بلغة واضحة**: يفكك Lumina على الفور البيانات السداسية العشرية المعقدة لتوقيعات Permit2 وموافقات ERC-20. يظهر لك بالضبط ما أنت على وشك توقيعه، بعبارات بسيطة ومفهومة.
- **شفافية تامة**: قبل كل توقيع، يعرض Lumina الإجراء المطلوب: هل هي موافقة محدودة أم غير محدودة؟ لمن تمنح حق الوصول إلى أموالك؟
- **تقييم المخاطر**: بفضل نظام تقييم المخاطر المرمز بالألوان لدينا (آمن، منخفض، متوسط، مرتفع، حرج)، يتم تنبيهك فورًا إذا كان التوقيع ينطوي على خطر محتمل.

مع Lumina Wallet، لن توقع أبداً في الظلام بعد الآن. تستعيد السيطرة الكاملة على تفاعلاتك في الويب 3 بفضل شفافية لا تتزعزع.

## أفضل الممارسات لأمان التوقيعات

للتنقل بأمان، اعتمد هذه الممارسات:

- **اقرأ بعناية**: لا توقع أبداً على معاملة أو توقيع دون قراءة وفهم التفاصيل.
- **استخدم أدوات فك التشفير**: فضل المحافظ مثل Lumina Wallet التي تترجم البيانات الفنية إلى لغة واضحة.
- **إلغاء الموافقات**: اعتد على إلغاء الموافقات بانتظام على التوكنات التي لم تعد تستخدمها.

## الخلاصة: وقّع بمعرفة تامة مع Lumina

لا يجب أن يكون الأمان في الويب 3 ترفاً، بل معياراً. تلتزم **Lumina Wallet** بتزويدك بالأدوات اللازمة لحمايتك من التهديدات الأكثر تعقيداً. من خلال إضفاء الوضوح حيث كان هناك غموض، يتيح لك Lumina الاستمتاع الكامل بالتمويل اللامركزي (DeFi) والعملات المشفرة، بأمان تام. وقّع بثقة، وقّع مع Lumina.

[تحميل Lumina Wallet على Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [تحميل Lumina Wallet على App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "faux-wallets-crypto-clones": {
    title: "محافظ الكريبتو المزيفة: كيف تتعرف على النسخ المستنسخة التي تفرغ حساباتك",
    meta: "يوزع المحتالون تطبيقات محافظ مستنسخة بشكل مثالي لسرقة كلماتك الاثنتي عشرة أو الأربع والعشرين. اكتشف علامات التحذير وكيف تحمي محفظتك على الويب 3.",
    body: `## تشريح المحفظة المزيفة

يستثمر المحتالون موارد كبيرة لإنشاء نسخ مثالية من أشهر المحافظ. تنسخ هذه النسخ الشعارات والألوان والخطوط وواجهة المستخدم الدقيقة للتطبيقات الشرعية. بالعين المجردة، يكاد يكون من المستحيل التمييز بين نسخة مزيفة والأصلية.

يُحكم الفخ عادةً في ثلاث خطوات:

### 1. التوزيع الاحتيالي
تُوزَّع المحافظ المزيفة عبر إعلانات مضللة في محركات البحث، رسائل خاصة على الشبكات الاجتماعية (X، تليغرام، ديسكورد)، أو بتجاوز مؤقت لفلاتر المتاجر الرسمية.

### 2. وهم التحديث أو الخطأ
بعد التثبيت، يحاكي التطبيق المستنسخ مشكلة تقنية: خطأ اتصال مزيف، رصيد مجمد، أو "تحديث أمني إجباري" مزعوم.

### 3. استخراج عبارة الاسترداد
"لحل" المشكلة المزيفة، يطلب التطبيق منك إدخال كلماتك الاثنتي عشرة أو الأربع والعشرين. بمجرد تأكيدك، تُنقل هذه الكلمات كنص عادي إلى خادم المهاجم، الذي يفرغ فورًا جميع حساباتك.

## علامات التحذير التي يجب ألا تتجاهلها أبدًا

- **طلب عبارة الاسترداد** — لن تطلب منك محفظة شرعية أو دعم فني أو موقع ويب **أبدًا** إدخال عبارة الاسترداد لحل مشكلة. كلماتك الاثنتي عشرة أو الأربع والعشرين تخدم غرضًا واحدًا فقط: استعادة حساباتك على جهاز جديد.
- **النوافذ المنبثقة غير المفسرة** — إذا ظهرت فجأة نافذة تطلب منك تسجيل الدخول أثناء تصفح موقع غير مرتبط بالكريبتو، أغلقها فورًا.
- **مصدر التنزيل** — نزّل المحافظ والإضافات فقط من الموقع الرسمي للناشر. لا تنقر أبدًا على روابط تلقيتها عبر البريد الإلكتروني أو الرسائل الخاصة. تحقق من عنوان URL بحثًا عن أخطاء إملائية دقيقة ("rn" بدلًا من "m").

## أمان الجهاز مقابل الأمان على السلسلة

المحفظة غير الوصائية مثل **Lumina Wallet** مصممة لتحليل المعاملات وفك تشفير العقود الذكية وتنبيهك إذا كنت على وشك إرسال أموال إلى عنوان خطير. تقارن البيانات مع قواعد التهديدات في الوقت الفعلي لمنع التصيد على السلسلة.

ومع ذلك، **لا يمكن لأي محفظة حمايتك إذا كان الجهاز الذي تعمل عليه مخترقًا ببرمجيات خبيثة**، أو إذا أدخلت طوعًا عبارة الاسترداد في تطبيق مزيف.

## قائمة السلامة الخاصة بك

- نزّل Lumina Wallet فقط من [luminawallet.org](https://luminawallet.org) أو المتاجر الرسمية.
- تحقق من الناشر: **HÉDONISME SARL** لـ Lumina Wallet.
- حافظ على تحديث نظام التشغيل والتطبيقات.
- لا تُدخل أبدًا عبارة الاسترداد الخاصة بك، إلا لاستعادة حساب طوعًا على جهاز موثوق.

## الخلاصة

يتطلب أمان الويب 3 نظافة رقمية شاملة. تؤمن Lumina تفاعلاتك على السلسلة؛ ويتعين عليك تأمين البيئة التي تعمل فيها.

[تحميل من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [تحميل من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "faux-support-arnaques-recuperation-crypto": {
    title: "الدعم المزيف واحتيال الاسترداد: الضربة المزدوجة لضحايا الكريبتو",
    meta: "بعد الاختراق، تعد موجة ثانية من المحتالين بإعادة أموالك مقابل رسوم. تعلم التعرف على خدمات الاسترداد المزيفة وعملاء الدعم المزيفين.",
    body: `> هل تبحث عن الخطوات العملية بعد السرقة؟ اقرأ [سرقة العملات الرقمية: ماذا تفعل في أول 24 ساعة](/ar/blog/crypto-volees-que-faire).

## الضربة المزدوجة

فقدان العملات المشفرة بسبب سهو أو اختراق أو احتيال تجربة صادمة. وسط الذعر الذي يعقب ذلك، تبحث الضحية بيأس عن حل. في هذه اللحظة بالتحديد من أقصى درجات الهشاشة، تضرب فئة ثانية من المحتالين: **خدمات الاسترداد المزيفة وعملاء الدعم الفني المزيفون**.

تعتمد هذه الاحتيالات، التي تُعرف غالبًا باسم "احتيال الدفع المسبق"، على تلاعب نفسي قاسٍ.

> **تعريف — احتيال الاسترداد:** احتيال ثانٍ يستهدف شخصًا سبق أن تضرر، ويُعد بأن يستعيد أمواله مقابل دفع أو بيانات حساسة أو الوصول إلى جهازه.

## احتيال الاسترداد

يحتفظ المحتالون بقوائم الضحايا ويراقبون بنشاط المنتديات والشبكات الاجتماعية وأقسام التعليقات. الآلية:

1. **الاتصال العناية الإلهية** — يزعم خبير في الأمن السيبراني أو "قرصان أخلاقي" أو وكيل مزيف لسلطة مالية أنه تتبع أموالك.
2. **الدليل المزيف** — يعرض لك لقطة شاشة لمحفظة مليئة أو موقعًا برصيد يوازي خسائرك. كلاهما تحت سيطرته.
3. **فخ الرسوم** — أموالك "جاهزة للتحويل"، لكن عليك أولًا دفع رسوم: "ضريبة فتح القفل"، "رسوم الشبكة"، "عمولة قانونية".
4. **الحلقة المفرغة** — إذا دفعت، يخترعون ذرائع جديدة لطلب مدفوعات أخرى. لن تُستعاد أي أموال أبدًا.

## الدعم الفني المزيف

نوع شائع جدًا هو انتحال شخصية فريق دعم لمحفظة أو منصة تداول معروفة. غالبًا ما يعمل هؤلاء الوكلاء المزيفون على X أو تليغرام أو ديسكورد. بمجرد أن تنشر سؤالًا علنيًا، يتصلون بك في الرسائل الخاصة بشعار الشركة الرسمي ونبرة احترافية.

هدفهم دائمًا نفسه: إقناعك بمشاركة عبارة الاسترداد أو النقر على رابط تصيد.

## علامات تكشف الاحتيال

- **معاملات الكريبتو لا رجعة فيها.** لا يمكن لأي شركة أو قرصان أو سلطة "إلغاء" معاملة مؤكدة.
- **لا يتصل بك الدعم أولًا أبدًا.** لا تتصل الفرق الشرعية بالمستخدمين تلقائيًا عبر رسائل مباشرة أو رسائل نصية أو هاتف.
- **عبارة الاسترداد محرمة.** لا يحتاجها أي دعم فني.
- **السلطات لا تطلب الكريبتو.** لن تتصل بك الشرطة أو الجهات التنظيمية تلقائيًا لإعادة الأموال.

## جدول الوعود المضللة

| الوعد المستلم | الهدف الحقيقي للمحتال | الرد الآمن |
|---|---|---|
| "لقد وجدنا محفظتك." | خلق أمل عاجل قبل طلب الرسوم. | لا تدفع؛ تحقق من خلال القنوات الرسمية. |
| "ادفع ضريبة فتح القفل." | دفعة أولى تليها دفعات أخرى. | اقطع الاتصال؛ احتفظ بالرسالة كدليل. |
| "قم بتثبيت هذا البرنامج لأتمكن من مساعدتك." | السيطرة على جهازك أو سرقة أسرارك. | ارفض أي وصول عن بُعد. |
| "أعطني كلماتك الـ 12/24 لإعادة المزامنة." | السيطرة النهائية على حساباتك. | لا تشارك أبدًا عبارة الاسترداد. |

## كيف تتصرف

1. **اقطع كل تواصل** مع المحتالين.
2. **أمّن ما تبقى** — انقل الأصول إلى محفظة جديدة على جهاز نظيف؛ ألغِ أي تفويضات مشبوهة.
3. **احتفظ بالأدلة** — روابط، لقطات، عناوين كريبتو، هاشات معاملات.
4. **بلّغ وقدّم شكوى** لدى السلطات المختصة.

## الشفافية قبل كل شيء

في Lumina Wallet، نبني أدوات لمنعك من إرسال أموال إلى المحتالين أو الموافقة على عقود خطيرة. تُحلّل ماسحاتنا العناوين والمعاملات قبل توقيعك.

ومع ذلك، نحن شفافون بشأن حدود التكنولوجيا: **إذا تم تأكيد معاملة احتيالية على البلوكتشين، فلا يمكن لـ Lumina إلغاؤها**. احذر ممن يدّعي عكس ذلك.

[تحميل من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [تحميل من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "qr-code-copier-coller-detournement-crypto": {
    title: "رموز QR والنسخ واللصق: عندما يكذب عليك عنوان الوجهة",
    meta: "برمجيات خبيثة للحافظة، رموز QR دفع مزيفة، ملصقات احتيالية: اكتشف كيف يحوّل المحتالون تحويلات الكريبتو الخاصة بك وكيف تحميك Lumina Wallet.",
    body: `## البادرة اليومية التي تكلف غاليًا

في عالم الكريبتو، العناوين هي سلاسل أبجدية رقمية طويلة ومعقدة. لا أحد يكتبها يدويًا. لتحويل الأموال، نعتمد جميعًا على بادرتين يوميتين: **النسخ واللصق** و**مسح رموز QR**.

يعرف المحتالون ذلك. بدلًا من محاولة كسر تشفير البلوكتشين، يستهدفون هاتين البادرتين لتحويل أموالك في اللحظة الدقيقة التي تبدأ فيها الدفع.

> **تعريف — تحويل الوجهة:** تلاعب يستبدل العنوان المستخدم فعليًا لدفع كريبتو أو يخفيه، بينما يعتقد المستخدم أنه لا يزال يرسل إلى المستلم الشرعي.

## اختطاف الحافظة (Clipboard Hijacking)

هجوم اختطاف الحافظة مخيف بسبب بساطته وسريته. يعتمد على برمجية خبيثة مثبتة دون علمك على جهازك.

1. تنسخ عنوان الكريبتو الشرعي للمستلم.
2. البرمجية الخبيثة، التي تراقب حافظتك باستمرار، تكتشف تنسيق العنوان.
3. في جزء من الثانية، تستبدل العنوان الشرعي بعنوان القرصان في ذاكرة جهازك.
4. عند اللصق في المحفظة، يظهر عنوان القرصان.

إذا صادقت على المعاملة دون إعادة القراءة بعناية، تُرسل أموالك إلى المحتال.

## فخاخ رموز QR

تُبسّط رموز QR المدفوعات المحمولة بشكل كبير، لكنها تُخفي المعلومات الفعلية. رمز QR ليس سوى تمثيل بصري للبيانات: يمكن أن يحتوي على عنوان كريبتو، طلب دفع، URI WalletConnect، أو رابط تصيد.

طرق الاحتيال الشائعة:

- **بوابة الدفع المزيفة** — يوجهك رمز QR إلى موقع يقلّد منصة شرعية تمامًا.
- **الانتحال عبر الهاتف (تنبيه FTC)** — يبقيك محتال ينتحل شخصية سلطة أو خدمة عملاء على الهاتف، ويقودك إلى ماكينة صراف كريبتو، ويطلب منك مسح رمز QR أرسله لك يحتوي على عنوان محفظته.
- **الملصق الاحتيالي** — في العالم المادي، يلصق المجرمون أحيانًا رمز QR الخاص بهم فوق رمز QR الشرعي لتاجر.

## جدول ملخص لناقلات الهجوم

| الناقل | ما يراه المستخدم | ما يحدث فعلًا | التحقق ذو الأولوية |
|---|---|---|---|
| حافظة مختطفة | عنوان نُسخ للتو من مصدر موثوق. | استبدلته البرمجية الخبيثة قبل اللصق. | قارن العنوان بعد اللصق بالمصدر الأصلي. |
| رمز QR دفع احتيالي | رمز يُقدَّم على أنه للمستفيد. | يحتوي على عنوان المحتال. | أكّد العنوان عبر قناة ثانية. |
| رمز QR تصيد | وصول سريع إلى خدمة. | يفتح نطاقًا مضللًا. | اقرأ النطاق والإجراء قبل المتابعة. |
| ملصق مغطى | رمز QR في مكان مادي. | الرمز الأصلي مُغطى. | افحص السطح واطلب التأكيد. |

## ردود الفعل لتأمين تحويلاتك

- **تحقّق دائمًا بعد اللصق**: قارن الأحرف الأولى والأخيرة بالمصدر الأصلي.
- **احذر من رموز QR غير المتوقعة** المستلمة عبر البريد الإلكتروني أو الرسائل النصية أو الشبكات الاجتماعية.
- **احمِ أجهزتك** بنظام تشغيل محدّث وبرنامج مكافحة فيروسات موثوق.
- **أرسل تحويلًا تجريبيًا** للعناوين الجديدة والمبالغ الكبيرة (رغم أن ذلك يضاعف رسوم الشبكة).
- **أعد قراءة شاشة التأكيد**: الشبكة والأصل والمبلغ والعنوان النهائي.

## نهج Lumina: التدقيق قبل الإرسال

الخطأ البشري لا مفر منه، لذا يجب أن تعمل المحفظة الحديثة كشبكة أمان. بدلًا من ماسح عالمي قد يعيد توجيهك إلى موقع خبيث، تفصل Lumina الاستخدامات. لا يقرأ ماسح شاشة الإرسال سوى عناوين الكريبتو. إذا اكتشف رابط ويب أو أمرًا مشبوهًا، يوقف الإجراء فورًا.

سواء كنت تلصق أو تمسح، لا تكتفي Lumina بقبول العنوان — بل تُجري **تدقيقًا أمنيًا فوريًا**:

- التحقق من صلاحية التنسيق.
- المقارنة في الوقت الفعلي مع قواعد التهديدات (مثل GoPlus Security).
- تنبيه واضح قبل تأكيدك للمعاملة.

تحتفظ بالسيطرة الكاملة، لكنك تحصل على المعلومات اللازمة لاكتشاف تحويل قبل فوات الأوان.

[تحميل من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [تحميل من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "how-to-secure-crypto-wallet": {
    title: "كيف تحمي محفظة العملات الرقمية في 2026: الدليل الشامل لمكافحة الاحتيال",
    meta: "تعرّف على كيفية حماية محفظة العملات الرقمية من خلال 10 قواعد أساسية يعتمدها خبراء الأمن. احمِ عبارة الاسترداد (Seed Phrase)، واكتشف المحافظ المزيفة، وامنع التوقيعات الخبيثة، وحافظ على أمان Bitcoin وEthereum وSolana وXRP في 2026.",
    body: `إذا كنت تملك عملات رقمية، فهناك سؤال واحد أهم من أي مخطط أسعار: **كيف تحمي محفظة العملات الرقمية** حتى لا يصل إليها المهاجم أبدًا. في 2026، سُرق أكثر من 3.8 مليار دولار من مستخدمي العملات الرقمية، وجاءت الغالبية العظمى منها من **هجمات على مستوى المحافظ** وليس من اختراقات المنصات [1]. هذا يعني أن الشخص الأكثر مسؤولية عن سلامتك هو أنت.

الخبر السار: حماية محفظة العملات الرقمية ليست معقدة. إنها سلسلة من العادات البسيطة والمقصودة. يقدم لك هذا الدليل الطريقة الدقيقة المكوّنة من 10 خطوات التي يستخدمها المستخدمون الواعون بالأمان لحماية Bitcoin وEthereum وSolana وXRP وأي أصل رقمي آخر، ويوضح لك كيف يقوم تطبيق مصمم لهذا الغرض مثل **Lumina Wallet** بالجزء الأكبر من العمل نيابةً عنك.

## لماذا يُعدّ سؤال «كيف أحمي محفظتي للعملات الرقمية» هو السؤال الخاطئ

تجيب معظم الأدلة عن سؤال *«ما هي أفضل محفظة؟»*. لكن السؤال الحقيقي هو: **كيف أحمي المحفظة التي أملكها بالفعل؟** لأن محفظتك في عالم العملات الرقمية لا تكون أقوى من أضعف عاداتك. فالمحفظة الصلبة لن تنقذك إذا أدخلت عبارة الاسترداد في موقع تصيّد. والمحفظة غير الحاضنة لن تحميك إذا وقّعت على عقد خبيث.

لذلك يركّز هذا الدليل على **العادات + الأدوات**، بحسب ترتيب أهميتها بالضبط.

## 10 قواعد لحماية محفظة العملات الرقمية

### 1. اختر محفظة غير حاضنة — بلا استثناءات

القاعدة الأولى في **كيفية حماية محفظة العملات الرقمية**: لا تسمح لأي طرف آخر بحيازة مفاتيحك أبدًا.

- ❌ **المحافظ الحاضنة** (معظم المنصات وبعض التطبيقات): المنصة هي من يحتفظ بمفاتيحك الخاصة. إذا تعرضت للاختراق أو جمّدت الحسابات أو أعلنت إفلاسها، تضيع عملاتك.
- ✅ **المحافظ غير الحاضنة** (مثل Lumina Wallet وMetaMask وTrust Wallet): أنت من تملك المفاتيح. لا شيء يقف بينك وبين أموالك.

الشعار الذي ينبغي أن تتذكره: **«ليست مفاتيحك، ليست عملاتك».**

### 2. احمِ عبارة الاسترداد كما تحمي مدخرات عمرك (لأنها كذلك فعلًا)

عبارة الاسترداد المكوّنة من 12 أو 24 كلمة هي المفتاح الرئيسي. أي شخص يحصل عليها يستطيع تفريغ محفظتك في 30 ثانية، من أي مكان في العالم.

**كيف تخزّنها بالطريقة الصحيحة:**

- 📝 **اكتبها على ورق** (أو انقشها على معدن). وليس رقميًا أبدًا.
- 🚫 **لا تلتقط لها صورة أبدًا**. ولا تخزّنها في iCloud أو Google Drive أو تطبيق الملاحظات أو أي مدير كلمات مرور متصل بالإنترنت.
- 🔒 **اصنع 2-3 نسخ مادية** واحفظها في أماكن آمنة مختلفة (خزنة منزلية، أحد أفراد العائلة الموثوقين، صندوق أمانات في بنك).
- 🗣️ **لا تشاركها مع أي أحد**. لا مع خدمة العملاء. ولا مع «مطوري المحفظة». ولا مع «موظفي مصلحة الضرائب». لن يطلبها منك أي طرف شرعي أبدًا.

> ⚠️ **القاعدة الذهبية**: إذا طلب منك شخص أو موقع أو تطبيق عبارة الاسترداد، فهو احتيال بنسبة 100%. بلا أي استثناء.

### 3. استخدم كلمة مرور قوية وفريدة للمحفظة

تقوم كلمة مرور المحفظة بتشفير مفاتيحك محليًا على جهازك. استخدم:

- **14 حرفًا** على الأقل
- مزيجًا من الأحرف الكبيرة والصغيرة والأرقام والرموز
- كلمة مرور **مختلفة عن أي كلمة مرور أخرى تستخدمها**
- مخزّنة في مدير كلمات مرور (Bitwarden أو 1Password أو KeePass)

### 4. فعّل المصادقة الحيوية + رمز PIN

تدعم محافظ العملات الرقمية الحديثة Face ID ومسح البصمة ورمز PIN من 6 أرقام. فعّل **الطبقات الثلاث جميعها**. حتى لو سرق أحدهم هاتفك، لن يتمكن من فتح محفظتك دون بياناتك الحيوية.

### 5. احذر من تطبيقات المحافظ المزيفة

ينشر المحتالون **تطبيقات منسوخة** على Google Play وApp Store بأسماء مثل *"Lumina Wallet Pro"* أو *"Lumina — Free Airdrop"* أو بشعارات مقلّدة. تبدو مطابقة للأصل لكنها تسرق عبارة الاسترداد لحظة إدخالها.

**كيف تتجنب المحافظ المزيفة:**
- ✅ نزّل التطبيق فقط من **الروابط الرسمية** في موقع المشروع (مثل https://luminawallet.org)
- ✅ تحقق من أن **اسم المطوّر** مطابق (بالنسبة إلى Lumina Wallet: *Lumina Wallet* من HEDONISME SARL)
- ✅ تحقق من عدد التنزيلات والمراجعات، فالنسخ المقلّدة عادةً لا تتجاوز 100 تنزيل
- ✅ اقرأ دليلنا الكامل عن [نسخ المحافظ المزيفة](/en/blog/fake-crypto-wallet-clones)

### 6. تحقق من عنوان المستلم قبل كل عملية إرسال

تنتشر هجمات تسميم العناوين (Address Poisoning) بسرعة: يرسل لك المحتالون معاملة صغيرة من عنوان **يشبه** أحد عناوينك المعتادة (نفس الأحرف الأربعة الأولى والأربعة الأخيرة، مع اختلاف الوسط). تنسخ العنوان من سجلك وتلصقه، فتُرسل أموالك مباشرةً إلى المهاجم.

**كيف تتجنب ذلك:**
- ✅ تحقق دائمًا من **العنوان كاملًا**، وليس بدايته ونهايته فقط
- ✅ استخدم محفظة تحتوي على **دفتر عناوين** لحفظ جهات الاتصال الموثوقة (Lumina لديها دفتر مدمج)
- ✅ قبل التحويلات الكبيرة، أرسل أولًا **معاملة تجريبية صغيرة**

### 7. لا توقّع أبدًا على معاملة لا تفهمها

أكثر عمليات الاحتيال تقنيةً في 2026 هي **التوقيع الخبيث**: تنقر على «توقيع» في ما يبدو أنه زر تسجيل دخول، لكنك في الحقيقة توافق على حد إنفاق غير محدود لعملات USDC/ETH لديك. ويقوم المهاجمون بتفريغ المحفظة في اليوم التالي.

**قائمة التحقق قبل التوقيع:**
- 🔍 اقرأ بيانات المعاملة: ما هي العملة؟ ما المبلغ؟ ما العقد؟
- 🚨 **«موافقة غير محدودة»** أو **«setApprovalForAll»** = علامة خطر
- 🚨 **طلب توقيع من موقع وصلت إليه للتو** = علامة خطر
- 🚨 المحفظة تقول *"قد تكون هذه المعاملة خطيرة"* = توقف فورًا

المحفظة التي تحتوي على **ماسح للمعاملات** (مثل Lumina Wallet) تكشف هذه الهجمات قبل أن توقّع.

### 8. حافظ على تحديث تطبيق المحفظة ونظام تشغيل هاتفك

يتضمن كل تحديث للمحفظة **تصحيحات أمنية** للثغرات المكتشفة حديثًا. وينطبق الأمر نفسه على نظام تشغيل هاتفك. التطبيق القديم هو سطح هجوم معروف.

- 📱 فعّل **التحديثات التلقائية** على Google Play وApp Store
- 🔐 حدّث نظام تشغيل هاتفك خلال أسبوع من صدور أي تحديث أمني

### 9. لا تربط محفظتك أبدًا بمواقع مجهولة

تطبيقات DApps قوية، لكن ربط محفظتك بموقع احتيالي قد يُفرغها بتوقيع واحد.

**القواعد:**
- اتصل فقط بـ**عناوين URL كتبتها بنفسك** أو التي جاءت من قنوات التواصل الاجتماعي الرسمية
- لا تتصل أبدًا عبر رابط في رسالة خاصة على Discord/Telegram
- بعد استخدام أي DApp، **ألغِ الأذونات** عبر [revoke.cash](https://revoke.cash)
- احفظ تطبيقات DApps الموثوقة في المفضلة حتى لا تبحث عنها في Google (إعلانات Google مليئة بالنسخ الاحتيالية)

### 10. استخدم محفظة تتضمن حماية مدمجة ضد الاحتيال

أنت إنسان. ستتعب. وستنقر بسرعة زائدة. لهذا يكون خط الدفاع الأخير هو محفظة **تكتشف الاحتيال نيابةً عنك** قبل أن ترتكب خطأً مكلفًا.

## كيف تحمي Lumina Wallet عملاتك الرقمية تلقائيًا

صُممت Lumina Wallet خصيصًا لإزالة أكبر نقطة ضعف في عالم العملات الرقمية: **الخطأ البشري تحت الضغط**. إليك كيف تحميك في كل خطوة:

| التهديد | كيف تتصدى له Lumina |
|---|---|
| **عنوان التصيّد** | يفحص الماسح الفوري كل مستلم مقابل قائمة سوداء حيّة تضم أكثر من 500,000 عنوان احتيالي معروف. ينبيه أحمر عند وجود تطابق. |
| **عقد ذكي خبيث** | قبل أن توقّع، تحاكي Lumina المعاملة وتعرض لك *بالضبط* أي العملات ستغادر محفظتك. وإذا رصدت موافقات غير محدودة أو أنماط تفريغ، تصلك رسالة تحذير حرجة. |
| **تسميم العناوين** | تضع Lumina تلقائيًا علامة على العناوين التي تشبه سجلك، حتى لو اختلفت بحرف واحد، قبل الإرسال. |
| **عمليات احتيال Permit / التوقيع المزيف** | يتم فك ترميز توقيعات ERC-20 Permit وPermit2 وشرحها بلغة واضحة. لا مزيد من التوقيع الأعمى. |
| **غير حاضنة بالتصميم** | مفاتيحك مشفّرة على جهازك باستخدام AES-256 + Secure Enclave. خوادم Lumina لا ترى مفاتيحك أبدًا. وكذلك لا تستطيع جهات إنفاذ القانون أو المخترقون أو الإفلاس الوصول إليها. |
| **المصادقة الحيوية + PIN + كلمة المرور** | قفل بثلاث طبقات، وكلها اختيارية حسب مستوى راحتك. |

## ماذا عن المحافظ الصلبة؟

تضيف المحافظ الصلبة (Ledger وTrezor) طبقة إضافية قوية لـ**الحيازات طويلة الأجل** (أكثر من 10 آلاف دولار لا تلمسها أسبوعيًا). لكنها لا تحل محل القواعد العشر أعلاه، بل تضاف إليها. حتى مع Ledger، فإن توقيعًا خبيثًا توافق عليه سيُفرغ أموالك.

أما للاستخدام اليومي (المبادلات والتحويلات وDeFi)، فإن **المحفظة المحمولة الآمنة مع ماسح للمعاملات** غالبًا ما تكون *أكثر أمانًا* من محفظة صلبة بمفردها، لأنها تكتشف هجمات الخطأ البشري التي لا تستطيع المحافظ الصلبة منعها.

## أخطاء شائعة تُفسد أمان المحفظة

حتى المستخدمون الذين يعرفون القواعد يرتكبون هذه الأخطاء. تجنبها:

- ❌ **التقاط لقطة شاشة لعبارة الاسترداد** «للنسخ الاحتياطي فقط»، إذ يقوم iCloud/Google Photos بمزامنتها إلى السحابة
- ❌ **استخدام نفس كلمة المرور** للمحفظة وللبريد الإلكتروني
- ❌ **النقر على إعلانات Google** لتطبيقات المحافظ أو DApps (الإعلانات الاحتيالية شائعة)
- ❌ **تخزين العملات الرقمية على المنصات** على المدى الطويل «لأن ذلك أسهل»
- ❌ **تجاهل التحذيرات الأمنية** لأنك مستعجل
- ❌ **تجربة «airdrops» من غرباء** عبر ربط محفظتك الرئيسية

## قائمة تحقق سريعة للأمان (احفظها)

قبل أن تستثمر يورو آخر في العملات الرقمية، تأكد من أنك أنجزت الخطوات العشر جميعها:

- [ ] أستخدم محفظة غير حاضنة (أنا أملك مفاتيحي)
- [ ] عبارة الاسترداد مكتوبة على ورق، في موقعين ماديين أو أكثر
- [ ] عبارة الاسترداد لم تلمس الإنترنت قط
- [ ] كلمة مرور محفظتي مكوّنة من 14 حرفًا أو أكثر وفريدة
- [ ] المصادقة الحيوية + PIN مفعّلان
- [ ] نزّلت محفظتي من الموقع الرسمي فقط
- [ ] أتحقق دائمًا من عناوين المستلمين كاملة
- [ ] لا أوقّع أبدًا على معاملات لا أفهمها
- [ ] محفظتي ونظام تشغيل هاتفي محدّثان
- [ ] أتصل فقط بتطبيقات DApps التي أثق بها صراحةً

## الخلاصة: الأمان عادة، وليس إعدادًا لمرة واحدة

لا يمكنك إسناد أمان محفظتك إلى طرف آخر. لكن يمكنك جعله أسهل بعشر مرات عبر الجمع بين **العادات الجيدة** و**الأدوات التي تحميك عندما تخطئ**. وهذا بالضبط ما تفعله Lumina Wallet: محفظة غير حاضنة متعددة السلاسل مع ماسح مدمج لمكافحة الاحتيال، والتحقق من العناوين، ومحاكاة المعاملات.

يتم فحص كل معاملة. ويتم فك ترميز كل توقيع. ويتم شرح كل خطر بلغة واضحة، قبل أن تلتزم.

**هل أنت مستعد لحماية محفظة عملاتك الرقمية بالطريقة الصحيحة؟**

[نزّل Lumina Wallet من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [نزّله من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)

---

### المراجع

[1] Chainalysis. (2026). *2026 Crypto Crime Report: Wallet-level attacks*. [https://www.chainalysis.com/blog/crypto-scams-2026/](https://www.chainalysis.com/blog/crypto-scams-2026/)`
  },
  "what-is-non-custodial-wallet": {
    title: "ما هي المحفظة غير الحافظة (Non-Custodial)؟ الدليل الشامل للمبتدئين (2026)",
    meta: "تتيح لك المحفظة غير الحافظة امتلاك مفاتيح عملاتك الرقمية — دون بنك ولا منصة تداول ولا وسيط. تعرّف على معنى «غير حافظة» وكيف تختلف عن المحافظ الحافظة، واطّلع على أمثلة حقيقية مثل Lumina Wallet وMetaMask وTrust Wallet.",
    body: `**المحفظة غير الحافظة (non-custodial wallet)** هي محفظة عملات رقمية **تحتفظ فيها أنت — وأنت وحدك — بالمفاتيح الخاصة** التي تتحكم في أموالك. لا يمكن لأي بنك أو منصة تداول أو طرف ثالث الوصول إلى عملاتك الرقمية أو تجميدها أو فقدانها. إذا كنت جديدًا في عالم العملات الرقمية، فهذا هو المفهوم الأهم الذي ينبغي أن تفهمه. يشرح هذا الدليل ما هي المحفظة غير الحافظة، وكيف تعمل، وأمثلة واقعية عليها، وهل هي الخيار المناسب لك.

## معنى المحفظة غير الحافظة: التعريف في 30 ثانية

**تعريف المحفظة غير الحافظة**: هي محفظة عملات رقمية يحتفظ فيها المستخدم بالملكية الكاملة لمفاتيحه الخاصة. لا يملك أي طرف ثالث حق حيازة الأموال أو الوصاية عليها. المستخدم هو الحافظ الوحيد.

بعبارة بسيطة: **إذا كنت لا تستطيع أن تفقد وصولك إلى أموالك لمجرد أن شركة قررت تجميد حسابك، فأنت تملك محفظة غير حافظة.**

### المحفظة الحافظة مقابل غير الحافظة: مقارنة سريعة

| الميزة | المحفظة الحافظة | المحفظة غير الحافظة |
|---|---|---|
| **من يملك مفاتيحك؟** | المنصة/الشركة | أنت |
| **هل يمكن تجميد الحسابات؟** | نعم، من قبل الشركة | لا — لا أحد يستطيع تجميدها |
| **ماذا لو أفلست الشركة؟** | قد تضيع الأموال أو تُحجز | أموالك آمنة 100% |
| **هل تحتاج إلى تذكّر عبارة الاسترداد (seed phrase)؟** | لا (هم يحتفظون بها) | نعم (أنت تحتفظ بها) |
| **خطر المصادرة الحكومية؟** | نعم (عبر أمر قضائي) | فقط إذا أُجبرت على تسليم المفاتيح |
| **أمثلة** | Coinbase وBinance وKraken (محفظتها الافتراضية) | Lumina Wallet وMetaMask وLedger وTrust Wallet |

## كيف تعمل المحفظة غير الحافظة؟

عند إعداد محفظة غير حافظة، تحدث ثلاثة أشياء محليًا على جهازك:

1. **يتم توليد مفتاح خاص** — رقم عشوائي ضخم يتحكم رياضيًا في عناوين عملاتك الرقمية.
2. **يتم إنشاء عبارة استرداد (seed phrase)** — 12 أو 24 كلمة مقروءة يمكنها إعادة توليد المفتاح الخاص. وهي نسختك الاحتياطية الوحيدة.
3. **يتم اشتقاق عنوان عام** — «عنوان الاستلام» الذي تشاركه مع الآخرين.

**لا يغادر المفتاح الخاص جهازك أبدًا**. عندما ترسل عملات رقمية، توقّع محفظتك المعاملة محليًا، ثم تبث التوقيع فقط إلى البلوكتشين. لا يرى أي خادم مفتاحك. ولهذا تُسمّى *غير حافظة*: لا يوجد حافظ خارجي على الإطلاق.

## مثال على محفظة غير حافظة: معاملة حقيقية

إليك ما يحدث عند إرسال 0.1 ETH من محفظة غير حافظة مثل Lumina:

1. تُدخل عنوان المستلم والمبلغ
2. تقوم محفظتك **بتجهيز** بيانات المعاملة (المرسِل، المستلِم، المبلغ، رسوم الغاز)
3. تقوم محفظتك **بتوقيع** المعاملة باستخدام مفتاحك الخاص — وهذا يحدث 100% على هاتفك
4. يتم إرسال **المعاملة الموقّعة** (وليس المفتاح) إلى شبكة Ethereum
5. يتحقق المعدّنون/المدقّقون (validators) من أن التوقيع صالح رياضيًا
6. يتم تأكيد المعاملة على السلسلة (on-chain)

لا تملك أي شركة، في أي مرحلة، القدرة على عكس هذا التحويل أو حظره أو تجميده. هذه هي الحرية — والمسؤولية — في المحافظ غير الحافظة.

## لماذا تختار محفظة عملات رقمية غير حافظة؟

### 1. أنت البنك

السبب الأول: **الملكية الحقيقية**. في عام 2022، انهارت FTX وأصبحت مليارات الدولارات من أموال المستخدمين غير قابلة للوصول بين عشية وضحاها. أما المستخدمون الذين يملكون محافظ غير حافظة فلم يتأثروا إطلاقًا. وتكرر الأمر في 2023 مع Celsius وVoyager وBlockFi.

> **«ليست مفاتيحك، ليست عملاتك.»** — هذا الشعار القصير أنقذ الملايين من خسائر العملات الرقمية.

### 2. خصوصية كاملة

تتطلب منصة التداول الحافظة إجراءات KYC (التحقق من الهوية)، وتتتبع كل معاملة، وتبلّغ السلطات الضريبية والجهات التنظيمية. أما المحفظة غير الحافظة فتحتاج فقط إلى عبارة الاسترداد — دون بريد إلكتروني ولا هوية ولا تسجيل. يمكنك إنشاء واحدة في 30 ثانية.

### 3. لا حدود للسحب ولا حسابات مجمّدة

تجمّد المنصات الحافظة الحسابات بسبب «نشاط مشبوه» أو مراجعات تنظيمية أو فترات صيانة — أحيانًا لأسابيع. أما المحافظ غير الحافظة فلا تعاني من هذه العوائق: أموالك متاحة دائمًا، على مدار الساعة، من أي مكان فيه إنترنت.

### 4. الوصول إلى DeFi وWeb3

يتطلب كل بروتوكول DeFi تقريبًا (Uniswap وAave وLido) وكل سوق NFT (OpenSea وMagic Eden) وكل تطبيق Web3 محفظة غير حافظة للاتصال به. فالمحافظ الحافظة لا تستطيع المشاركة في التطبيقات على السلسلة.

## ماذا يتضمن تطوير المحافظ غير الحافظة؟

للمطورين المهتمين بـ**تطوير المحافظ غير الحافظة**، إليكم المكدّس التقني:

- 🔐 **توليد المفاتيح**: BIP-32 (المفاتيح الهرمية الحتمية) + BIP-39 (عبارات الاسترداد النمطية) + BIP-44 (اشتقاق الحسابات المتعددة)
- 🔗 **دعم سلاسل متعددة**: مزوّدو RPC أو عقد مستضافة ذاتيًا لكل بلوكتشين (Bitcoin وEthereum وSolana وXRP وغيرها)
- 💾 **تخزين محلي آمن**: iOS Secure Enclave / Android Keystore لتشفير المفاتيح
- ✍️ **توقيع المعاملات**: ECDSA لـ Bitcoin/Ethereum، وEd25519 لـ Solana، وكله يتم من جهة العميل
- 🛡️ **طبقات الأمان**: فحص الاحتيال، ودفتر العناوين، ومحاكاة المعاملات

Lumina Wallet هي **محفظة جوال غير حافظة** مبنية بكل ما سبق، إضافة إلى **ماسح مدمج لكشف الاحتيال** — لأن الملكية دون حماية فخ للمبتدئين.

## المقايضة الوحيدة: أنت المسؤول

المحفظة غير الحافظة تعني أنك تملك مفاتيحك — لكنها تعني أيضًا أنك **مسؤول بنسبة 100% عن سلامتها**.

- 🔴 **فقدان عبارة الاسترداد = فقدان عملاتك الرقمية**. لا يوجد زر «نسيت كلمة المرور». ولا يستطيع أي دعم عملاء مساعدتك.
- 🔴 **الوقوع ضحية تصيّد = فقدان عملاتك الرقمية**. لا أحد يستطيع عكس معاملة موقّعة.
- 🔴 **توقيع عقد خبيث = فقدان عملاتك الرقمية**. المسؤولية بالكامل عليك.

ولهذا تضيف المحافظ غير الحافظة الحديثة مثل Lumina طبقات من الحماية:
- ✅ ماسح احتيال فوري يحظر عناوين التصيّد المعروفة
- ✅ محاكاة المعاملة قبل التوقيع
- ✅ تنبيهات واضحة لتوقيعات "Permit" أو "Approve" المشبوهة
- ✅ دفتر عناوين لمنع الأخطاء الإملائية وهجمات النسخ واللصق

## أمثلة على المحافظ غير الحافظة في 2026

أفضل محافظ العملات الرقمية غير الحافظة اليوم، بناءً على الأمان وسهولة الاستخدام ودعم السلاسل المتعددة:

| المحفظة | النوع | السلاسل | الأنسب لـ |
|---|---|---|---|
| **Lumina Wallet** | جوال | أكثر من 10 (BTC وETH وSOL وXRP وBNB وPOL...) | الاستخدام اليومي + الحماية من الاحتيال |
| **MetaMask** | متصفح + جوال | سلاسل EVM وSolana وBitcoin | مستخدمو DeFi المحترفون |
| **Trust Wallet** | جوال | أكثر من 70 | مستخدمو السلاسل المتعددة العاديون |
| **Ledger** | عتادية (Hardware) | أكثر من 100 | التخزين البارد طويل الأمد |
| **Rabby** | متصفح | منظومة Ethereum | DeFi المتقدم مع محاكاة المعاملات |

## محفظة الجوال غير الحافظة: هل هي آمنة؟

نعم — إذا اتبعت ممارسات الأمان الأساسية. فمحفظة الجوال غير الحافظة غالبًا ما تكون **أكثر أمانًا من منصة التداول** للأسباب التالية:

- مفاتيحك مشفّرة بوحدة الأمان العتادية في هاتفك
- تحصل على مصادقة بيومترية + رمز PIN
- المحافظ الحديثة (مثل Lumina) تفحص كل معاملة بحثًا عن الاحتيال
- لا يوجد «هدف» واحد للمخترقين — 100 مليون محفظة = 100 مليون هدف منفصل

بالنسبة للمبالغ التي تقل عن 10,000 € والتي تستخدمها بانتظام، تحقق محفظة الجوال غير الحافظة جيدة التصميم أفضل توازن بين الأمان وسهولة الاستخدام.

## كيف تبدأ بمحفظتك الأولى غير الحافظة

1. **نزّل التطبيق** من الموقع الرسمي (وليس من البحث في متجر التطبيقات — فالنسخ المقلَّدة موجودة)
2. **أنشئ محفظة جديدة** — يولّد التطبيق مفاتيحك محليًا
3. **دوّن عبارة الاسترداد المكونة من 12 كلمة** على ورقة، في مكان آمن
4. **عيّن كلمة مرور قوية** وفعّل القياسات الحيوية
5. **أرسل مبلغًا تجريبيًا صغيرًا** أولًا للتحقق من أن كل شيء يعمل
6. **اقرأ [دليل أمان المحفظة في 10 خطوات](/en/blog/how-to-secure-crypto-wallet)** قبل تخزين مبالغ كبيرة

## الأسئلة الشائعة حول المحفظة غير الحافظة

### هل المحفظة غير الحافظة هي نفسها المحفظة الساخنة؟

ليس تمامًا. *المحفظة الساخنة* تعني «متصلة بالإنترنت». أما *غير الحافظة* فتعني «المستخدم يملك المفاتيح». يمكن أن تكون المحفظة ساخنة وغير حافظة في آن واحد (Lumina وMetaMask) — أو غير حافظة وباردة (Ledger وTrezor).

### ماذا يحدث إذا فقدت هاتفي؟

لا شيء سيئ — طالما لديك عبارة الاسترداد. ثبّت المحفظة على هاتف جديد، واستورد عبارة الاسترداد، وستعود أموالك فورًا.

### هل يمكنني تحويل محفظتي الحافظة إلى غير حافظة؟

لا يمكنك «تحويلها» — لكن يمكنك سحب أموالك من منصة تداول حافظة إلى محفظة جديدة غير حافظة أنشأتها. هذا هو المسار الموصى به لأي شخص يحتفظ بعملات رقمية ذات قيمة كبيرة.

### هل تدفع المحافظ غير الحافظة الضرائب؟

لا تبلّغ المحافظ غير الحافظة السلطات الضريبية تلقائيًا — لكن *أنت* ما زلت مدينًا بالضرائب على أرباحك. استخدم أدوات مثل Koinly أو CoinTracker لحساب ضرائبك من سجل معاملات محفظتك.

## الخلاصة: امتلك عملاتك الرقمية فعلًا

إذا كنت جادًا في التعامل مع العملات الرقمية، فالمحفظة غير الحافظة ليست خيارًا إضافيًا — بل هي الأساس. كل عام، يخسر المستخدمون ثروات بسبب إفلاس المنصات أو تجميد الحسابات أو اختراقات المنصات. ولا شيء من ذلك يمكنه المساس بمحفظة غير حافظة مؤمَّنة جيدًا.

**Lumina Wallet هي محفظة متعددة السلاسل وغير حافظة** مزوّدة بماسح احتيال مدمج، ودفتر عناوين، ومحاكاة للمعاملات، ودعم لأكثر من 10 بلوكتشين — صُنعت لمن يريدون الملكية *مع* الحماية.

[حمّل Lumina Wallet من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [حمّل من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "lumina-wallet-vs-lumina-token": {
    title: "Lumina Wallet مقابل Lumina Coin وLumina Pay وLumina Chain: لا تخلط بين المشاريع",
    meta: "هل تخلط بين Lumina Wallet ومشاريع كريبتو أخرى تحمل اسم \"Lumina\" (مثل Lumina Coin وLumina Pay وLumina Chain وLumina Crest AI)؟ إليك الفروقات الواضحة حتى لا تقع في فخ تشابه الأسماء.",
    body: `هل بحثت في Google عن "Lumina crypto" فوجدت عدة مشاريع مختلفة تستخدم اسم "Lumina"؟ هذا أمر طبيعي، وهو بالضبط الالتباس الذي نريد توضيحه. **لا تربط Lumina Wallet أي صلة بمشاريع "Lumina Coin" أو "Lumina Pay" أو "Lumina Chain Base" أو "Lumina Crest AI"** التي قد تصادفها على الإنترنت. إليك كيف تميّز بينها بوضوح.

## من هي Lumina Wallet حقًا؟

**Lumina Wallet** هو تطبيق محفظة عملات رقمية للهواتف المحمولة **غير حاضنة (non-custodial)**، تنشره شركة **HEDONISME SARL** (شركة فرنسية مسجّلة في RCS Dunkerque تحت الرقم 901 439 505).

### مميزاتنا الفريدة:
- 📱 **تطبيق للجوال** متوفر على [Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) و[App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)
- 🔐 **غير حاضنة**: أنت وحدك من يملك مفاتيحك الخاصة
- 🌐 **متعددة الشبكات**: Bitcoin وEthereum وSolana وXRP وBNB وPolygon وأكثر من 5 بلوكتشينات أخرى
- 🛡️ **ماسح مدمج لكشف الاحتيال**: وهذا هو أبرز ما يميّزنا
- 🇫🇷 **شركة فرنسية** يمكن التحقق منها في السجل التجاري RCS
- 🌍 **موقع رسمي واحد فقط**: [luminawallet.org](https://luminawallet.org)

### ما الذي لا تمثّله Lumina Wallet:
- ❌ **ليست رمزًا / عملة رقمية** — ليس لدينا رمز أصلي خاص بنا
- ❌ **ليست بلوكتشين من الطبقة الأولى أو الثانية** — نحن نتصل بشبكات بلوكتشين قائمة
- ❌ **ليست منصة استثمار آلي** — لا نقدّم "عوائد مضمونة"
- ❌ **ليست خدمة مدفوعات للشركات (B2B)** — نحن محفظة موجهة للمستهلكين
- ❌ **ليست مشروع ذكاء اصطناعي** — نحن تطبيق لأمان العملات الرقمية

## مشاريع "Lumina" الأخرى (لا علاقة لنا بها)

إليك أبرز مشاريع الكريبتو التي تحمل كلمة "Lumina" في اسمها والتي قد تصادفها:

### 1. Lumina Coin / Lumina Token

توجد عدة رموز ERC-20 باسم "Lumina" أو "LUMI" على شبكات بلوكتشين مختلفة. هذه **عملات رقمية مضاربية** أصدرتها مشاريع تابعة لجهات خارجية.

⚠️ **تحذير**: بعض هذه الرموز تعرّضت لعمليات "rug pull" (عمليات احتيال يختفي فيها الفريق ومعه السيولة). تحقق دائمًا من الفريق والعقد الذكي والسيولة **قبل الاستثمار**.

**الصلة بـ Lumina Wallet: لا توجد أي صلة.** نحن لا نصدر أي رمز.

### 2. Lumina Pay

تستخدم بعض المنصات اسم "Lumina Pay" لخدمات الدفع بالعملات الرقمية أو الخدمات المصرفية الرقمية (neobanking). مرة أخرى، **لا علاقة لها بـ Lumina Wallet**.

### 3. Lumina Chain / Lumina Base

هناك مشاريع تقدّم نفسها على أنها بلوكتشين من الطبقة الأولى أو rollups باسم "Lumina Chain" أو "Lumina Base". **لا صلة** لها بمحفظتنا — نحن لا نطوّر بلوكتشين.

### 4. Lumina Crest AI

⚠️ **تحذير خاص بهذا المشروع.** تنتشر تقارير متعددة عن Lumina Crest AI تتعلق بممارسات مشبوهة (عوائد مضمونة، سحوبات مقفلة). ابحث في Google عن "Lumina Crest AI review" قبل التعامل مع هذا المشروع.

**لا علاقة لـ Lumina Wallet إطلاقًا بـ Lumina Crest AI.**

## كيف تتحقق من أنك تستخدم Lumina Wallet الحقيقية

للتأكد من أنك تستخدم تطبيقنا الأصلي وليس نسخة مقلّدة:

### ✅ فحوصات يجب إجراؤها:

1. **الموقع الرسمي الوحيد**: [https://luminawallet.org](https://luminawallet.org)
   - لا يوجد أي نطاق آخر يمثّل Lumina Wallet
2. **Google Play**: اسم المطوّر = *Lumina Wallet*، والحزمة = \`com.luminawallet.app\`
3. **App Store**: معرّف التطبيق = \`id6760651380\`، والناشر = *Lumina Wallet*
4. **حساب Twitter/X الرسمي**: [@getluminawallet](https://x.com/getluminawallet)
5. **جميع حساباتنا على وسائل التواصل الاجتماعي** مدرجة في [صفحة من نحن](/en/about)

### 🚨 علامات التحذير (احتيال):

- موقع يطلب منك عبارة الاسترداد (seed phrase) من أجل "ربط" محفظتك
- "airdrop لـ Lumina" يتطلب دفع "رسوم gas" مسبقًا
- "دعم Lumina" يتواصل معك عبر رسائل Telegram أو Discord الخاصة
- مشروع يعد بعوائد مقابل "Lumina Token"
- موقع يشبه موقعنا لكن بعنوان URL مختلف (مثل \`lumina-wallet.org\` بشرطة، أو \`luminawallet.com\`، أو \`luminawallets.org\`)

## لماذا يوجد هذا الالتباس

اسم "Lumina" (من الكلمة اللاتينية *lumen* وتعني الضوء) شائع في عالم الكريبتو لأنه يوحي بالوضوح والشفافية. ونتيجة لذلك، تبنّت **عدة فرق مستقلة** هذا الاسم دون أي تنسيق بينها.

في **Lumina Wallet**، اخترنا هذا الاسم ليعبّر عن مهمتنا: **جعل أمان العملات الرقمية واضحًا ومنيرًا**، من خلال ماسح للاحتيال يكشف المخاطر الخفية قبل كل معاملة.

## الخلاصة

إذا كنت تبحث عن رمز "Lumina Coin" أو "Lumina Pay" أو أي عملة رقمية/منصة أخرى تحمل هذا الاسم: **فهذا ليس نحن، ولا تربطنا بها أي علاقة**. قم ببحثك الخاص (DYOR) حول هذه المشاريع التابعة لجهات خارجية.

أما إذا كنت تبحث عن **محفظة عملات رقمية للجوال غير حاضنة ومتعددة الشبكات مع حماية مدمجة من الاحتيال**، تنشرها **شركة فرنسية شفافة ومسجّلة** — فأنت في المكان الصحيح.

**اكتشف Lumina Wallet، الأصلية والوحيدة:**

[حمّل من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [حمّل من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "best-non-custodial-crypto-wallet-2026": {
    title: "أفضل محفظة عملات رقمية غير حضانية في 2026: المقارنة الشاملة",
    meta: "قارن بين أفضل محافظ العملات الرقمية غير الحضانية لعام 2026: Lumina Wallet وMetaMask وTrust Wallet وRabby وRainbow وCoinbase Wallet وLedger. مقارنة جنبًا إلى جنب من حيث الميزات والأمان ودعم السلاسل المتعددة والحماية من الاحتيال.",
    body: `أصبح اختيار **أفضل محفظة عملات رقمية غير حضانية** في 2026 أصعب من أي وقت مضى. هناك عشرات الخيارات — للهاتف والمتصفح والأجهزة المادية — وكل منها يدّعي أنه الأكثر أمانًا أو الأسهل أو الأغنى بالميزات. يختصر لك هذا الدليل الضجيج عبر **مقارنة جنبًا إلى جنب** بين 7 من أشهر المحافظ غير الحضانية، استنادًا إلى الميزات الفعلية والأمان الحقيقي وتجربة المستخدم الواقعية.

## ما هي المحفظة غير الحضانية؟ (مراجعة سريعة في 30 ثانية)

[المحفظة غير الحضانية](/en/blog/what-is-non-custodial-wallet) هي محفظة عملات رقمية تتحكم فيها **أنت** — وأنت وحدك — بالمفاتيح الخاصة. لا يستطيع أي منصة تداول أو بنك أو طرف ثالث تجميد أموالك أو الاستيلاء عليها أو فقدانها. والمقابل: أنت مسؤول بنسبة 100% عن عبارة الاسترداد (seed phrase) الخاصة بك.

تأتي المحافظ غير الحضانية في ثلاثة أنواع:
- **الهاتف المحمول** (Lumina وTrust Wallet وRainbow) — الأفضل للاستخدام اليومي
- **إضافة المتصفح** (MetaMask وRabby) — الأفضل لمستخدمي DeFi المحترفين
- **المحافظ المادية** (Ledger وTrezor) — الأفضل للتخزين البارد طويل الأمد

## أفضل 7 محافظ غير حضانية في 2026 — مقارنة جنبًا إلى جنب

| المحفظة | النوع | السلاسل | ماسح الاحتيال | مرشّح الرموز المزيفة | الأفضل لـ |
|---|---|---|---|---|---|
| **Lumina Wallet** | هاتف محمول | 10+ (BTC, ETH, SOL, XRP, BNB, POL...) | ✅ مدمج، في الوقت الفعلي | ✅ قائمة بيضاء حسب العقد | المستخدمون اليوميون الذين يريدون **الأمان دون تعقيد** |
| **MetaMask** | متصفح + هاتف | سلاسل EVM وSolana وBitcoin | ⚠️ تحذيرات أساسية | ❌ يعرض جميع الرموز | مستخدمو DeFi المحترفون |
| **Trust Wallet** | هاتف محمول | 70+ | ⚠️ ماسح من طرف ثالث | ❌ يعرض جميع الرموز | المستخدمون العاديون متعددو السلاسل |
| **Rabby** | متصفح | منظومة Ethereum | ✅ محاكاة المعاملات | ❌ يعرض جميع الرموز | DeFi المتقدم مع معاينة المعاملة |
| **Rainbow** | هاتف محمول | منظومة Ethereum | ⚠️ تحذيرات أساسية | ❌ يعرض جميع الرموز | مستخدمو Ethereum فقط، تجربة استخدام رائعة |
| **Coinbase Wallet** | هاتف + متصفح | 20+ | ⚠️ تحذيرات أساسية | ❌ يعرض جميع الرموز | مستخدمو منصة Coinbase |
| **Ledger (مع Ledger Live)** | جهاز مادي | 100+ | ❌ لا يوجد ماسح | ❌ يعرض جميع الرموز | التخزين البارد طويل الأمد (>10k€) |

## نظرة معمّقة: كل محفظة بالتفصيل

### 🥇 Lumina Wallet — الأفضل للمستخدمين اليوميين المهتمين بالأمان

**أبرز المزايا:**
- ✅ غير حضانية، والمفاتيح مشفّرة باستخدام iOS Secure Enclave / Android Keystore
- ✅ **ماسح احتيال ثلاثي الطبقات** (قارئ QR، تدقيق العناوين، فك ترميز المعاملات)
- ✅ **مرشّح الرموز المزيفة** — لا تظهر في محفظتك سوى العقود الرسمية
- ✅ دعم متعدد السلاسل: Bitcoin وEthereum وSolana وXRP وBNB Chain وPolygon وArbitrum وOptimism وBase وAvalanche
- ✅ توقيعات ERC-20 Permit وPermit2 مفكوكة الترميز بلغة إنجليزية واضحة
- ✅ دفتر عناوين لتجنّب الأخطاء الإملائية وهجمات النسخ واللصق
- ✅ معلومات التهديدات من GoPlus Security في الوقت الفعلي
- ✅ **شركة فرنسية** (HEDONISME SARL، RCS Dunkerque) — ملكية شفافة

**نقاط الضعف:**
- ليست مفتوحة المصدر بعد (مخطط لذلك)
- للهاتف المحمول فقط حاليًا (لا توجد إضافة متصفح)

**مثالية لـ:** كل من يريد **أقصى درجات الأمان دون أن يصبح خبيرًا في العملات الرقمية**. خصوصًا المبتدئين والمستخدمين متوسطي الخبرة.

**الحكم:** ⭐⭐⭐⭐⭐

### 🥈 MetaMask — خيار محترفي DeFi

**أبرز المزايا:**
- ✅ المحفظة الأكثر دعمًا عبر تطبيقات Web3
- ✅ متوفرة كإضافة متصفح وكتطبيق للهاتف
- ✅ منظومة Snaps للتوسعة
- ✅ مفتوحة المصدر

**نقاط الضعف:**
- ⚠️ تعرض جميع الرموز افتراضيًا ← فتلوّث الرموز المزيفة محفظتك
- ⚠️ تحذيرات التوقيع أساسية ويسهل تجاهلها
- ⚠️ واجهت Consensys (الشركة الأم) انتقادات بشأن جمع البيانات

**مثالية لـ:** مستخدمي DeFi المتقدمين الذين يعرفون ما يفعلون.

**الحكم:** ⭐⭐⭐⭐

### 🥉 Trust Wallet — الأوسع دعمًا للسلاسل

**أبرز المزايا:**
- ✅ تدعم أكثر من 70 بلوكتشين (الأوسع في فئتها)
- ✅ مجمّع DEX مدمج
- ✅ مملوكة لـ Binance (فريق كبير وتمويل جيد)

**نقاط الضعف:**
- ⚠️ حماية أساسية من الاحتيال (تفاعلية في معظمها، لا استباقية)
- ⚠️ تعرض جميع الرموز ← خطر رسائل الرموز المزيفة المزعجة
- ⚠️ حوادث سابقة (ثغرة WalletConnect في 2023، وإفصاح عن ضعف في MPC)

**مثالية لـ:** المستخدمين النشطين على سلاسل غير شائعة.

**الحكم:** ⭐⭐⭐

### Rabby — أفضل معاينة للمعاملات في فئتها

**أبرز المزايا:**
- ✅ تحاكي كل معاملة قبل التوقيع (وتعرض التغيّر الدقيق في الرصيد)
- ✅ مفتوحة المصدر
- ✅ التبديل بين السلاسل دون إضافة الشبكات يدويًا

**نقاط الضعف:**
- ⚠️ للمتصفح فقط (لا يوجد تطبيق للهاتف)
- ⚠️ منظومة Ethereum فقط
- ⚠️ منحنى تعلّم أكثر حدّة

**مثالية لـ:** مستخدمي DeFi المتقدمين الذين يريدون رؤية الأثر قبل التوقيع.

**الحكم:** ⭐⭐⭐⭐

### Rainbow — أفضل تجربة استخدام (لكن لـ Ethereum فقط)

**أبرز المزايا:**
- ✅ واجهة جميلة وبديهية
- ✅ تهيئة ممتازة للمبتدئين
- ✅ مفتوحة المصدر

**نقاط الضعف:**
- ⚠️ منظومة Ethereum فقط
- ⚠️ ميزات محدودة لمكافحة الاحتيال
- ⚠️ مشكلة رسائل الرموز المزيفة المزعجة

**مثالية لـ:** المستخدمين العاديين على Ethereum فقط ممن يقدّرون الجماليات.

**الحكم:** ⭐⭐⭐

### Coinbase Wallet — جسر المنصة

**أبرز المزايا:**
- ✅ تكامل سلس مع منصة Coinbase
- ✅ دعم متعدد السلاسل
- ✅ علامة تجارية موثوقة

**نقاط الضعف:**
- ⚠️ ميزات أساسية لمكافحة الاحتيال
- ⚠️ مخاوف بشأن جمع البيانات (الالتزام بالتنظيمات الأمريكية)
- ⚠️ تعرض جميع الرموز

**مثالية لـ:** مستخدمي منصة Coinbase المنتقلين إلى الحفظ الذاتي.

**الحكم:** ⭐⭐⭐

### Ledger + Ledger Live — الأفضل للتخزين طويل الأمد

**أبرز المزايا:**
- ✅ عزل مادي — المفاتيح لا تلامس الإنترنت أبدًا
- ✅ تدعم أكثر من 100 سلسلة
- ✅ أفضل حل للمبالغ الكبيرة (>10 000 €)

**نقاط الضعف:**
- ⚠️ يكلّف الجهاز من 79 € إلى 249 €
- ⚠️ جهاز مادي يجب حمله وقد يضيع
- ⚠️ اختراق بيانات في 2020 (تسريب رسائل البريد الإلكتروني للعملاء)
- ⚠️ لا يوجد ماسح احتيال — ما زلت عرضة للتوقيعات الخبيثة

**مثالي لـ:** أصحاب المبالغ الكبيرة كخزنة ادخار.

**الحكم:** ⭐⭐⭐⭐ (للمقتنيات طويلة الأمد فقط)

## أي محفظة غير حضانية تناسبك أنت؟

اسأل نفسك هذه الأسئلة الثلاثة:

### 1. كم أملك من العملات الرقمية؟
- **< 1 000 €** ← **Lumina Wallet** (للهاتف، آمنة، ومجانية)
- **1 000 € – 10 000 €** ← **Lumina Wallet** للاستخدام اليومي + Ledger اختياري للادخار
- **> 10 000 €** ← **Ledger** للتخزين البارد + Lumina Wallet للمعاملات اليومية

### 2. هل أنا نشط في DeFi؟
- **لا، أحتفظ بالعملات وأرسلها فقط** ← **Lumina Wallet**
- **نعم، لكن أحيانًا** ← **Lumina Wallet** (WalletConnect مدمج)
- **نعم، مستخدم DeFi محترف يوميًا** ← **Rabby** أو MetaMask

### 3. هل أقلق من عمليات الاحتيال؟
- **نعم، سمعت قصصًا مخيفة** ← **Lumina Wallet** (ماسح ثلاثي الطبقات)
- **أنا حذر وتقني** ← MetaMask أو Rabby أو Trust Wallet
- **أرسل فقط إلى عناوين معروفة** ← أي محفظة تفي بالغرض

## مشكلة الرموز المزيفة: فارق حاسم

لدى معظم المحافظ في هذه القائمة عيب صارخ: فهي تعرض **كل رمز** ترسله إليها البلوكتشين. ويعني هذا أنه حين يرسل المحتالون 10 000 "USDT" مزيفة إلى عنوانك عبر الإسقاط الجوي (airdrop)، فإن MetaMask وTrust Wallet وRainbow وCoinbase Wallet **كلها تعرضها** كأنها حقيقية.

وإذا نقرت للبيع — فإنك توقّع عقدًا خبيثًا. وتُفرَّغ محفظتك في لحظة.

**Lumina Wallet مختلفة.** فهي لا تعرض إلا الرموز الواردة في **قائمة بيضاء صارمة بعناوين العقود الرسمية لكل بلوكتشين**. USDT مزيفة على Ethereum؟ تُتجاهل. USDC مزيفة على BNB Chain؟ تُتجاهل. وهذا وحده يقضي على احتيال العملات الرقمية الأول في 2026.

اقرأ دليلنا الكامل: [الرموز المزيفة — كيف توقفها Lumina من المصدر](/en/security).

## الأسئلة الشائعة حول المحافظ غير الحضانية

### ما هي أكثر المحافظ غير الحضانية أمانًا في 2026؟

بالنسبة لمعظم المستخدمين، **Lumina Wallet** — لأنها تجمع بين الحفظ الذاتي والحماية النشطة من الاحتيال. أما للمقتنيات الكبيرة طويلة الأمد، فـ**محفظة Ledger المادية**.

### هل يمكن اختراق المحفظة غير الحضانية؟

المحفظة نفسها لا، فالمفاتيح الخاصة تبقى على جهازك. لكن قد **تُخدع أنت** فتوقّع معاملة خبيثة. ولهذا يهمّ اختيار محفظة تتضمن **ماسح معاملات**.

### هل Lumina Wallet مجانية حقًا؟

نعم. لا رسوم شهرية ولا باقات مميزة. تربح Lumina عبر رسوم شركاء شفافة على الخدمات الاختيارية (التخزين/الستيكينغ عبر Everstake، وشراء العملات الرقمية عبر MoonPay/Transak) — وهي معلنة بوضوح.

### هل ينبغي أن أستخدم عدة محافظ؟

نعم. هذا هو نمط كبار حائزي العملات الرقمية: **Ledger للادخار** (أكثر من 90% من المقتنيات) + **Lumina Wallet للاستخدام اليومي** (أقل من 10%). وتحتفظ كل محفظة بعبارة استرداد مستقلة.

## الخلاصة: لقد نضج مشهد المحافظ

في 2026 لم يعد وصف "غير حضانية" كافيًا. فكل محفظة جادة هي غير حضانية. أما **الفارق الحقيقي** فهو الحماية من الاحتيال: إلى أي مدى تدافع المحفظة عنك في لحظات سهوك أنت؟

توصيتنا:
- **المستخدمون اليوميون** ← [Lumina Wallet](/en/download) (أفضل نسبة بين الأمان وسهولة الاستخدام)
- **محترفو DeFi** ← Rabby أو MetaMask
- **المقتنيات الكبيرة** ← الجمع بين Ledger وLumina Wallet

**هل أنت مستعد لتجربة أكثر المحافظ غير الحضانية أمانًا في 2026؟**

[حمّل Lumina Wallet من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [حمّله من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "permit-malveillant-erc20-scam": {
    title: "تصريح ERC-20 الخبيث (Permit): الاحتيال الصامت الذي يستنزف محفظتك دون أي معاملة",
    meta: "افهم كيف تعمل تصاريح ERC-20 الخبيثة وتوقيعات Permit2، أخطر عملية احتيال في عالم العملات المشفرة لعام 2026 والتي تستنزف محفظتك دون أي معاملة ظاهرة على السلسلة. تعرّف على كيفية اكتشافها وحظرها.",
    body: `في عام 2026، سُرق أكثر من **500 مليون دولار** من مستخدمي العملات المشفرة عبر أسلوب واحد: **تصريح ERC-20 الخبيث (malicious permit)**. هذا الاحتيال خطير بشكل خاص لأنه لا يترك **أي أثر ظاهر على السلسلة** عند التوقيع، فهو مجرد توقيع بسيط يخوّل المهاجم استنزاف محفظتك متى شاء.

يشرح هذا الدليل ما هو التصريح الخبيث، ولماذا أصبح عملية الاحتيال المفضلة لدى مستنزفي المحافظ (drainers) في 2026، والأهم من ذلك **كيف تحمي نفسك**.

## ما هو تصريح ERC-20 (Permit)؟

**التصريح (permit)** هو امتداد لمعيار ERC-20 تم تقديمه في عام 2020 (EIP-2612). وهو يتيح للمستخدم **منح تفويض** لعقد ذكي لإنفاق رموزه **دون الحاجة إلى إرسال معاملة على السلسلة**.

بعبارة بسيطة: بدلاً من معاملة "Approve" التقليدية التي تكلّف رسوم غاز، تقوم **فقط بتوقيع رسالة** باستخدام محفظتك. ثم يقوم العقد نفسه بإرسال هذه الرسالة إلى السلسلة.

**الفوائد المشروعة:**
- ✅ توفير رسوم الغاز (معاملة واحدة بدلاً من اثنتين)
- ✅ تجربة مستخدم أفضل (يوقّع المستخدم مرة واحدة ويتم كل شيء)
- ✅ تستخدمه Uniswap و1inch ومجمّعات DEX

**المشكلة:** هذا التوقيع **غير مرئي لمعظم المحافظ**. تنقر على "Sign" معتقدًا أنك تتصل بموقع ما، وفي الواقع تكون قد خوّلت المهاجم لتوه استنزاف 100 000 USDC.

## كيف تعمل عملية الاحتيال في 5 خطوات

### الخطوة 1 — الطُّعم
تنقر على إعلان في Google أو رابط في Discord يقودك إلى **موقع Uniswap مزيف** أو **توزيع airdrop مزيف** أو **موقع NFT مزيف**. يبدو الموقع شرعيًا بنسبة 100% — شعارات رسمية، تصميم احترافي، وعنوان URL مضلل (\`uniswaap.org\` بدلاً من \`uniswap.org\`).

### الخطوة 2 — طلب الاتصال
يطلب منك الموقع "ربط محفظتك". تنقر، فتفتح MetaMask، ولا ترى سوى "توقيع رسالة". لا شيء مريب **على السطح**.

### الخطوة 3 — الرسالة المخفية
ما لا تراه: الرسالة تحتوي على معاملات تصريح ERC-20:
- **owner**: عنوانك
- **spender**: عنوان المهاجم
- **value**: الحد الأقصى للمبلغ (عادةً 115 792 089 237 316 195... = لا نهائي)
- **deadline**: 30 يومًا من الآن
- **nonce**: رقم nonce الحالي الخاص بك

توقّع، ولا يحدث شيء على السلسلة **فورًا**. فتظن أنه لم يحدث شيء.

### الخطوة 4 — الاستغلال
بعد ساعات أو أيام، يرسل المهاجم **توقيعك** إلى السلسلة عبر معاملة \`permit()\` + \`transferFrom()\`. يقبل العقد الذكي ذلك لأن التوقيع صحيح رياضيًا.

### الخطوة 5 — السرقة
تُنقل رموز USDC أو USDT أو WETH أو أي رمز ERC-20 آخر لديك **إلى عنوان المهاجم**. وتكتشف الخسارة في صباح اليوم التالي.

**لا يوجد أي سبيل للتعويض.** المعاملة لا رجعة فيها، ولا توجد أي منصة تداول مركزية معنية.

## Permit2: النسخة الأشد خطورة

**Permit2** هو امتداد اقترحته Uniswap في عام 2022 لتوحيد التصاريح عبر **جميع رموز ERC-20**، حتى تلك التي لا تطبّق EIP-2612 بشكل أصلي.

إنه **عبقري من الناحية التقنية** لتجربة مستخدم DeFi، لكنه **كارثي** على الأمان، لأن:
- توقيع Permit2 واحد يمكنه تخويل إنفاق **عدة رموز دفعة واحدة**
- يظل التوقيع صالحًا لمدة **أيام أو أسابيع**
- تعرض معظم المحافظ Permit2 كـ"رسالة" عادية دون تفاصيل

**النتيجة:** يستخدم المستنزفون الحديثون Permit2 بشكل أساسي لأنه يجعل السرقة **أكثر كفاءة وأشد تكتمًا**.

## كيف تكتشف التصريح الخبيث

### العلامة الحمراء رقم 1: صيغة التوقيع
يظهر توقيع Permit أو Permit2 دائمًا في محفظتك على شكل **رسالة مهيكلة بمعيار EIP-712** بهذا الشكل:

\`\`\`
Domain: PermitToken or Permit2
Types:
  Permit: [owner, spender, value, nonce, deadline]
Message:
  owner: 0xYOUR_ADDRESS
  spender: 0xUNKNOWN  ← THIS is suspicious
  value: 115792089237316195423570985008687907853269984665640564039457584007913129639935  ← That's infinity!
  deadline: 1735689600
\`\`\`

### العلامة الحمراء رقم 2: السياق
- وصلت للتو إلى موقع **لم تستخدمه من قبل** → 🔴
- يعرض الموقع **airdrop مجانيًا** أو **عائدًا غير طبيعي** → 🔴
- يطلب منك الموقع التوقيع **قبل أن يعرض أي محتوى** → 🔴
- عنوان URL يحتوي على **خطأ إملائي دقيق** (uniswaap بدلاً من uniswap) → 🔴

### العلامة الحمراء رقم 3: spender مجهول
يجب أن يكون الحقل \`spender\` (العقد الذي سينفق رموزك) عقدًا **معروفًا وموثّقًا**. إذا كان عنوانًا عشوائيًا لا يظهر على Etherscan كعقد موثّق، **فهو احتيال.**

## كيف تحميك Lumina Wallet

تقوم Lumina Wallet بفك ترميز **كل** توقيع Permit وPermit2 قبل أن تطلب منك التوقيع. وإليك ما يحدث عمليًا:

1. **فك ترميز التوقيع**: تحلل Lumina رسالة EIP-712 وتحدد ما إذا كانت تصريحًا
2. **التحقق من spender**: هل العقد الوجهة DEX/بروتوكول معروف (Uniswap، 1inch، Aave...) أم عنوان مجهول؟
3. **تنبيه المبلغ**: إذا كان المبلغ "لا نهائيًا" (2^256 - 1)، يظهر تنبيه حرج
4. **ترجمة بلغة مفهومة**: بدلاً من كتلة سداسية عشرية، ترى: *"أنت تخوّل [عقدًا مجهولًا] بإنفاق [كل USDC لديك]، دون حد، خلال الأيام الثلاثين القادمة"*

النتيجة: ترى **بالضبط** ما توقّع عليه قبل أن توقّع. ويصبح من المستحيل أن توافق على تصريح خبيث عن طريق الخطأ.

## ماذا تفعل إذا كنت قد وقّعت بالفعل على تصريح خبيث

### الخطوة 1 — لا تفزع، وتصرّف بسرعة
قد لا يكون التصريح قد استُغل بعد. لديك **مهلة** قبل أن يستخدم المهاجم توقيعك.

### الخطوة 2 — أفرغ الرموز المعرّضة للخطر
انقل فورًا جميع رموز ERC-20 لديك إلى **محفظة جديدة نظيفة**. استخدم محفظة جديدة بعبارة استرداد (seed phrase) جديدة. لا تعد استخدام المحفظة المخترقة.

### الخطوة 3 — إلغاء الموافقات الحالية
انتقل إلى [revoke.cash](https://revoke.cash) وألغِ جميع الموافقات. **ملاحظة مهمة:** لا يمكن لـ revoke.cash إلغاء توقيع Permit خارج السلسلة لم يُستغل بعد. كل ما يمكنك فعله هو نقل الرموز.

### الخطوة 4 — الإبلاغ عن الموقع الاحتيالي
- ScamAdviser
- Google Safe Browsing
- Chainabuse.com

### الخطوة 5 — تخلَّ عن المحفظة المخترقة
لا تعد استخدام محفظة وقّعت على تصريح خبيث، حتى لو لم تخسر شيئًا. فقد يظل nonce التوقيع قابلًا للاستغلال بحسب السياق.

## إجماع الخبراء

- **Vitalik Buterin (أحد مؤسسي Ethereum)** حذّر علنًا من مخاطر Permit2 على X في عام 2024.
- حددت **Chainalysis** "توقيع التصاريح الخبيثة" باعتباره **الأسلوب الأول لسرقة العملات المشفرة في 2025**، متجاوزًا موافقات ERC-20 التقليدية.
- وثّقت **PeckShield** أكثر من 300 هجوم بتصاريح خبيثة في عام 2025 وحده.

## الخلاصة: التوقيع غير المرئي هو الخطر الجديد

انتهى عصر المعاملات المرئية على السلسلة. في 2026، أخطر عمليات الاحتيال لا تترك **أي أثر ظاهر** عند الموافقة. توقيع خارج السلسلة، صامت، ومؤجَّل التنفيذ، وتجد محفظتك فارغة في اليوم التالي.

**الدفاع الفعّال الوحيد:** محفظة **تفك ترميز كل توقيع بلغة مفهومة** قبل أن توافق عليه. وهذا بالضبط ما تفعله Lumina Wallet، مع Permit وPermit2 وجميع توقيعات EIP-712 الخبيثة.

**احمِ نفسك الآن:**

[حمّل Lumina Wallet من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [حمّله من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "how-to-set-up-non-custodial-wallet-2026": {
    title: "كيفية إعداد محفظة عملات رقمية غير احتجازية في 2026: دليل كامل خطوة بخطوة",
    meta: "تعلّم بالضبط كيفية إعداد محفظة عملات رقمية غير احتجازية في 2026 — دليل تعليمي كامل خطوة بخطوة يغطي اختيار المحفظة، والنسخ الاحتياطي لعبارة الاسترداد، وإعدادات الأمان، ومعاملتك الأولى. مناسب للمبتدئين.",
    body: `يُعدّ إعداد **محفظة عملات رقمية غير احتجازية** أهم خطوة في رحلتك مع العملات الرقمية. إذا أنجزتها بالشكل الصحيح، فستمتلك عملاتك الرقمية فعلًا — فلا بنك ولا منصة تداول ولا أي طرف ثالث يستطيع تجميد أموالك أو فقدانها. أما إذا أخطأت، فقد تخسر كل شيء بسبب خطأ واحد.

يرشدك هذا الدليل خطوة بخطوة عبر **العملية بأكملها** في 2026، بدءًا من اختيار المحفظة المناسبة وصولًا إلى معاملتك الأولى الآمنة. بلا مصطلحات معقدة، وبلا اختصارات.

## قبل أن تبدأ: القواعد الذهبية الثلاث

### القاعدة 1 — لا تشارك عبارة الاسترداد أبدًا
عبارة الاسترداد المكوّنة من 12 أو 24 كلمة هي المفتاح الرئيسي لمحفظتك بالكامل. **لن يطلبها منك أي شخص أو تطبيق أو موقع شرعي أبدًا.** حتى مطورو المحفظة التي تستخدمها لن يطلبوها. إذا طلبها أي أحد، فهي عملية احتيال بنسبة 100%.

### القاعدة 2 — لا تخزّن عبارة الاسترداد رقميًا أبدًا
لا صور. لا لقطات شاشة. لا ملاحظات سحابية. لا مديري كلمات مرور متصلين بالإنترنت. أبدًا. اكتبها على **ورق** أو انقشها على **معدن**. واحفظ الورقة في مكان آمن فعليًا.

### القاعدة 3 — حمّل التطبيق دائمًا من الموقع الرسمي
تطبيقات المحافظ المزيفة على App Store وGoogle Play تسرق عبارات الاسترداد لحظة إدخالها. حمّل التطبيق فقط من **الموقع الرسمي** للمحفظة (مثل https://luminawallet.org)، وليس من نتائج البحث في Google Play أو App Store.

## الخطوة 1 — اختر المحفظة غير الاحتجازية المناسبة

للمبتدئين في 2026، نوصي بـ **Lumina Wallet** للأسباب التالية:
- ✅ غير احتجازية بالتصميم (أنت من يملك المفاتيح)
- ✅ ماسح مدمج لمكافحة الاحتيال (يحميك من أخطائك أنت)
- ✅ متعددة السلاسل منذ اليوم الأول (Bitcoin وEthereum وSolana وXRP وBNB Chain وPolygon...)
- ✅ تحميل مجاني
- ✅ شركة فرنسية (HEDONISME SARL) بملكية شفافة

بدائل يمكن النظر فيها بحسب ملفك الشخصي:
- **MetaMask** — إذا كنت مستخدمًا متقدمًا لتطبيقات DeFi
- **Ledger** — إذا كنت تحتفظ بأكثر من 10 000 € على المدى الطويل (محفظة عتادية)
- **Rabby** — إذا كنت تستخدم DeFi يوميًا عبر المتصفح

اطّلع على [مقارنتنا الكاملة لأفضل المحافظ غير الاحتجازية لعام 2026](/en/blog/best-non-custodial-crypto-wallet-2026).

## الخطوة 2 — حمّل التطبيق من المصدر الرسمي

بالنسبة إلى Lumina Wallet:
1. افتح متصفح هاتفك (Safari على iOS، وChrome على Android)
2. اكتب **luminawallet.org** مباشرة (لا تبحث عنه في Google — فقد تكون إعلانات Google مزيفة)
3. اضغط على زر **"Download"**
4. ستتم إعادة توجيهك إلى صفحة التطبيق الرسمية في Google Play Store أو App Store

تحقق قبل التثبيت من:
- ✅ اسم المطوّر: **Lumina Wallet**
- ✅ معرّف App Store: **id6760651380**
- ✅ حزمة Google Play: **com.luminawallet.app**
- ✅ عدد مرات التحميل > 1 000 (النسخ المزيفة لا تحظى إلا بعدد قليل جدًا من التحميلات)

بعد التحقق من الهوية، ثبّت التطبيق.

## الخطوة 3 — أنشئ محفظة جديدة (ولا تستورد)

افتح التطبيق للمرة الأولى. ستظهر لك خياران:
- **"Create New Wallet"** ← اختر هذا
- **"Import Existing Wallet"** ← فقط إذا كانت لديك عبارة استرداد بالفعل

اضغط على **Create New Wallet**. يولّد التطبيق مفاتيحك الخاصة **محليًا على جهازك**. فهي لا تمر أبدًا عبر خوادمنا ولا عبر مطورينا ولا عبر الإنترنت.

## الخطوة 4 — انسخ عبارة الاسترداد احتياطيًا (الخطوة الحاسمة)

سيعرض التطبيق الآن **12 أو 24 كلمة** بترتيب محدد. هذه هي **عبارة الاسترداد** الخاصة بك.

### كيف تنسخها احتياطيًا بشكل صحيح:

1. **أحضر قلمًا وورقة** (وليس هاتفك).
2. **اكتب الكلمات بالترتيب**، كلمة واحدة في كل سطر، مع الرقم بجانب كل كلمة.
3. **دقّق في كل كلمة مرتين** — خطأ إملائي واحد يعني أنك لن تتمكن من استرداد محفظتك.
4. **تحقق من الإملاء** بمقارنتها بالتطبيق كلمة كلمة.
5. **احفظ الورقة** في مكان آمن فعليًا: درج مقفل، أو خزنة منزلية، أو صندوق أمانات في البنك.
6. **اصنع نسخة ثانية** واحفظها في **مكان مادي مختلف** (مثل أحد أفراد العائلة الموثوق بهم).
7. **لا تصوّر الورقة أبدًا.** ولا تخزّنها أبدًا في Notes أو iCloud أو Google Drive أو أي خدمة سحابية.

**إعداد متقدم اختياري:** انقش عبارة الاسترداد على الفولاذ المقاوم للصدأ (باستخدام أطقم مثل Cryptosteel أو Billfodl، أو طقم أختام معدنية بسيط). مقاوم للحريق والماء وعوامل الزمن.

### ما يجب تجنّبه:
- ❌ التقاط صورة "للنسخ الاحتياطي فقط"
- ❌ إرسالها إلى نفسك عبر البريد الإلكتروني
- ❌ تخزينها في مدير كلمات مرور عبر الإنترنت
- ❌ حفظها في تطبيق الملاحظات على هاتفك
- ❌ مشاركتها مع أي شخص (الزوج/الزوجة، العائلة، "وكلاء الدعم")

## الخطوة 5 — أكّد عبارة الاسترداد

سيطلب منك التطبيق **التحقق** من أنك كتبت العبارة بشكل صحيح. فيعرض عليك بعض المواضع (مثل الكلمة رقم 3، والكلمة رقم 7، والكلمة رقم 11) ويطلب منك اختيار الكلمة الصحيحة من قائمة.

إذا أخطأت، فلن يقفل التطبيق حسابك — لكنها إشارة قوية إلى أنك لم تنسخها احتياطيًا بشكل صحيح. **أعد النسخ الاحتياطي** حتى تتمكن من التأكيد اعتمادًا على ما كتبته في ورقتك.

## الخطوة 6 — عيّن كلمة مرور قوية للمحفظة

أنشئ **كلمة مرور قوية** لفتح التطبيق على جهازك:
- **14 حرفًا** على الأقل
- مزيج من الأحرف الكبيرة والصغيرة والأرقام والرموز
- **مختلفة عن كل كلمة مرور أخرى تستخدمها**
- احفظها في مدير كلمات مرور (Bitwarden أو 1Password أو KeePass)

تقوم كلمة المرور هذه بتشفير مفاتيحك محليًا. وحتى لو سرق أحدهم هاتفك، فلن يتمكن من فتح Lumina Wallet بدونها.

## الخطوة 7 — فعّل القياسات الحيوية + رمز PIN

من قائمة الإعدادات في محفظتك، فعّل:
- ✅ **Face ID** أو **بصمة الإصبع** (القياسات الحيوية في iOS/Android)
- ✅ **رمز PIN** (6 أرقام، مختلف عن رمز PIN لفتح هاتفك)

أصبح لديك الآن **3 طبقات من المصادقة** تحمي محفظتك:
1. فتح الهاتف (Face ID / PIN)
2. رمز PIN للمحفظة (6 أرقام)
3. كلمة مرور المحفظة (14 حرفًا أو أكثر)

وحتى لو سرق لص هاتفك وهو مفتوح، فلن يتمكن من الوصول إلى عملاتك الرقمية.

## الخطوة 8 — تحقق من كل شيء بمعاملة اختبار صغيرة

قبل تخزين أي مبلغ كبير:

1. أرسل إلى نفسك ما قيمته **من 5 € إلى 10 €** من العملات الرقمية من منصة تداول (Coinbase أو Binance أو Kraken) إلى عنوان محفظتك الجديدة.
2. انتظر تأكيد المعاملة (عادةً من 1 إلى 15 دقيقة حسب البلوكتشين).
3. أرسلها **مرة أخرى** إلى المنصة كاختبار آخر.

إذا نجحت المعاملتان، فقد أُعدّت محفظتك بشكل صحيح. **لا تخزّن مبالغ كبيرة قبل إجراء هذا الاختبار.**

## الخطوة 9 — تدرّب على استخدام ماسح مكافحة الاحتيال

تحتوي Lumina Wallet على ماسح مدمج يحميك من عمليات الاحتيال الشائعة. جرّبه:

- **جرّب الإرسال إلى عنوان مزيف بوضوح** (مثل 0x000...000) ← ستحظره Lumina
- **جرّب مسح رمز QR لا علاقة له بالعملات الرقمية** ← سترفضه Lumina
- **اطّلع على معاينة المعاملة** قبل التوقيع ← تعرض Lumina الرموز المميزة (tokens) الخارجة بدقة

إن التعرّف على هذه التحذيرات **الآن** يعني أنك ستتعرّف عليها حين تواجه عملية احتيال حقيقية.

## الخطوة 10 — الآن فقط، خزّن مبالغ حقيقية

بعد أن تكون قد:
- ✅ أكدت النسخ الاحتياطي لعبارة الاسترداد
- ✅ فعّلت القياسات الحيوية + PIN + كلمة المرور
- ✅ أجريت معاملة اختبار بنجاح
- ✅ تدرّبت على الماسح

...**عندها** يمكنك البدء بتخزين مبالغ حقيقية.

النمط الموصى به لكبار المحتفظين بالعملات:
- **المحفظة اليومية**: احتفظ فيها بأقل من 10 % من إجمالي عملاتك الرقمية (للإنفاق وDeFi وعمليات المبادلة)
- **خزنة المدخرات**: للمبالغ الكبيرة، استخدم محفظة عتادية (Ledger) بعبارة استرداد مختلفة، محفوظة دون اتصال بالإنترنت

## أخطاء شائعة تفسد أمان المحفظة

حتى المستخدمون الذين يتبعون هذا الدليل يرتكبون أحيانًا هذه الأخطاء. تجنّبها:

- ❌ **التقاط لقطة شاشة لعبارة الاسترداد** "للنسخ الاحتياطي فقط" — فـ iCloud يزامنها إلى السحابة
- ❌ **إعادة استخدام كلمة المرور نفسها** للمحفظة والبريد الإلكتروني
- ❌ **النقر على إعلانات Google** الخاصة بتطبيقات المحافظ (النسخ المزيفة تستخدم إعلانات Google)
- ❌ **تجاهل تحذيرات الأمان** لأنك على عجلة من أمرك
- ❌ **الاتصال بتطبيقات DApp عشوائية** من أجل "تجربة" airdrop

## الأسئلة الشائعة حول إعداد محفظة غير احتجازية

### كم يستغرق إعداد محفظة غير احتجازية؟

إذا اتبعت هذا الدليل بعناية، فحوالي **15 إلى 20 دقيقة**. ويُقضى معظم هذا الوقت في كتابة عبارة الاسترداد والتحقق منها بشكل صحيح.

### هل من الآمن كتابة عبارة الاسترداد على هاتفي؟

فقط في **السيناريو المحدد** الذي تقوم فيه بإعداد محفظة جديدة أو استرداد محفظة موجودة **داخل تطبيق المحفظة الرسمي**. لا تكتبها أبدًا على موقع ويب أو في دردشة دعم أو في أي تطبيق آخر.

### هل يمكنني استخدام عبارة الاسترداد نفسها لعدة محافظ؟

نعم. عبارة الاسترداد هي المفتاح الرئيسي — يمكنك استيرادها إلى أي محفظة متوافقة مع BIP-39 (Lumina وMetaMask وTrust Wallet وLedger...) والوصول إلى الحسابات نفسها. ومع ذلك، فإن أفضل ممارسة هي **استخدام عبارات استرداد مختلفة لأغراض مختلفة** (يومية مقابل مدخرات).

### ماذا لو فقدت هاتفي؟

إذا كانت عبارة الاسترداد مكتوبة لديك: ثبّت Lumina Wallet على هاتف جديد، واختر "Import Existing Wallet"، وأدخل عبارة الاسترداد — وستعود أموالك فورًا.

أما إذا لم تكن عبارة الاسترداد مكتوبة لديك: فعملاتك الرقمية **مفقودة إلى الأبد**. بلا استثناء.

## الخلاصة: أعدّ المحفظة بشكل صحيح، ونَم قرير العين

إعداد محفظة غير احتجازية هو **استثمار لمرة واحدة** يحدد أمان عملاتك الرقمية لسنوات. خصّص 5 دقائق إضافية لكتابة عبارة الاسترداد بشكل صحيح، وفعّل جميع طبقات الأمان، وابدأ الاختبار بمبالغ صغيرة.

صُمّمت **Lumina Wallet** لجعل هذه العملية آمنة قدر الإمكان — مع ماسح لمكافحة الاحتيال يلتقط الأخطاء التي قد ترتكبها لاحقًا، مهما كنت حريصًا اليوم.

**هل أنت مستعد لإعداد أول محفظة غير احتجازية لك؟**

[حمّل Lumina Wallet من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [حمّله من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "unhosted-wallet-vs-custodial-wallet": {
    title: "المحفظة غير المستضافة مقابل المحفظة الحافظة (Custodial): الدليل التنظيمي لعام 2026",
    meta: "ما المقصود بـ\"المحفظة غير المستضافة\"؟ تعرّف على الفرق بين المحافظ غير المستضافة والمحافظ الحافظة (Custodial) — وهو مصطلح وزارة الخزانة الأمريكية للمحافظ غير الحافظة — وما يعنيه ذلك لتنظيم العملات الرقمية والخصوصية والحفظ الذاتي في عام 2026.",
    body: `إذا كنت تتابع منشورات وزارة الخزانة الأمريكية أو FinCEN مؤخرًا، فمن المرجّح أنك صادفت مصطلح **"المحفظة غير المستضافة" (unhosted wallet)**. إنه التسمية التنظيمية لما يسميه مجتمع العملات الرقمية **المحفظة غير الحافظة (non-custodial wallet)** — لكن مع فروق دقيقة مهمة في عام 2026. يوضح هذا الدليل ما هي المحفظة غير المستضافة، وكيف تختلف عن المحفظة الحافظة (custodial wallet)، ولماذا تهمّ المصطلحات في مجالات الخصوصية والامتثال والحفظ الذاتي.

## ما المقصود بالمحفظة غير المستضافة؟

**المحفظة غير المستضافة** هي محفظة عملات رقمية تكون فيها المفاتيح الخاصة تحت سيطرة المستخدم، وليس تحت سيطرة مزوّد خدمة من طرف ثالث. وفي لغة الجهات التنظيمية المالية الأمريكية — وعلى رأسها FinCEN (شبكة إنفاذ الجرائم المالية) ووزارة الخزانة الأمريكية — يعني مصطلح "غير مستضافة": **غير مستضافة لدى مؤسسة مالية خاضعة للتنظيم**.

**عمليًا، المحفظة غير المستضافة هي:**
- ✅ محفظة **تمتلك** أنت مفاتيحها الخاصة
- ✅ لا يديرها بنك أو منصة تداول أو أي شركة خدمات مالية (MSB) مسجّلة
- ✅ محفظة يمكنك الوصول إليها دون المرور بعملية التحقق من الهوية (KYC)

**مرادفات شائعة في 2026:**
- المحفظة غير الحافظة (مصطلح الصناعة)
- محفظة الحفظ الذاتي (مصطلح تعليمي)
- المحفظة الشخصية (مصطلح غير رسمي)

## غير المستضافة مقابل الحافظة: الفروق الأساسية

| الميزة | المحفظة غير المستضافة | المحفظة الحافظة |
|---|---|---|
| **من يملك المفاتيح الخاصة؟** | أنت | طرف ثالث خاضع للتنظيم (منصة تداول، بنك) |
| **هل يلزم التحقق من الهوية (KYC)؟** | لا | نعم (التحقق من الهوية) |
| **هل يمكن تجميد الحسابات؟** | لا — لا أحد يملك هذه الصلاحية | نعم — يمكن للجهة الحافظة التجميد بناءً على طلب |
| **الإبلاغ التنظيمي؟** | محدود (يختلف حسب الولاية القضائية) | كامل (يُبلَّغ عن كل معاملة للسلطات) |
| **من يملك الأموال قانونيًا؟** | أنت مباشرةً | الجهة الحافظة تحتفظ بها لأجلك |
| **مخاطر الإفلاس؟** | لا توجد | نعم — أنت دائن غير مضمون |
| **أمثلة** | Lumina Wallet، MetaMask، Ledger | Coinbase، Binance، Kraken (حسابها الافتراضي) |

## لماذا تستخدم الجهات التنظيمية مصطلح "غير مستضافة"؟

ظهر مصطلح "غير مستضافة" بشكل بارز في **قاعدة مقترحة من FinCEN في ديسمبر 2020** كانت ستُلزم منصات التداول بجمع معلومات الهوية للمعاملات من وإلى المحافظ غير المستضافة التي تتجاوز حدودًا معينة.

وكانت هذه القاعدة:
- **لم تُعتمد بصيغتها الأصلية** (بسبب معارضة قوية من القطاع)
- نُفّذت جزئيًا في **إطار الإبلاغ الأمريكي عن الأصول المشفرة لعام 2024**
- جزءًا من مواءمة أوسع بين مجموعة السبع وFATF بشأن **قاعدة السفر (Travel Rule)** للعملات الرقمية

في عام 2026، يُستخدم مصطلح "المحفظة غير المستضافة" بكثرة في:
- منشورات وزارة الخزانة الأمريكية وFinCEN
- توصيات FATF (مجموعة العمل المالي)
- لائحة MiCA الأوروبية (الأسواق في الأصول المشفرة)
- شهادات الكونغرس بشأن سياسات العملات الرقمية

## هل استخدام المحفظة غير المستضافة قانوني؟

**نعم.** استخدام المحفظة غير المستضافة **قانوني بالكامل** في الولايات المتحدة والاتحاد الأوروبي والمملكة المتحدة وفرنسا وفي معظم الديمقراطيات تقريبًا في عام 2026.

ما يخضع للتنظيم هو:
- المعاملات **بين منصات التداول والمحافظ غير المستضافة** (وفق حدود الإبلاغ)
- بعض الأنشطة التجارية المتعلقة بالمحافظ غير المستضافة (تحويل الأموال، خدمات الحفظ)
- **وليس** مجرد امتلاك الفرد لمحفظة غير مستضافة أو استخدامه لها

للتوضيح: **يمكنك قانونيًا امتلاك محفظة غير مستضافة واستخدامها والإرسال منها واستقبال العملات الرقمية فيها في فرنسا والاتحاد الأوروبي في 2026 — دون الحاجة إلى ترخيص أو تفويض.**

## مقايضة الخصوصية

توفر المحافظ غير المستضافة **خصوصية أكبر** من المحافظ الحافظة للأسباب التالية:
- لا يلزم KYC لإنشائها
- لا إبلاغ عن المعاملات إلى سلطات مركزية
- لا حظر للمعاملات من قِبل وسطاء

ومع ذلك، فإن هذه الخصوصية **ليست مطلقة**:
- معاملات البلوكشين **مرئية للعموم إلى الأبد**
- إذا ارتبطت هويتك بعنوانك (عبر منصات التداول أو تطبيقات dApps أو أحداث KYC)، يصبح سجلّك الكامل على السلسلة قابلًا للتتبع
- **شركات تحليل السلاسل** (Chainalysis وElliptic وTRM Labs) تراقب نشاط البلوكشين بشكل فعّال

لتحقيق خصوصية حقيقية في 2026، تحتاج إلى:
- محفظة غير مستضافة
- استخدام حذر لمنصات التداول (باستخدام قنوات تحويل النقد إلى عملات رقمية عند الإمكان)
- أدوات تركّز على الخصوصية (خلاطات، عملات الخصوصية، أو بروتوكولات خصوصية ZK)

⚠️ **ملاحظة:** تتطور اللوائح المتعلقة بأدوات الخصوصية. استشر مستشارًا قانونيًا محليًا في حالات القيم الكبيرة أو الاستخدام التجاري.

## المحافظ غير المستضافة ولائحة MiCA (أوروبا)

تتناول **لائحة MiCA الأوروبية** (الأسواق في الأصول المشفرة)، المطبّقة بالكامل منذ ديسمبر 2024، المحافظ غير المستضافة على النحو التالي:

- يمكن **للأفراد** استخدام المحافظ غير المستضافة بحرية — دون أي إبلاغ
- يجب على **مزوّدي خدمات الأصول المشفرة (CASPs)** — منصات التداول والجهات الحافظة — جمع بيانات الهوية للمعاملات التي تتجاوز **1 000 €** من أو إلى المحافظ غير المستضافة ("قاعدة السفر")
- تبقى المعاملات بين محفظتين غير مستضافتين لدى أفراد **غير خاضعة للتنظيم**

عمليًا: بصفتك مستخدمًا فرنسيًا، يمكنك استخدام Lumina Wallet بحرية، واستقبال العملات الرقمية فيها والإرسال منها — دون أي التزام خاص.

## أمان المحفظة غير المستضافة: ما تحتاج إلى معرفته

لأن المحافظ غير المستضافة تمنحك تحكمًا كاملًا، فإنها تمنحك أيضًا **مسؤولية كاملة**:

### الجانب الإيجابي:
- ✅ **لا يستطيع أي طرف ثالث** تجميد أموالك
- ✅ **لا يمكن لإفلاس جهة حافظة** أن يضيّع أموالك
- ✅ **خصوصية كاملة** افتراضيًا
- ✅ **وصول مباشر إلى DeFi** دون وسطاء

### المقايضة:
- 🔴 **فقدان عبارة الاسترداد (seed phrase) = فقدان أموالك** (لا يوجد خيار "نسيت كلمة المرور")
- 🔴 **التعرض للتصيّد = فقدان أموالك** (لا يمكن التراجع)
- 🔴 **توقيع عقد خبيث = فقدان أموالك** (المسؤولية عليك بالكامل)

لهذا السبب، فإن اختيار محفظة غير مستضافة مزوّدة **بحماية مدمجة ضد الاحتيال** — مثل Lumina Wallet — يحسّن بشكل ملحوظ معادلة المخاطرة والعائد. فأنت تحتفظ بحرية الحفظ الذاتي مع إضافة شبكة أمان ضد أخطائك الشخصية.

## هل يجب أن تستخدم محفظة غير مستضافة؟

**نعم، إذا:**
- كنت تريد ملكية حقيقية لعملاتك الرقمية
- كنت جادًا في الاحتفاظ طويل الأمد
- كنت تريد استخدام DeFi أو NFT أو تطبيقات Web3
- كنت قلقًا من إفلاس منصات التداول أو تجميد الحسابات
- كنت تقدّر الخصوصية

**لا، إذا:**
- كنت تتداول أحيانًا فقط على منصات مركزية
- لا تشعر بالارتياح في إدارة عبارة الاسترداد
- كنت تحتاج إلى شبكة أمان "نسيت كلمة المرور" في الخدمات الحافظة
- كانت بساطة الإبلاغ التنظيمي أهم لديك من الحفظ الذاتي

بالنسبة لمعظم مستخدمي العملات الرقمية الجادين، الجواب هو: **استخدم الاثنين معًا**. احتفظ بأرصدة التداول النشط في منصة تداول خاضعة للتنظيم، وانقل الحيازات طويلة الأمد إلى محفظة غير مستضافة.

## الأسئلة الشائعة: المحافظ غير المستضافة

### هل "المحفظة غير المستضافة" هي نفسها "المحفظة الباردة"؟

ليس تمامًا. **"غير مستضافة"** تصف من يتحكم بالمفاتيح (أنت، وليس طرفًا ثالثًا). أما **"باردة"** فتصف مكان تخزين المفاتيح (دون اتصال مقابل متصلة بالإنترنت). يمكن أن تكون المحفظة غير مستضافة وساخنة (Lumina، MetaMask)، أو غير مستضافة وباردة (Ledger، Trezor).

### هل أحتاج إلى التصريح بمحفظتي غير المستضافة في إقراري الضريبي؟

في فرنسا، منذ عام 2020، يجب التصريح **بحسابات الأصول الرقمية الأجنبية** في النموذج 3916-BIS. أما المحافظ غير المستضافة المحتفظ بها مباشرةً (ليس لدى جهة حافظة) فهي عمومًا **غير خاضعة لهذا الالتزام**، لكن قواعد الإبلاغ تتطور. استشر مختصًا ضريبيًا بشأن وضعك.

### هل يمكن للحكومة مصادرة العملات الرقمية في محفظة غير مستضافة؟

فقط إذا حصلت على المفاتيح الخاصة أو أجبرتك على تسليمها عبر إجراء قانوني. توجد حالات موثقة صادرت فيها السلطات عملات رقمية بالحصول على عبارات الاسترداد عبر أوامر تفتيش أو صفقات إقرار بالذنب. **الملكية التشفيرية ليست هي نفسها الحصانة القانونية.**

### ما أفضل محفظة غير مستضافة للمبتدئين؟

صُمّمت **Lumina Wallet** خصيصًا للمستخدمين الذين يريدون الحفظ الذاتي دون أن يصبحوا خبراء في العملات الرقمية. تلتقط الحماية المدمجة من الاحتيال أكثر الأخطاء شيوعًا، بينما يغطي الدعم متعدد السلاسل (Bitcoin وEthereum وSolana وXRP وBNB وPolygon...) كل ما ستحتاجه فعليًا.

## الخلاصة

"المحفظة غير المستضافة" هي كلمة الجهات التنظيمية للدلالة على **المحفظة غير الحافظة** — أداة أساسية لملكية العملات الرقمية في 2026. يساعدك فهم هذا المصطلح على استيعاب النقاشات السياسية والإقرارات الضريبية والامتثال في عصر MiCA.

الخلاصة: المحافظ غير المستضافة **قانونية وقوية وباقية**. اختر محفظة تجمع بين الحفظ الذاتي والحماية العملية — مثل Lumina Wallet — لتحصل على أفضل ما في العالمين.

**هل أنت مستعد لتجربة محفظة غير مستضافة حديثة؟**

[حمّل Lumina Wallet من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [حمّل من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "non-custodial-wallet-app-2026-mobile-guide": {
    title: "تطبيق محفظة غير حاضنة: الدليل الشامل لعام 2026 لمستخدمي الهاتف المحمول",
    meta: "تبحث عن أفضل تطبيق محفظة غير حاضنة في 2026؟ دليل متكامل يركّز على الهاتف المحمول: ما الذي تتوقعه، وأهم متطلبات الأمان، ومقارنة بين أفضل 5 تطبيقات على iOS/Android، وكيف تكتشف النسخ المزيفة على App Store.",
    body: `البحث عن **تطبيق محفظة غير حاضنة** في 2026 أمر محيّر. هناك مئات التطبيقات على App Store وGoogle Play، وكل منها يدّعي أنه الأكثر أمانًا أو الأسهل أو الأغنى بالميزات. بعضها ممتاز، وبعضها عمليات احتيال صريحة (نسخ مزيفة صُمّمت لسرقة عبارات الاسترداد). هذا الدليل يركّز بالكامل على الهاتف المحمول، دون إضافات المتصفح أو المحافظ الصلبة، ويقدّم إطارًا عمليًا لاختيار التطبيق المناسب مع تجنّب الفخاخ.

## ما هو تطبيق المحفظة غير الحاضنة؟

**تطبيق المحفظة غير الحاضنة** هو تطبيق للهاتف المحمول (iOS أو Android) يتحقق فيه ما يلي:
- **أنت** من يملك المفاتيح الخاصة، وهي مشفّرة محليًا على هاتفك
- **لا منصة تداول ولا بنك ولا أي طرف ثالث** يستطيع تجميد عملاتك المشفرة أو فقدانها
- **عبارة الاسترداد (seed phrase)** تُنشأ محليًا ولا تغادر جهازك أبدًا
- الوصول محمي بالقياسات الحيوية + رمز PIN + كلمة مرور

أفضل المحافظ المحمولة غير الحاضنة في 2026 تدعم أكثر من 10 سلاسل بلوكتشين، وتتكامل مع تطبيقات Web3 عبر WalletConnect، والأهم أنها تتضمن **حماية من الاحتيال** مدمجة في التطبيق نفسه.

## لماذا الهاتف المحمول أهم من الحاسوب في 2026؟

أكثر من **72% من معاملات العملات المشفرة** في 2026 تتم على الأجهزة المحمولة (Chainalysis 2026 State of Crypto). وقد تفوّقت المحافظ غير الحاضنة المخصصة للهاتف على إضافات المتصفح للأسباب التالية:

- 🔐 الهواتف الحديثة تحتوي على **وحدات أمان عتادية** (iOS Secure Enclave وAndroid Keystore) لا تضاهيها المتصفحات
- 📱 **المصادقة بالقياسات الحيوية** (Face ID، بصمة الإصبع) أصبحت معيارًا
- 🚀 **الإشعارات الفورية** تنبّهك مباشرة إلى المعاملات الواردة
- 📷 **الكاميرا ومسح رموز QR** يتيحان إدخال العناوين بطريقة أكثر أمانًا
- 🌐 **WalletConnect v2** يتيح للمحافظ المحمولة التوقيع نيابةً عن تطبيقات dApps على الحاسوب

## أفضل 5 تطبيقات محافظ غير حاضنة في 2026

### 🥇 Lumina Wallet — أفضل محفظة محمولة تركّز على الأمان
- **المنصات:** iOS + Android
- **السلاسل:** Bitcoin، Ethereum، Solana، XRP، BNB Chain، Polygon، Arbitrum، Optimism، Base، Avalanche
- **الميزات الفريدة:** ماسح ضد الاحتيال بثلاث طبقات (قارئ QR، تدقيق العناوين، مفكّك المعاملات) + [فلتر القائمة البيضاء للرموز المزيفة](/en/security)
- **الأنسب لـ:** المستخدمين الذين يريدون أقصى حماية دون أن يصبحوا خبراء في العملات المشفرة
- **مجاني** — بلا اشتراك

### 🥈 Trust Wallet — أوسع دعم للسلاسل
- **المنصات:** iOS + Android
- **السلاسل:** أكثر من 70
- **نقطة الضعف:** يعرض جميع الرموز افتراضيًا (خطر الرموز المزيفة المزعجة)، وحماية أساسية ضد الاحتيال
- **الأنسب لـ:** المستخدمين النشطين على سلاسل كثيرة غير شائعة

### 🥉 MetaMask Mobile — معيار DeFi
- **المنصات:** iOS + Android
- **السلاسل:** سلاسل EVM وSolana وBitcoin
- **نقطة الضعف:** تحذيرات أساسية، لا فلتر للرموز المزيفة، وصعوبات تاريخية في تجربة الاستخدام
- **الأنسب لـ:** المستخدمين المعتادين على MetaMask في المتصفح

### Rainbow — أفضل تجربة استخدام لـ Ethereum
- **المنصات:** iOS + Android
- **السلاسل:** منظومة Ethereum فقط
- **نقطة الضعف:** دعم محدود للسلاسل المتعددة
- **الأنسب لـ:** مستخدمي Ethereum العاديين الذين يقدّرون التصميم

### Coinbase Wallet — الأفضل لمستخدمي Coinbase
- **المنصات:** iOS + Android
- **السلاسل:** أكثر من 20
- **نقطة الضعف:** حماية أساسية ضد الاحتيال، ومخاوف بشأن جمع البيانات
- **الأنسب لـ:** من ينتقلون من منصة Coinbase إلى الحفظ الذاتي

## الميزات الأربع التي لا غنى عنها في 2026

عند المقارنة بين تطبيقات المحافظ غير الحاضنة، أصرّ على الميزات الأربع جميعها:

### 1. تخزين محلي للمفاتيح مع أمان عتادي
يجب أن تكون المفاتيح الخاصة مشفّرة باستخدام iOS Secure Enclave أو Android Keystore. **إذا كان التطبيق يخزّن المفاتيح كنص عادي أو عبر المزامنة السحابية، فابتعد عنه.**

### 2. ماسح مدمج ضد الاحتيال
كل محفظة تستحق اسمها في 2026 ينبغي أن:
- تفحص عناوين المستلمين مقابل قوائم العناوين الخبيثة المعروفة
- تفكّ تشفير توقيعات ERC-20 Permit / Permit2 بلغة واضحة
- تحاكي المعاملات قبل التوقيع (وتُظهر الرموز التي ستغادر محفظتك بالضبط)
- تنبّه عند اكتشاف أنماط «الموافقة غير المحدودة»

### 3. فلتر الرموز المزيفة
هذا هو **أهم عامل تمييز في 2026**. يرسل المحتالون 10 000 رمز «USDT» مزيف إلى ملايين المحافظ عبر الإسقاط الجوي. المحافظ التي تعرض كل رمز خطرة. ابحث عن المحافظ التي تعتمد **قائمة بيضاء لعناوين العقود الرسمية لكل سلسلة بلوكتشين** (Lumina هي الرائدة حاليًا في هذا المجال).

### 4. دعم متعدد السلاسل منذ اليوم الأول
يجب أن تولّد عبارة استرداد واحدة عناوين لـ Bitcoin وEthereum وSolana وXRP وBNB Chain وغيرها من الشبكات الرئيسية، دون الحاجة إلى التنقل بين عدة تطبيقات.

## كيف تكتشف تطبيقات المحافظ المزيفة على App Store

**النسخ المزيفة** تهديد كبير في 2026. فهي تنسخ اسم Lumina Wallet وشعارها ووصفها، ثم تسرق عبارة الاسترداد بمجرد إدخالها.

**قائمة التحقق قبل التنزيل:**

- ✅ نزّل التطبيق فقط من **الموقع الرسمي** (مثل https://luminawallet.org). لا تبحث أبدًا داخل App Store.
- ✅ تحقق من أن **اسم المطوّر** مطابق تمامًا (Lumina Wallet منشورة باسم *Lumina Wallet*)
- ✅ تحقق من **معرّف الحزمة**: Lumina الحقيقية = \`com.luminawallet.app\`
- ✅ تحقق من **معرّف App Store**: Lumina الحقيقية = \`id6760651380\`
- ✅ عدد التنزيلات أكبر من 1 000 (النسخ المزيفة عادةً أقل من 100)
- ✅ اقرأ المراجعات — غالبًا ما تحمل النسخ المزيفة تقييمات بخمس نجوم متشابهة بشكل مريب

📖 اقرأ دليلنا الكامل: [نسخ محافظ العملات المشفرة المزيفة](/en/blog/fake-crypto-wallet-clones)

## الأسئلة الشائعة حول تطبيق المحفظة غير الحاضنة

### هل تطبيق المحفظة غير الحاضنة أكثر أمانًا من تطبيق المنصة؟

للتخزين المتوسط والطويل الأجل، **نعم**. لا يمكن اختراق المحفظة غير الحاضنة على مستوى المنصة، فلكل مستخدم مفاتيحه الخاصة على جهازه الخاص. أما تطبيقات المنصات فهي أهداف مغرية يستهدفها المهاجمون باستمرار.

### هل تكلّف تطبيقات المحافظ غير الحاضنة مالًا؟

أفضل التطبيقات مثل **Lumina Wallet** مجانية بالكامل. تحقق بعض المحافظ أرباحًا عبر رسوم شفافة من الشركاء على خدمات اختيارية (التخزين/Staking، شراء العملات المشفرة). احذر التطبيقات التي تطلب «اشتراكًا مميزًا» مقابل ميزات المحفظة الأساسية.

### هل يمكنني استخدام تطبيق المحفظة غير الحاضنة نفسه على عدة هواتف؟

نعم، ثبّت التطبيق على الهاتفين واستورد عبارة الاسترداد في كل منهما. سيعرض الهاتفان الأرصدة نفسها ويمكن لكل منهما إرسال المعاملات بشكل مستقل. احذر: أي هاتف يحتوي على عبارة الاسترداد يملك وصولًا كاملًا.

### ماذا يحدث إذا اختفى مطوّر تطبيق المحفظة؟

عملاتك المشفرة تبقى آمنة. «غير حاضنة» تعني أن التطبيق مجرد واجهة، أما مفاتيحك فمرتبطة بالبلوكتشين. وإذا اختفت Lumina Wallet يومًا ما، يمكنك استيراد عبارة الاسترداد في **أي محفظة متوافقة مع BIP-39** (MetaMask وTrust Wallet وLedger…) واستعادة الوصول الكامل.

## الخلاصة: اختر تطبيق محفظة تثق به لسنوات

تطبيق محفظتك غير الحاضنة هو المكان الذي ستتعامل فيه مع عملاتك المشفرة **مئات المرات** خلال السنوات القادمة. اختر تطبيقًا يجمع بين الحفظ الذاتي والحماية الفعّالة من تهديدات 2026: التوقيعات الخبيثة، والرموز المزيفة، وعناوين التصيّد.

صُمّمت **Lumina Wallet** لهذا الغرض تحديدًا: محفظة محمولة غير حاضنة بماسح ضد الاحتيال بثلاث طبقات، وعرض للرموز ذات العقود الرسمية فقط، ودعم لأكثر من 10 سلاسل بلوكتشين. مجانية وشفافة (شركة فرنسية، HEDONISME SARL، RCS Dunkerque 901 439 505)، وبلا جمع للبيانات.

**هل أنت مستعد لتجربة أكثر تطبيقات المحافظ غير الحاضنة أمانًا في 2026؟**

[نزّل Lumina Wallet من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [نزّله من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "metamask-vs-lumina-wallet-anti-scam-comparison": {
    title: "MetaMask مقابل Lumina Wallet: مقارنة الحماية من الاحتيال لعام 2026",
    meta: "MetaMask أم Lumina Wallet في 2026؟ مقارنة صريحة وجنبًا إلى جنب تركّز على الحماية من الاحتيال: فلتر الرموز المزيفة، وفك تشفير التوقيعات، وماسح العناوين، ودعم السلاسل المتعددة، وتجربة الاستخدام على الهاتف.",
    body: `**MetaMask** هي أشهر محفظة غير حاضنة (non-custodial) في العالم، بأكثر من 30 مليون مستخدم نشط شهريًا. أما **Lumina Wallet** فهي منافس أحدث يعتمد نهج الهاتف المحمول أولًا، وقد صُمّم خصيصًا للحماية من الاحتيال. أيّهما ينبغي أن تستخدم في 2026؟ تركّز هذه المقارنة على الأمر الأهم في عالم العملات المشفّرة اليوم: مدى قدرة كل محفظة على حمايتك من تفريغ أموالك.

## الإجابة السريعة

- **اختر MetaMask إذا:** كنت مستخدمًا متمرسًا في التمويل اللامركزي (DeFi)، وتعمل من المتصفح، وتعرف كيف تقرأ استدعاءات دوال Solidity قبل التوقيع.
- **اختر Lumina Wallet إذا:** كنت تريد محفظة للهاتف تكشف عنك عمليات الاحتيال — قبل أن ترتكب خطأً مكلفًا.

بالنسبة لمعظم المستخدمين في 2026، الإجابة هي **Lumina Wallet**. إليك السبب.

## مقارنة جنبًا إلى جنب

| الميزة | MetaMask | Lumina Wallet |
|---|---|---|
| **المنصة** | المتصفح + الهاتف | الهاتف فقط (iOS + Android) |
| **السلاسل المدعومة** | سلاسل EVM وSolana وBitcoin | أكثر من 10 بما فيها BTC وETH وSOL وXRP وBNB |
| **تخزين المفاتيح** | تخزين المتصفح / Keystore على الهاتف | iOS Secure Enclave / Android Keystore |
| **ماسح العناوين المضاد للاحتيال** | ⚠️ أساسي (قائمة حظر فقط) | ✅ GoPlus فوري + ماسح مخصص |
| **فلتر الرموز المزيفة** | ❌ يعرض كل رمز | ✅ قائمة بيضاء حسب العقد الرسمي |
| **مفكّك ERC-20 Permit** | ⚠️ يعرض بيانات hex الخام | ✅ ترجمة بلغة بسيطة |
| **مفكّك Permit2** | ⚠️ أساسي | ✅ فك تشفير كامل مع فحص المبلغ والمُنفِق (spender) |
| **محاكاة المعاملات** | ⚠️ أساسية (Ethereum فقط) | ✅ محاكاة متعددة السلاسل |
| **دفتر العناوين (ضد الأخطاء الإملائية)** | ❌ لا | ✅ نعم |
| **مفتوح المصدر** | ✅ نعم | ⚠️ ليس بعد (مخطط له) |
| **شفافية الشركة** | ⚠️ Consensys (الولايات المتحدة) | ✅ HEDONISME SARL (فرنسا) — قابلة للتحقق عبر RCS |
| **السعر** | مجانية | مجانية |

## أكبر فرق: فلتر الرموز المزيفة

في 2026، **الاحتيال الأول في عالم العملات المشفّرة** هو الإسقاطات الجوية (airdrops) الخبيثة. يُنشئ المحتالون رموز USDT أو USDC أو WETH مزيفة بالاسم والشعار نفسيهما للرموز الحقيقية، ثم يُسقطون 10 000 منها على ملايين المحافظ. وعندما تضغط للبيع، توقّع عقدًا خبيثًا ← فتُفرَّغ محفظتك.

### كيف تتعامل MetaMask مع ذلك
تعرض MetaMask **كل رمز** ترسله إليك البلوكتشين. وإذا أسقط أحدهم USDT مزيفًا على عنوانك، فسيظهر في محفظتك — بالاسم نفسه والشعار نفسه. عليك أن تتحقق يدويًا من عنوان العقد على Etherscan للتأكد من أنه حقيقي. ومعظم المستخدمين لا يفعلون ذلك.

### كيف تتعامل Lumina Wallet مع ذلك
تعتمد Lumina على **قائمة بيضاء صارمة بعناوين العقود الرسمية لكل بلوكتشين**. لا يظهر إلا USDT من عقد Ethereum الحقيقي (0xdAC17F...). أما الرموز المزيفة فتظل غير مرئية. ولا يتطلب الأمر أي إجراء من المستخدم.

اقرأ تحليلنا المعمّق: [كيف تحظر Lumina الرموز المزيفة من المصدر](/en/security)

## فك تشفير التوقيعات: الوقاية الصامتة من الاحتيال

كلّفت توقيعات ERC-20 Permit وPermit2 الخبيثة المستخدمين **أكثر من 500 مليون دولار في 2026** (راجع [دليلنا الكامل](/en/blog/malicious-erc20-permit-scam)). وهي تنجح لأن معظم المحافظ تعرض التوقيعات كبيانات hex غامضة — فلا يفهم المستخدمون ما الذي يوقّعون عليه.

### MetaMask والتوقيعات
تعرض MetaMask توقيعات Permit كرسالة EIP-712 منسّقة، لكن التفاصيل تقنية. فالحقول مثل \`spender\` و\`value\` و\`nonce\` ظاهرة لكنها غير مشروحة. ويغفل المستخدمون العاديون باستمرار عن علامات «الموافقة غير المحدودة».

### Lumina Wallet والتوقيعات
تقوم Lumina بـ**فك تشفير كل توقيع** إلى لغة بسيطة قبل أن يُطلب منك التوقيع:
- «أنت تفوّض [اسم العقد / عقد غير معروف] بإنفاق [المبلغ / غير محدود] من [الرمز] الخاص بك، لمدة [المدة]»
- تنبيهات حرجة عند المبالغ غير المحدودة
- علامة حمراء إذا لم يكن المُنفِق (spender) عقدًا موثّقًا

النتيجة الملموسة: تفهم بالضبط ما الذي توقّع عليه، قبل أن توقّع.

## دعم السلاسل المتعددة

بدأت MetaMask بوصفها **محفظة Ethereum**. ومنذ 2025 أصبحت تدعم أيضًا Solana وBitcoin بشكل أصلي عبر الحسابات متعددة السلاسل ([MetaMask](https://metamask.io/news/multichain-accounts)). لا تدعم XRP بشكل أصلي، ولا تزال الشبكات غير الموجودة في قائمتها المدمجة تتطلب إضافة يدوية — وهو عائق بسيط للمبتدئين.

أما Lumina Wallet فهي **متعددة السلاسل منذ اليوم الأول**: Bitcoin وEthereum وSolana وXRP وBNB Chain وPolygon وArbitrum وOptimism وBase وAvalanche. عبارة استرداد واحدة، وتطبيق واحد، وكل شيء يعمل.

## تجربة الاستخدام: واقع الهاتف المحمول

**الحقيقة:** تتعرض تطبيق MetaMask للهاتف لانتقادات منذ سنوات بسبب واجهته الثقيلة، وبطء متصفح dApp، ومشكلات الاتصال عبر WalletConnect. وقد حسّن الإصدار 8.0 (2026) الأمور، لكن التصميم لا يزال متأخرًا بوضوح عن المحافظ التي تعتمد الهاتف أولًا.

بُنيت **Lumina Wallet** كتطبيق للهاتف أولًا، مع:
- معاينة فورية للمعاملة
- فتح القفل بالقياسات الحيوية
- واجهة نظيفة وعصرية صممها مصممو تجربة المستخدم على الهاتف
- دعم أصلي لـ WalletConnect v2

## أين تتفوق MetaMask

MetaMask لن تختفي. نقاط قوتها في 2026:

- ✅ **هيمنة المنظومة**: 99% من تطبيقات dApp تضع «الاتصال عبر MetaMask» كخيار افتراضي
- ✅ **إضافة المتصفح**: أفضل لمستخدمي DeFi المحترفين الذين يعملون كثيرًا على سطح المكتب
- ✅ **منظومة Snaps**: قابلية التوسّع عبر إضافات من جهات خارجية
- ✅ **مفتوحة المصدر**: الشيفرة عامة وقابلة للتدقيق

إذا كنت مستخدم DeFi متقدمًا وتلتزم بانضباط التخزين البارد، فإن MetaMask خيار جيد. لكن معادلة الأمان مقابل سهولة الاستخدام تغيّرت في 2026، وLumina هي وجهة المستخدمين العاديين.

## الأسئلة الشائعة: MetaMask مقابل Lumina Wallet

### هل يمكنني استخدام الاثنتين معًا؟

نعم — كثير من المستخدمين يفعلون ذلك. والنمط الشائع: MetaMask على سطح المكتب لـ DeFi المتقدم، وLumina Wallet على الهاتف للمعاملات اليومية وأي توقيع تحت الضغط.

### هل عبارة الاسترداد متوافقة بين المحفظتين؟

نعم. كلتاهما تستخدم معيار BIP-39، لذا يمكنك استيراد عبارة الاسترداد نفسها إلى أي من المحفظتين والوصول إلى الحسابات نفسها.

### أيّهما أكثر أمانًا؟

بالنسبة لـ**تخزين المفاتيح الأساسي**: كلتاهما آمنة (غير حاضنة ومشفّرة محليًا). أما بالنسبة لـ**الحماية الفعلية من الاحتيال**: فإن Lumina Wallet متقدمة بشكل ملحوظ في 2026، بفضل فلتر الرموز المزيفة، ومفكّك التوقيعات، والماسح متعدد السلاسل.

### أيّهما أسرع؟

كلتاهما سريعة في المعاملات الأساسية. وفي التفاعل مع dApp، تكون إضافة المتصفح لـ MetaMask أسرع على سطح المكتب. أما تطبيق Lumina Wallet للهاتف فهو أسرع من MetaMask Mobile.

## الخلاصة: محافظ مختلفة لمستخدمين مختلفين

تبقى MetaMask المعيار الصناعي لمستخدمي DeFi المتقدمين الذين يُعطون الأولوية لتوافق المنظومة والمصدر المفتوح. أما Lumina Wallet فهي الإجابة العصرية للمستخدمين الذين يُعطون الأولوية لـ**الحماية من مشهد التهديدات في 2026** — التوقيعات الخبيثة، والرموز المزيفة، وعناوين التصيّد.

إذا شعرت يومًا بالتوتر من الضغط على «توقيع» دون أن تفهم تمامًا ما تفعله المعاملة، فإن **Lumina Wallet مصممة من أجلك**.

**هل أنت مستعد لتجربة محفظة 2026 المضادة للاحتيال؟**

[حمّل Lumina Wallet من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [حمّل من App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380)`
  },
  "guide-wallet-non-custodial-2026": {
    title: "محفظة العملات الرقمية غير الحافظة (Non-Custodial): الدليل الكامل لعام 2026",
    meta: "ما هي محفظة العملات الرقمية غير الحافظة فعلاً في 2026، وكيف تختلف عن المنصات الحافظة، وكيف تختار واحدة، وقائمة الأمان الدقيقة التي يجب اتباعها قبل نقل ساتوشي واحد. مكتوب للمستخدمين العاديين.",
    body: `**محفظة العملات الرقمية غير الحافظة (Non-Custodial)** هي محفظة **تملك وحدك مفاتيحها الخاصة** التي تتحكم في أموالك. لا يمكن لأي شركة أو منصة تداول أو طرف ثالث تجميد أصولك أو مصادرتها أو فقدانها نيابةً عنك. في عام 2026، وبعد عقد من انهيارات المنصات (FTX وCelsius وMt. Gox) ومليارات الدولارات من أموال المستخدمين المجمّدة، انتقلت المحافظ غير الحافظة من خيار محدود الانتشار إلى التوصية الافتراضية لدى معظم باحثي الأمان تقريباً [1].

يشرح هذا الدليل، بلغة بسيطة، كيف تعمل المحافظ غير الحافظة، وكيف تختلف عن الخيارات الحافظة، وما المقايضات التي تقبلها عند اختيار الحفظ الذاتي، وقائمة التحقق العملية لعام 2026 لاختيار محفظة يمكنك الوثوق بها فعلاً.

## تعريف 2026: المحفظة غير الحافظة موضّحة

محفظة العملات الرقمية ليست سوى أداة لإدارة **المفاتيح الخاصة** — السلاسل التشفيرية الطويلة التي تثبت ملكيتك للعملات المسجّلة على البلوكتشين. هناك نموذجان للحفظ:

| النموذج | من يملك المفاتيح؟ | من يستطيع تحريك أموالك؟ | مثال |
|---|---|---|---|
| **حافظة (Custodial)** | شركة (منصة تداول، وسيط) | الشركة (وأنت من خلالها) | Coinbase, Binance, Revolut Crypto |
| **غير حافظة (Non-Custodial)** | أنت (على جهازك) | أنت فقط | Lumina Wallet, MetaMask, Phantom, Ledger |

في الإعداد غير الحافظ، تُولَّد مفاتيحك **محلياً على هاتفك أو جهازك الصلب** وتُشفَّر باستخدام المنطقة الآمنة في نظام التشغيل (iOS Secure Enclave، أو Android Keystore، أو شريحة مخصصة في المحفظة الصلبة). لا يرسلها تطبيق المحفظة إلى أي مكان. وإذا اختفت الشركة المطوّرة للمحفظة غداً، تبقى أموالك متاحة طالما لديك **عبارة الاسترداد المكوّنة من 12 أو 24 كلمة** (BIP-39).

## لماذا 2026 هو عام الحفظ الذاتي

ثلاث قوى جعلت المحافظ غير الحافظة سائدة في 2026:

1. **إخفاقات المنصات لم تعد أحداثاً نادرة.** تفيد Chainalysis بأن 2.8 مليار دولار من أموال المستخدمين ما زالت مجمّدة أو مفقودة من انهيارات المنصات بين 2022 و2025 [2].
2. **قانون MiCA والتنظيمات العالمية تدفع نحو إثبات الاحتياطيات.** لكن إثبات الاحتياطيات لا يحمي من الإعسار التشغيلي — الحفظ الذاتي وحده يفعل ذلك.
3. **محافظ الهاتف لحقت بركب تجربة الاستخدام.** تقلّصت الفجوة في سهولة الاستخدام بين فتح حساب في Binance وإعداد محفظة غير حافظة إلى أقل من 5 دقائق.

## المقايضات الحقيقية (النسخة الصادقة)

اختيار محفظة غير حافظة ليس "أفضل" بالمطلق — بل هو نموذج مسؤولية مختلف. وهذه هي المقايضة بصراحة:

**ما تكسبه:**
- ملكية مباشرة — دون مخاطر الطرف المقابل
- الوصول إلى التمويل اللامركزي (DeFi) وNFT والمبادلات والتخزين (staking) دون KYC عند كل حركة
- مقاومة الرقابة
- رسوم أقل على المدى الطويل (دون هامش سعري للحافظ)

**ما تقبله:**
- **أنت النسخة الاحتياطية.** إن فقدت عبارتك المكوّنة من 24 كلمة، فلا يوجد مكتب دعم يستعيد أموالك.
- **أنت فريق الأمان.** التصيّد، والتواقيع الخبيثة، والرموز المزيفة — المحفظة تساعد، لكن القرار النهائي لك.
- **لا إمكانية لعكس الاحتيال.** معاملات البلوكتشين نهائية.

يمكن تقليل عبء الأمان بشكل كبير باختيار محفظة تتضمن **حماية فعّالة من الاحتيال** (فك ترميز التواقيع، وفحص العناوين، وتصفية الرموز المزيفة). لكنه لا يزول تماماً أبداً.

## كيف تختار محفظة غير حافظة في 2026

ليست كل المحافظ غير الحافظة متساوية. الادعاءات التسويقية ("آمنة"، "أكثر المحافظ أماناً") ليست معايير تقييم. استخدم هذه القائمة الملموسة:

### 1. تخزين المفاتيح: أين تُحفظ العبارة الأصلية (seed)؟

- **الحد الأدنى المقبول (المحافظ البرمجية):** مفاتيح مخزّنة في iOS Secure Enclave أو Android Keystore، ومشفّرة بالقياسات الحيوية أو الرقم السري. وليس أبداً في تخزين التطبيق العادي أو المزامنة السحابية.
- **أعلى مستوى من الأمان:** المحفظة الصلبة (Ledger وTrezor وColdcard). المفاتيح لا تغادر الجهاز أبداً.

### 2. الشفافية: كود مفتوح المصدر أو قابل للتحقق

- فضّل المحافظ ذات الكود العلني أو على الأقل تقرير تدقيق منشور من شركة موثوقة (Trail of Bits وHalborn وCertik).
- تحقق من أن الشركة المطوّرة للمحفظة معروفة الهوية. فالمحفظة التابعة لكيان قانوني يمكنك التحقق منه في سجل عام (مثل الشركات الأوروبية في RCS أو Companies House) يصعب أن يهرب أصحابها بأموالك.

### 3. ميزات مكافحة الاحتيال (الفارق الحاسم في 2026)

الخطر الحقيقي في 2026 **ليس** أن يكسر أحدهم تشفيرك، بل أن **توقّع معاملة خبيثة**. أفضل المحافظ غير الحافظة تمنع ذلك عبر:

- **ماسح عناوين** يقارن كل مستلم بقوائم التصيّد والعقوبات المعروفة (GoPlus وChainalysis وOFAC)
- **مفكّك توقيعات** يترجم تواقيع ERC-20 Permit وPermit2 إلى لغة بسيطة
- **مرشّح الرموز المزيفة** حتى لا يظهر USDT المزيف المُرسَل عشوائياً (airdrop) بجانب USDT الحقيقي
- **محاكاة المعاملة** تعرض ما سيغادر محفظتك قبل أن توقّع

اقرأ: [احتيال ERC-20 Permit الخبيث](/en/blog/malicious-erc20-permit-scam) و[احتيال تسميم العناوين](/en/blog/address-poisoning-crypto-scam).

### 4. سلاسل متعددة بعبارة استرداد واحدة

المحفظة التي تدعم Bitcoin وEthereum وSolana وXRP وأهم سلاسل EVM من عبارة BIP-39 واحدة تعني احتكاكاً أقل وعبارات استرداد أقل لحمايتها.

### 5. تجربة الاسترداد

اختبر مسار الاسترداد قبل إيداع مبالغ كبيرة. المحفظة الجيدة تطلب منك تأكيد عبارة الاسترداد عند الإعداد الأول، وتحذرك إن حاولت التقاط صورة شاشة لها، وتوفّر توثيقاً واضحاً لكيفية الاسترداد على جهاز جديد.

## الإعداد في 10 دقائق الذي يحميك

1. نزّل المحفظة من **صفحة المتجر الرسمية** (وليس من إعلان بحث — فالمحتالون يشترون النتائج الممولة)
2. أنشئ محفظة جديدة
3. **اكتب عبارة الاسترداد على ورق أو على نسخة احتياطية معدنية**. لا تحفظها أبداً في ملاحظة سحابية أو لقطة شاشة أو مدير كلمات مرور بمزامنة سحابية
4. أكّد العبارة داخل التطبيق
5. فعّل الفتح بالقياسات الحيوية + الرقم السري
6. أرسل مبلغاً تجريبياً صغيراً (5–10 دولارات) من منصة تداول أولاً
7. تأكد من وصوله
8. وعندها فقط انقل مبالغ أكبر

## غير الحافظة مقابل الساخنة/الباردة: أين يقع هاتفك؟

"الساخنة" و"الباردة" **ليستا** مثل "الحافظة" و"غير الحافظة":

- **المحفظة الساخنة** = متصلة بالإنترنت (تطبيق جوال، إضافة متصفح)
- **المحفظة الباردة** = غير متصلة (محفظة صلبة، محفظة ورقية)
- المحفظة غير الحافظة على الجوال **ساخنة لكنها غير حافظة**.
- المحفظة الصلبة **باردة وغير حافظة**.

للاستخدام اليومي (أقل من نحو 10 آلاف دولار)، تُعدّ محفظة جوال آمنة غير حافظة التوصية السائدة في 2026. أما للمدخرات الأكبر من ذلك، فأضف طبقة محفظة صلبة.

## الأسئلة الشائعة حول محفظة العملات الرقمية غير الحافظة

### هل المحفظة غير الحافظة قانونية؟
نعم. في كل الولايات القضائية الكبرى (الولايات المتحدة، والاتحاد الأوروبي بموجب MiCA، والمملكة المتحدة، وكندا، واليابان، وسنغافورة)، يُعدّ امتلاك مفاتيحك الخاصة قانونياً. تنطبق التزامات الإبلاغ على **التحويلات من وإلى العملات الورقية**، لا على الحفظ الذاتي نفسه. راجع قواعد الإبلاغ الضريبي المحلية لديك.

### هل يمكن أن أخسر أموالي مع محفظة غير حافظة؟
نعم، بثلاث طرق: (1) فقدان عبارة الاسترداد، (2) توقيع معاملة خبيثة، (3) الإرسال إلى عنوان خاطئ. ويمكن معالجة الثلاث بنسخ احتياطية سليمة ومحفظة تتضمن ميزات فعّالة لمكافحة الاحتيال.

### هل Coinbase Wallet غير حافظة؟
Coinbase Wallet (التطبيق المستقل) غير حافظة. أما حساب **منصة** Coinbase فهو حافظ. إنهما منتجان مختلفان يحملان الاسم التجاري نفسه.

### ما أفضل محفظة غير حافظة للمبتدئين في 2026؟
اطّلع على مقارنتنا المخصصة: [أفضل محفظة عملات رقمية غير حافظة 2026](/en/blog/best-non-custodial-crypto-wallet-2026). باختصار: اختر محفظة تعتمد الجوال أولاً مع فك ترميز التواقيع وفحص العناوين مدمجَين.

## الخلاصة

محفظة العملات الرقمية غير الحافظة ليست ترفاً — ففي 2026 هي الحد الأدنى لكل من يملك أكثر من بضع مئات من الدولارات في العملات الرقمية. منحنى التعلّم حقيقي لكنه قصير. القرارات الأساسية هي: اختر محفظة بحماية حديثة من الاحتيال، واحتفظ بنسخة احتياطية من عبارة الاسترداد على ورق، وابدأ بتحويل تجريبي صغير، وتعامل مع عبارة الاسترداد على أنها المفتاح الرئيسي الذي هي عليه فعلاً.

**هل أنت مستعد للحفظ الذاتي مع حماية مدمجة من الاحتيال؟** [نزّل Lumina Wallet من Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380).

---

### المراجع

[1] Electronic Frontier Foundation. (2026). *Self-custody as a digital-rights baseline*. [https://www.eff.org/](https://www.eff.org/)

[2] Chainalysis. (2026). *The State of Centralized Exchange Insolvencies*. [https://www.chainalysis.com/](https://www.chainalysis.com/)`
  },
  "faux-wallets-crypto-2026-7-clones": {
    title: "المحافظ المشفرة المزيفة 2026: 7 هجمات استنساخ جديدة يجب أن تعرفها",
    meta: "دليل ميداني لعام 2026 عن أكثر 7 هجمات نشاطًا للمحافظ المشفرة المزيفة: نسخ متاجر التطبيقات الممولة، والنطاقات المشابهة، ومحافظ \"الدعم\" على تيليجرام، وملفات APK المعدّلة، وفيديوهات المؤسسين المزيفة بتقنية التزييف العميق، وتحديثات MetaMask المزيفة، واحتيال استعادة العبارة السرية، مع خطوات الوقاية.",
    body: `في عام 2026، نمت هجمات المحافظ المشفرة المزيفة أسرع من أي فئة أخرى من سرقات العملات المشفرة. تقدّر Chainalysis أن **340 مليون دولار فُقدت بسبب مخططات المحافظ المزيفة في النصف الأول من عام 2026 وحده** [1]، مدفوعةً بتحوّل عمليات الاحتيال إلى العمل الاحترافي: إعلانات بحث مدفوعة، وبنية تحتية للاستنساخ الديناميكي، ومقاطع فيديو مزيفة للمؤسسين مولَّدة بتقنية التزييف العميق، وملفات APK معدّلة لنظام Android تحمل برمجيات لسرقة العبارة السرية.

هذا المقال دليل ميداني. ستجد لكل نمط من أنماط الهجوم السبعة الأكثر نشاطًا في 2026: كيف يعمل، والحيلة التقنية المستخدمة، والخطوة الوحيدة التي تُبطله.

## 1. نسخ المتاجر الممولة (Sponsored Store-Listing Clones)

**كيف يعمل.** ينشر المهاجمون نسخة شبه مطابقة لمحفظة شرعية على Google Play أو App Store — بالأيقونة نفسها واسم مشابه ("Lumina Wallet Pro" أو "MetaMask Lite" أو "Phantom Wallet Vault"). ثم يشترون إعلانات ممولة على بحث Google باسم العلامة التجارية للمحفظة الحقيقية. فتدفع النتيجة الممولة النسخة المزيفة فوق الأصلية.

**الحيلة التقنية.** يعمل التطبيق المزيف بواجهة مبسطة تشبه المحفظة الحقيقية. وعند إنشاء العبارة السرية أو استيرادها، يرفع العبارة بصمت إلى خادم المهاجم. يرى المستخدم شاشة "المحفظة جاهزة" المعتادة بينما تُسحب أمواله في الخلفية.

**ما يبطله.** لا تثبّت محفظة من إعلان بحث أبدًا. اذهب مباشرةً إلى النطاق الرسمي للجهة المطورة (اكتبه يدويًا ولا تنسخه من نتائج البحث)، وابحث هناك عن شارة المتجر، ثم انتقل منها. توصي Google رسميًا بهذا الأسلوب لتطبيقات العملات المشفرة [2]. اقرأ أيضًا: [نسخ المحافظ المشفرة المزيفة](/en/blog/fake-crypto-wallet-clones).

## 2. النطاقات المشابهة (Punycode والأخطاء الإملائية المتعمدة)

**كيف يعمل.** يسجّل المهاجمون نطاقات لا يمكن تمييزها بصريًا عن النطاق الحقيقي — مثل "luminawallet.com" مقابل "lumınawallet.org" (حرف i بلا نقطة)، و"metamask.io" مقابل "metamαsk.io" (حرف ألفا اليوناني)، و"trustwallet.com" مقابل "trust-wallet.com".

**الحيلة التقنية.** تعرض أشرطة عناوين المتصفح أحرف Unicode تبدو مطابقة للأحرف اللاتينية (هجوم IDN homograph). ولا يلاحظ كثير من مستخدمي المحافظ ذلك.

**ما يبطله.** استخدم دائمًا إشارة مرجعية (Bookmark) لصفحة المحفظة. ولا تكتب النطاق أبدًا تحت ضغط الوقت. مديرو كلمات المرور التي تطابق النطاق تمامًا سترفض الملء التلقائي على نطاق مشابه — وهذه إشارة للتوقف.

## 3. احتيال محافظ "دعم تيليجرام"

**كيف يعمل.** تنشر شكوى في مجموعة تشفير شرعية ("معاملتي عالقة"). وفي غضون دقائق، يراسلك حساب باسم "Lumina Wallet Support" أو "MetaMask Help" عارضًا المساعدة. يرسل لك رابطًا إلى "لوحة دعم" ويطلب منك ربط محفظتك أو لصق عبارتك السرية "للتحقق من الملكية".

**الحيلة التقنية.** لا توجد شركة محافظ حقيقية تقدم الدعم عبر تيليجرام بهذه الطريقة. يستخدم المحتالون روبوتات كشط ترصد ذكر العلامات التجارية للمحافظ وترسل رسائل خاصة خلال ثوانٍ.

**ما يبطله.** لن يطلب أي دعم شرعي للمحافظ عبارتك السرية أو مفتاحك الخاص، ولن يطلب منك الاتصال بتطبيق dApp مجهول. جميع قنوات الدعم الحقيقية يمكن الوصول إليها من داخل التطبيق الرسمي — وليس العكس. اطّلع على [عمليات احتيال استعادة العملات المشفرة بدعم مزيف](/en/blog/fake-support-crypto-recovery-scams).

## 4. ملفات APK المعدّلة لنظام Android (هجمات التثبيت الجانبي)

**كيف يعمل.** على Android، يبحث المستخدم عن "download MetaMask APK" ويثبّت نسخة معدّلة من موقع طرف ثالث. يبدو التطبيق المعدّل ويعمل كالأصلي، لكنه يحتوي على شيفرة خبيثة تعترض عملية توليد العبارة السرية.

**الحيلة التقنية.** يأخذ المهاجم ملف APK الحقيقي مفتوح المصدر، ويحقن شيفرة خبيثة في مسار توليد المفاتيح (بحيث تصبح العشوائية خاضعة جزئيًا لسيطرة المهاجم)، ثم يعيد توقيعه ويوزعه على مواقع مرايا APK.

**ما يبطله.** على Android، ثبّت المحافظ من متجر Google Play فقط. وعطّل خيار "التثبيت من مصادر غير معروفة" افتراضيًا. أما مستخدمو iPhone فهم محميون بطبيعتهم بعزل App Store.

## 5. فيديوهات المؤسسين المزيفة بالتزييف العميق (احتيال الهدايا)

**كيف يعمل.** تعرض إعلانات YouTube وTikTok "Vitalik Buterin" أو "Changpeng Zhao" أو المؤسس الحقيقي لمحفظة ما وهو يعلن عن "هدية ترقية المحفظة". أرسل 1 ETH إلى رمز QR ← تحصل على 2 ETH. الفيديو مزيف بتقنية التزييف العميق.

**الحيلة التقنية.** تستطيع نماذج 2026 مفتوحة المصدر (SadTalker-v4 وHeyGen-OSS ونسخ VASA-1) توليد فيديوهات مقنعة متزامنة الشفاه انطلاقًا من صورة واحدة وعينة صوت مستنسخة. وقد رصد فريق التحليلات في Lumina 23 فيديو تزييف عميق مختلفًا ينتحل صفة مؤسسي محافظ كبرى في الربع الثالث من 2026 وحده.

**ما يبطله.** لا تُجري أي محفظة شرعية ترويجًا من نوع "أرسل X واحصل على 2X". أبدًا. هذه إشارة احتيال موثوقة بنسبة 100%. كما أن فعاليات المؤسسين المبثوثة مباشرةً أسهل في التحقق من صحتها من الفيديوهات المسجلة مسبقًا.

## 6. نوافذ "تحديث المحفظة" المنبثقة المزيفة في المتصفح

**كيف يعمل.** تزور أي موقع تشفير. تظهر نافذة منبثقة أو لافتة محقونة تقول: "محفظة MetaMask لديك قديمة. انقر للتحديث". يقودك الرابط إلى صفحة تثبّت إضافة متصفح خبيثة أو محفظة معدّلة.

**الحيلة التقنية.** كثير من هذه النوافذ تأتي من شبكات إعلانية تابعة لجهات خارجية تم اختراقها على مواقع تشفير شرعية. والمحفظة الحقيقية لا تعرض طلبات التحديث بهذه الطريقة — فإضافات المتصفح تتحدث عبر متجر Chrome / Firefox، وتطبيقات الهاتف عبر متجر نظام التشغيل.

**ما يبطله.** تجاهل جميع رسائل "حدّث محفظتك" داخل الصفحات. تحقق من التحديثات فقط في متجر إضافات المتصفح أو متجر التطبيقات في هاتفك. وإذا أصرّت الرسالة، فأغلق علامة التبويب.

## 7. احتيال "الترحيل" واستعادة العبارة السرية

**كيف يعمل.** تتلقى بريدًا إلكترونيًا أو رسالة نصية أو رسالة داخل التطبيق: "يجري ترحيل محفظتك إلى إصدار جديد آمن. يرجى إعادة إدخال عبارتك السرية في هذه الصفحة لترحيل أصولك". وهي تحاكي الهوية البصرية لمحفظتك الحقيقية.

**الحيلة التقنية.** يستغل هذا حقيقة أن المحافظ الحقيقية تغيّر علامتها التجارية أو تُرحّل أحيانًا. ويحاكي المهاجمون هذه الأحداث الشرعية (أحيانًا خلال 48 ساعة من إعلان شركة حقيقية) لتقليل شك المستخدم.

**ما يبطله.** لا يتطلب أي ترحيل لمحفظة إعادة إدخال عبارتك السرية في صفحة ويب أو نموذج. فالترحيل الحقيقي إما يتم داخل التطبيق أو يكون مجرد تحديث بسيط من المتجر. وإذا ساورك الشك، افتح التطبيق الرسمي مباشرةً وابحث عن إعلان داخله.

## مرجع سريع: علامات التحذير للمحافظ المزيفة في 2026

| علامة التحذير | ما الذي يحدث |
|---|---|
| "أدخل عبارتك السرية للتحقق / الاستعادة / الترحيل" | تصيّد احتيالي. دائمًا. |
| نتيجة ممولة من Google باسم علامة محفظة | نسخة مستنسخة على الأرجح. تجاوزها. |
| تنزيل APK من موقع غير Play Store | برمجية خبيثة معدّلة. |
| رسالة خاصة من "دعم المحفظة" بعد شكوى علنية | روبوت كشط. أبلغ واحظر. |
| "أرسل X واستلم 2X" من مؤسس | تزييف عميق / هدية مزيفة. |
| نافذة منبثقة داخل الصفحة تطلب تحديث محفظتك | إعلان محقون. تجاهله. |
| مدير كلمات المرور يرفض الملء التلقائي لنطاق "المحفظة" | نطاق مشابه. توقف. |

## كيف تحميك Lumina Wallet من مسارات المحافظ المزيفة

تدمج Lumina Wallet الدفاعات العملية الواردة في هذا الدليل:

- **التحقق من مصدر التثبيت** — تعرض شاشة التشغيل الأول سلامة حزمة التطبيق بحيث يمكن اكتشاف ملف APK المعدّل
- **فك توقيع المعاملات** — يتم التنبيه بلغة واضحة قبل التوقيع إلى المعاملات الخبيثة القادمة من تطبيقات dApp المستنسخة
- **ماسح العناوين** — تتم مقارنة عناوين المستلمين بقواعد بيانات التصيّد والعقوبات المعروفة
- **تحذير ظهور العبارة السرية** — يرصد التطبيق محاولات التقاط لقطة الشاشة في شاشة العبارة السرية ويمنعها على Android

اطّلع على التفاصيل الكاملة: [نهج Lumina في الأمان](/en/security).

## الأسئلة الشائعة حول المحافظ المزيفة

### هل تستطيع محفظة مزيفة سرقة أموالي بمجرد تثبيتها؟
ليس فورًا. تسرق معظم المحافظ المزيفة الأموال عندما (أ) تستورد عبارة سرية موجودة إليها، أو (ب) تنشئ عبارة سرية جديدة داخلها، أو (ج) توقّع معاملة تصنعها هي. تثبيتها وعدم استخدامها أبدًا آمن نسبيًا — لكن احذفها على أي حال.

### كيف أتحقق من أن محفظتي الحالية أصلية؟
على Android، تحقق من مصدر التثبيت: الإعدادات ← التطبيقات ← [المحفظة] ← معلومات التطبيق ← المثبّت. يجب أن يظهر "Google Play Store" (com.android.vending). أما على iOS، فلا يمكن تعديل التطبيقات المثبّتة من App Store الحقيقي بهذه الطريقة؛ لذا يكون الخطر أقل. قارن أيضًا اسم الناشر بنطاق الجهة المطورة الحقيقية.

### أعتقد أنني أدخلت عبارتي السرية في موقع مزيف. ماذا أفعل الآن؟
الإجراء الفوري: افتح محفظتك الشرعية وانقل كل الرموز إلى محفظة جديدة تمامًا تنشئها (بعبارة سرية جديدة). العبارة القديمة مخترقة إلى الأبد. اطّلع على [عمليات احتيال استعادة العملات المشفرة بدعم مزيف](/en/blog/fake-support-crypto-recovery-scams).

### هل المحافظ الصلبة محصّنة ضد هذه الهجمات؟
في الغالب نعم. تحمي المحافظ الصلبة المفتاح، لذا حتى لو كان تطبيق مرافق مزيف على هاتفك فلن يستطيع استخراجه. لكن المعاملة الخبيثة التي يبنيها تطبيق dApp مزيف ستظهر على المحفظة الصلبة، ويبقى عليك ألا توافق عليها. اقرأ ما يظهر على شاشة الجهاز.

## الخلاصة

المحافظ المشفرة المزيفة في 2026 ليست عمليات هواة — بل هي احترافية وممولة جيدًا وتتطور بسرعة. الدفاع مملّ لكنه موثوق: ثبّت فقط من المتاجر الرسمية، ولا تكتب عبارتك السرية خارج التطبيق الذي أنشأها، واستخدم محفظة تفك توقيع المعاملات، وضع إشارات مرجعية للنطاقات الحقيقية. أربع عادات، بلا استثناءات.

**ثبّت Lumina Wallet — من المتاجر الرسمية فقط:** [Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380).

---

### المراجع

[1] Chainalysis. (2026). *Mid-Year Crypto Crime Report 2026 — Fake Wallet Threats*. [https://www.chainalysis.com/](https://www.chainalysis.com/)

[2] Google Safety. (2026). *Crypto Wallet App Safety Guidelines*. [https://safety.google/](https://safety.google/)`
  },
  "checklist-securite-wallet-crypto-2026": {
    title: "قائمة التحقق من أمان محفظة العملات المشفرة 2026",
    meta: "قائمة تحقق أمنية عملية وغير مبالغ فيها لكل مستخدم لمحفظة عملات مشفرة في عام 2026. خمسة عشر بنداً مقسمة إلى الإعداد والاستخدام اليومي والتخزين طويل الأمد والاسترداد، وهي مكتوبة للمستخدمين العاديين لا للمدقّقين الأمنيين.",
    body: `معظم مقالات "نصائح أمان محفظة العملات المشفرة" إما تقنية أكثر من اللازم (نماذج تهديد موجهة للمدقّقين) أو مبهمة أكثر من اللازم ("كن حذراً!"). هذه قائمة من نوع مختلف: **خمسة عشر إجراءً عملياً قابلاً للاختبار**، مقسمة بحسب المرحلة التي تمر بها في رحلتك مع العملات المشفرة، مع ذكر الهجوم المحدد الذي يمنعه كل إجراء. إذا كنت ستقرأ قائمة واحدة فقط هذا العام عن أمان المحافظ، فهذه هي القائمة التي تستحق الطباعة.

## القسم 1 — الإعداد (أول 15 دقيقة)

### 1. ثبّت التطبيق من المتجر الرسمي، وليس من إعلان في نتائج البحث
**يمنع:** نسخ صفحات المتاجر المنتحلة المدعومة بالإعلانات وملفات APK المعدّلة.
اكتب نطاق الشركة الحقيقي يدوياً، واعثر على شارة المتجر هناك، ثم انتقل منها. لا تثبّت أبداً من نتيجة ممولة على Google.

### 2. تحقق من اسم الناشر في صفحة التطبيق
**يمنع:** التطبيقات المقلِّدة ذات الأيقونات المشابهة.
في Google Play وApp Store يظهر اسم الناشر أسفل عنوان التطبيق. يجب أن يطابق الشركة التي تتوقعها (مثل "HEDONISME SARL" لـ Lumina Wallet). فإذا ظهر "Lumina Studios LLC" فهو تطبيق مقلِّد.

### 3. أنشئ محفظة جديدة — ولا تستورد محفظة قديمة على هاتف جديد فوراً
**يمنع:** حالات اختراق عبارة الاسترداد.
إذا كنت تُعدّ محفظة للمرة الأولى، فأنشئ عبارة استرداد جديدة. لا تستورد عبارة موجودة إلا إذا كنت بحاجة فعلية إلى الوصول إلى تلك الأموال.

### 4. دوّن عبارة الاسترداد على الورق أو على نسخة احتياطية معدنية
**يمنع:** التسريبات السحابية وبرمجيات التقاط الشاشة الخبيثة.
لا تحفظ العبارة أبداً في ملاحظة سحابية (Google Keep أو iCloud Notes أو Dropbox)، ولا كلقطة شاشة، ولا في مدير كلمات مرور متزامن مع السحابة، ولا في مسودات بريدك الإلكتروني. الورق أو لوح فولاذي (Billfodl وCryptosteel) فقط.

### 5. أكّد العبارة داخل التطبيق، ثم اختبر الاسترداد قبل تحميل الأموال
**يمنع:** أخطاء الكتابة أثناء الإعداد التي لا تُكتشف إلا بعد فوات الأوان.
تطلب منك معظم المحافظ تأكيد العبارة بإعادة اختيار الكلمات. افعل ذلك بعناية. ثم — قبل تحويل أي أموال حقيقية — احذف المحفظة واستردّها مرة واحدة باستخدام نسختك المكتوبة. إذا تمت الاستعادة بشكل صحيح، فنسختك الاحتياطية تعمل.

## القسم 2 — الاستخدام اليومي

### 6. اقفل التطبيق بالقياسات الحيوية + رمز PIN
**يمنع:** سرقة الهاتف وهو مفتوح.
كلتا الطبقتين مهمة: القياسات الحيوية للراحة اليومية، ورمز PIN كخيار احتياطي إذا تمكّن السارق من فتح الهاتف بوجهك.

### 7. استخدم محفظة بها مفكّك للتوقيعات
**يمنع:** توقيعات ERC-20 Permit وPermit2 الخبيثة.
تترجم المحفظة الجيدة التوقيعات إلى لغة واضحة ("أنت تفوّض [عقداً غير معروف] بإنفاق كمية غير محدودة من USDT") قبل أن توقّع. فإذا كانت محفظتك تعرض سلسلة سداسية عشرية خام، فانتقل إلى محفظة أفضل. اطّلع على تحليلنا المعمّق حول [عمليات الاحتيال عبر ERC-20 Permit الخبيثة](/en/blog/malicious-erc20-permit-scam).

### 8. فعّل تصفية الرموز المزيفة (أو استخدم محفظة تفعل ذلك افتراضياً)
**يمنع:** عمليات احتيال الإيردروب التي يظهر فيها USDT مزيف بجانب الرمز الحقيقي.
تقوم Lumina Wallet بتصفية الرموز بحسب عنوان العقد الرسمي. وإذا كانت محفظتك تعرض كل إيردروب، فتعامل مع كل رمز غير متوقع على أنه مشبوه حتى يثبت أنه حقيقي على مستكشف البلوكشين.

### 9. تحقق من عنوان المستلم باستخدام ماسح على السلسلة
**يمنع:** تسميم العناوين والعناوين الخاضعة للعقوبات.
تفحص المحافظ الحديثة كل عنوان صادر مقابل قوائم GoPlus وChainalysis وOFAC في الوقت الفعلي. إذا تم تمييز عنوان ما — فتوقّف. اقرأ: [عملية احتيال تسميم العناوين](/en/blog/address-poisoning-crypto-scam).

### 10. اختبر المستلم الجديد بمبلغ صغير أولاً
**يمنع:** الأخطاء المطبعية وتسميم العناوين والعناوين المنسوخة التي استُبدلت عبر التصيّد.
قبل أي تحويل يتجاوز نحو 500 دولار، أرسل نحو 5–10 دولارات أولاً. تأكد من وصولها إلى المحفظة الصحيحة. ثم أرسل الباقي.

## القسم 3 — المعاملات وتطبيقات dApps

### 11. لا توقّع أبداً توقيعاً لا تفهمه
**يمنع:** جميع عمليات السحب القائمة على التوقيعات (Permit وPermit2 وSeaportOrder وموافقات ERC-721).
إذا عرضت عليك محفظة أو تطبيق dApp طلب توقيع بحقول غير واضحة، فلا توقّع. لا يوجد **أي سبب مشروع** لتوقيع توقيع غامض في عام 2026.

### 12. اعتبر "الموافقة غير المحدودة" علامة تحذير
**يمنع:** موافقات الإنفاق اللانهائي التي تبقى فعّالة إلى الأبد.
عندما يطلب تطبيق dApp موافقة على رمز ERC-20، فضّل "مبلغاً مخصصاً" (بقدر مبلغ هذه المعاملة فقط) على "غير محدود". راجع الموافقات القديمة غير المحدودة وألغِها دورياً عبر Revoke.cash أو مدير الموافقات في محفظتك.

### 13. افصل تطبيقات dApps التي لم تعد تستخدمها
**يمنع:** استغلال الصلاحيات الخاملة لاحقاً.
لكل محفظة عرض "المواقع المتصلة" أو "التطبيقات المتصلة". إذا لم تتعرف على اتصال ما، فافصله. القيام بذلك شهرياً يستغرق 30 ثانية.

## القسم 4 — التخزين طويل الأمد والاسترداد

### 14. استخدم محفظة هاردوير للمبالغ التي تتجاوز "خط الراحة" لديك
**يمنع:** البرمجيات الخبيثة على الجهاز التي تسرّب المفاتيح.
لكل شخص عتبة مختلفة يبدأ عندها الشعور بأنه "سأنزعج كثيراً إذا سُرق هذا". بالنسبة لمعظم مستخدمي 2026، يقع هذا الخط في مكان ما بين 5 آلاف و20 ألف دولار. وفوقه، تستحق محفظة الهاردوير تكلفتها البالغة نحو 70–150 دولاراً.

### 15. وزّع ممتلكاتك على محفظتين على الأقل
**يمنع:** اختراق محفظة واحدة يؤدي إلى فقدان كل شيء.
افصل "محفظة الإنفاق" (محمولة ومريحة وبمبالغ أصغر) عن "محفظة الادخار" (محفظة هاردوير أو محفظة برمجية ذات نسخ احتياطية متينة، باردة). التحويلات بين الاثنتين نادرة ومقصودة.

## ملخص قابل للطباعة

| # | الإجراء | يمنع |
|---|---|---|
| 1 | التثبيت من المتجر الرسمي | نسخ صفحات المتاجر المنتحلة |
| 2 | التحقق من اسم الناشر | التطبيقات المقلِّدة |
| 3 | إنشاء محفظة جديدة | عبارات الاسترداد المخترقة |
| 4 | نسخة احتياطية ورقية/معدنية | التسريبات السحابية |
| 5 | اختبار الاسترداد قبل التمويل | أخطاء الكتابة أثناء الإعداد |
| 6 | القياسات الحيوية + PIN | سرقة الهاتف |
| 7 | مفكّك التوقيعات | عمليات سحب Permit/Permit2 |
| 8 | مرشّح الرموز المزيفة | عمليات احتيال الإيردروب |
| 9 | ماسح العناوين على السلسلة | تسميم العناوين |
| 10 | تحويل تجريبي صغير | الأخطاء المطبعية، التسميم |
| 11 | عدم توقيع التوقيعات الغامضة | جميع عمليات الاحتيال عبر التوقيعات |
| 12 | تجنب الموافقات غير المحدودة | عمليات السحب بالإنفاق اللانهائي |
| 13 | فصل تطبيقات dApps غير المستخدمة | الاستغلالات الخاملة |
| 14 | محفظة هاردوير للمدخرات | البرمجيات الخبيثة على الجهاز |
| 15 | الفصل بين الإنفاق والادخار | اختراق محفظة واحدة |

## كيف تغطي Lumina Wallet هذه القائمة

البنود 6–11 و13 مدمجة في Lumina Wallet افتراضياً — دون الحاجة إلى أي إعداد. أما البنود 1–5 و12 و14 و15 فتعتمد على عاداتك الشخصية، ولا تستطيع أي محفظة فرضها نيابةً عنك.

اطّلع على التفاصيل الكاملة للميزات: [ميزات Lumina Wallet](/en/features) و[نهجنا في الأمان](/en/security).

## الأسئلة الشائعة حول أمان محفظة العملات المشفرة

### كم مرة يجب أن أراجع هذه القائمة؟
تكفي إعادة قراءة كاملة كل 6 أشهر. أما البنود السريعة (3 و9 و13) فتستحق التطبيق قبل كل معاملة جديدة تتجاوز 500 دولار.

### هل مدير كلمات المرور آمن لحفظ عبارة الاسترداد؟
فقط إذا لم يكن لمدير كلمات المرور أي مزامنة سحابية على الإطلاق (خزنة محلية فقط) وكان الجهاز مشفّراً. بالنسبة لمعظم المستخدمين، الورق أو المعدن أبسط وأكثر أماناً. مديرو كلمات المرور المتزامنون مع السحابة = سحابة = خارج نطاق ما يصلح لحفظ عبارة الاسترداد.

### ماذا لو سُرق هاتفي والمحفظة مفتوحة؟
إذا كنت قد طبّقت البندين 6 (القياسات الحيوية + PIN) و15 (توزيع الممتلكات)، فإن انكشاف محفظة الإنفاق محدود ومدخراتك لم تُمَس. ومع ذلك، ألغِ فوراً اتصالات dApps من جهاز آخر، وإذا كانت لديك عبارة الاسترداد فحوّل الأموال إلى محفظة جديدة.

### هل لا يزال نشاط العملات المشفرة عبر المتصفح آمناً في 2026؟
يمكن أن يكون كذلك، مع محفظة إضافة متصفح موثوقة وملف تعريف متصفح مخصص ومراجعة صارمة للتوقيعات. لكن سطح الهجوم أكبر منه على الهاتف المحمول. وبالنسبة لمعظم المستخدمين العاديين، فإن المحافظ المحمولة ذات الحماية المدمجة هي الخيار الافتراضي الأفضل في 2026.

## الخاتمة

أمان محفظة العملات المشفرة في 2026 هو 90 % عادات و10 % تقنية. والجانب التقني مهم — فالمحفظة التي تفكّ التوقيعات وتفحص العناوين وتصفّي الرموز المزيفة تسدّ ثغرات هجمات لا يمكن للانضباط وحده أن يصدّها. لكن العادات الخمس عشرة أعلاه هي ما يفرّق بين مستخدم ينام قرير العين وآخر يتعلم أهمية حماية عبارة الاسترداد بالطريقة الصعبة.

**جرّب المحفظة مع البنود 6–11 و13 المدمجة:** [Lumina Wallet على Google Play](https://play.google.com/store/apps/details?id=com.luminawallet.app) | [App Store](https://apps.apple.com/us/app/lumina-wallet/id6760651380).

---

### المراجع

[1] NIST. (2026). *Digital Identity Guidelines — Cryptographic Key Management for Consumer Wallets*. [https://www.nist.gov/](https://www.nist.gov/)

[2] GoPlus Labs. (2026). *2026 Crypto Threat Intelligence Report*. [https://gopluslabs.io/](https://gopluslabs.io/)`
  },
  "verifier-app-wallet-crypto-authentique": {
    title: "كيف تتحقق من أن تطبيق محفظة العملات الرقمية حقيقي: قائمة التحقق لعام 2026",
    meta: "قبل تثبيت تطبيق محفظة عملات رقمية، أجرِ هذه الفحوصات: الرابط الرسمي، والناشر، ومعرّف التطبيق، والأذونات، وسلوك عبارة الاسترداد. قائمة تحقق من 5 دقائق لاكتشاف تطبيقات المحافظ المزيفة.",
    body: `تطبيقات المحافظ المزيفة من أبسط الطرق لخسارة العملات الرقمية: تثبّت تطبيقًا يبدو كمحفظة عادية، وتنشئ عبارة استرداد أو تستورد واحدة، فيرسل التطبيق هذه العبارة بصمت إلى المحتال. لا اختراق ولا ثغرة، بل مجرد تطبيق خاطئ.

الخبر الجيد أن معظم تطبيقات المحافظ المزيفة تفشل في بعض الفحوصات الأساسية. يقدم لك هذا الدليل **روتين تحقق يمكنك إجراؤه في نحو خمس دقائق** قبل تثبيت أي محفظة، بما فيها Lumina Wallet.

> هل سبق أن اطلعت على علامات التحذير الرئيسية؟ يشرح دليلنا [المحافظ المزيفة للعملات الرقمية: كيف تكتشف النسخ المقلدة](/ar/blog/faux-wallets-crypto-clones) كيف تعمل التطبيقات المقلدة. أما هذه المقالة فهي قائمة التحقق العملية.

## الخطوة 1: ابدأ من الموقع الرسمي لا من إعلان في نتائج البحث

أكثر نقاط الدخول شيوعًا للمحفظة المزيفة هي **النتيجة الممولة** أو الإعلان الذي يظهر فوق النتيجة الحقيقية. يشتري المحتالون إعلانات على أسماء المحافظ لأن الناس يبحثون عنها.

- اكتب عنوان الموقع الرسمي بنفسك، أو استخدم إشارة مرجعية أنشأتها سابقًا.
- استخدم روابط التنزيل المنشورة على ذلك الموقع، لا أول رابط في محرك البحث أو في شبكة اجتماعية.
- احذر من النطاقات المشابهة: حرف زائد، أو امتداد مختلف (.app, .io, .net)، أو أحرف تبدو متطابقة (مثل "rn" بدلًا من "m").

بالنسبة إلى Lumina Wallet، تجد روابط التنزيل الرسمية في [صفحة التنزيل](/ar/download).

## الخطوة 2: تحقق من الناشر في صفحة المتجر

في App Store أو Google Play، افتح صفحة التطبيق وانظر إلى **اسم المطوّر / الناشر**، لا إلى اسم التطبيق وشعاره فقط، فهذان يسهل نسخهما.

- يجب أن يطابق الناشر الشركة أو المشروع الذي يقف وراء الموقع الرسمي.
- اضغط على اسم الناشر: فريق المحفظة الحقيقي له عادةً تاريخ متسق، لا قائمة تطبيقات غير مترابطة نُشرت الأسبوع الماضي.
- اقرأ أحدث التقييمات. وجود عدة تقييمات تذكر أن "الأموال اختفت بعد الاستيراد" علامة تحذير قوية. وكذلك كثرة تقييمات الخمس نجوم العامة المنشورة خلال بضعة أيام.

## الخطوة 3: قارن معرّف التطبيق

لكل تطبيق معرّف فريد لا تستطيع النسخة المقلدة إعادة استخدامه في المتاجر الرسمية:

- **Android:** اسم الحزمة (package name) في رابط Google Play (بعد \`id=\`).
- **iOS:** المعرّف الرقمي في رابط App Store (بعد \`/id\`).

قارنه بالمعرّف الموجود في الرابط المنشور على الموقع الرسمي. إذا كان الموقع الرسمي يشير إلى معرّف والتطبيق الذي وجدته يحمل معرّفًا آخر، فهو ليس التطبيق نفسه.

## الخطوة 4: لا تثبّت محفظة من ملف أُرسل إليك

المحفظة المثبّتة من ملف APK جرى تداوله على Telegram أو Discord أو WhatsApp أو عبر البريد الإلكتروني تتجاوز مراجعة المتجر بالكامل. وتُعد النسخ "المعدّلة" أو "الاحترافية" أو "المفتوحة" من المحفظة فخًا كلاسيكيًا.

- ثبّت المحافظ من المتاجر الرسمية فقط، عبر روابط الموقع الرسمي.
- إذا أصرّ شخص على أن تثبّت نسخة خاصة "لإصلاح حسابك"، فاعتبر ذلك عملية احتيال. تتناول مقالتنا عن [الدعم المزيف وعمليات احتيال الاسترداد](/ar/blog/faux-support-arnaques-recuperation-crypto) هذا النمط.

## الخطوة 5: افحص الأذونات (Android)

لا يحتاج تطبيق المحفظة إلا إلى القليل: الوصول إلى الشبكة، وأحيانًا الكاميرا لمسح رموز QR. كن حذرًا إذا طلبت المحفظة:

- **خدمات إمكانية الوصول** (تستطيع قراءة ما على شاشتك والتحكم به)،
- **العرض فوق التطبيقات الأخرى** (تستطيع إظهار شاشات مزيفة فوق الشاشات الحقيقية)،
- **الوصول إلى الرسائل النصية SMS** أو صلاحيات **مسؤول الجهاز**.

لا شيء من هذه الأذونات مطلوب لإرسال العملات الرقمية أو استقبالها.

## الخطوة 6: راقب كيف يتعامل التطبيق مع عبارة الاسترداد

هذا أهم فحص، لأن عبارة الاسترداد هي ما يريده المحتال.

- المحفظة غير الحافظة (non-custodial) الحقيقية **تولّد** عبارة الاسترداد على جهازك عند إنشاء محفظة جديدة، وتطلب منك تدوينها بعيدًا عن الإنترنت.
- ولا تطلب منك أبدًا إرسال العبارة إلى "الدعم"، ولا "التحقق منها" أو "مزامنتها" على موقع، ولا إدخالها "لفتح" مكافأة.
- إذا طلب منك تطبيق استيراد عبارة موجودة فورًا، مع ضغط نفسي ("سيتم تعليق محفظتك")، فتوقف.

وعند الشك، **أنشئ محفظة جديدة** في التطبيق بدلًا من استيراد عبارة الاسترداد الرئيسية، واختبرها أولًا.

## الخطوة 7: اختبر بمبلغ صغير

قبل نقل أموال كبيرة:

1. أرسل مبلغًا صغيرًا إلى المحفظة الجديدة.
2. تحقق من المعاملة على مستكشف بلوكتشين عام.
3. أعد جزءًا منه إلى عنوان تتحكم فيه.

إذا تصرف أي شيء بشكل غريب، كعدم ظهور الرصيد، أو تغيّر العنوان بشكل غير متوقع، أو طلب "رسوم" لفتح أموالك، فتوقف عن استخدام التطبيق.

## قائمة التحقق من 5 دقائق

| الفحص | كيف يبدو التطبيق الحقيقي |
| --- | --- |
| المصدر | رابط مأخوذ من الموقع الرسمي، لا من إعلان أو رسالة |
| الناشر | الجهة نفسها صاحبة الموقع الرسمي، بتاريخ متسق |
| معرّف التطبيق | يطابق المعرّف المرتبط من الموقع الرسمي |
| التثبيت | من المتجر الرسمي فقط، وليس من ملف APK أُرسل إليك |
| الأذونات | لا إمكانية وصول ولا عرض فوق التطبيقات ولا SMS ولا صلاحيات مسؤول |
| عبارة الاسترداد | تُولَّد محليًا ولا يطلبها "الدعم" أو موقع إلكتروني |
| الاستخدام الأول | معاملة اختبار صغيرة قبل نقل مبالغ أكبر |

## ماذا تفعل إذا ثبّتَّ محفظة مزيفة

إذا أدخلت عبارة الاسترداد في تطبيق صرت تشك فيه، فافترض أن العبارة قد اخترقت:

1. **تصرف بسرعة.** ثبّت محفظة حقيقية من المصدر الرسمي على جهاز تثق به، وأنشئ محفظة **جديدة** بعبارة استرداد جديدة.
2. **انقل أموالك** من العناوين القديمة إلى المحفظة الجديدة.
3. **راجع أذونات الرموز (token approvals)** المرتبطة بالعناوين القديمة باستخدام أداة موثوقة لفحص الأذونات، وألغِ ما لا تعرفه.
4. **احذف التطبيق المزيف** وبلّغ عنه في المتجر.
5. **تجاهل أي شخص يعرض استرداد أموالك** مقابل رسوم: هذه العروض تكاد تكون دائمًا عملية احتيال ثانية.

## الأسئلة الشائعة

**هل يمكن أن يوجد تطبيق محفظة مزيف في المتاجر الرسمية؟**
نعم، يحدث ذلك: بعض النسخ المقلدة تجتاز المراجعة لفترة قبل أن تُزال. لهذا يهم التحقق من الناشر ومعرّف التطبيق، لا من المتجر وحده.

**هل المحفظة ذات التنزيلات الكثيرة حقيقية دائمًا؟**
لا. يمكن تضخيم أعداد التنزيلات والتقييمات. استخدمها كمؤشر واحد بين مؤشرات أخرى، ولا تعتمدها دليلًا قاطعًا.

**هل يطلب Lumina Wallet عبارة الاسترداد الخاصة بي؟**
لا. Lumina Wallet محفظة غير حافظة: تبقى عبارة الاسترداد على جهازك ولن يطلبها منك أحد من Lumina.

**كيف أحافظ على أمان محفظتي بعد تثبيتها؟**
اتبع [قائمة التحقق لأمان محفظة العملات الرقمية 2026](/ar/blog/checklist-securite-wallet-crypto-2026) للإعداد والاستخدام اليومي والاسترداد.

## الخلاصة

لا ينجح تطبيق المحفظة المزيف إلا إذا تجاهلت الفحوصات الأساسية. خذ الرابط من الموقع الرسمي، وقارن الناشر ومعرّف التطبيق، وارفض الملفات التي يرسلها الغرباء، ولا تعطِ عبارة الاسترداد لأي شخص. خمس دقائق من التحقق أرخص بكثير من خسارة محفظة.

لتثبيت Lumina Wallet، استخدم الروابط الموجودة في [صفحة التنزيل](/ar/download) الرسمية.`
  },
  "crypto-volees-que-faire": {
    title: "استرداد العملات المسروقة في عمليات احتيال إيثيريوم: ما الذي يمكنك فعله فعلًا بعد سرقة أموالك الرقمية (2026)",
    meta: "سُرقت عملاتك الرقمية في عملية احتيال؟ إليك ما يمكنك فعله بواقعية خلال أول 24 ساعة: تأمين محفظتك، وحفظ الأدلة، وتتبّع الأموال، والإبلاغ للشرطة والمنصات ومُصدِّري العملات المستقرة، وتجنّب عمليات احتيال \"الاسترداد\".",
    body: `إذا سُرقت عملات ETH أو الرموز الخاصة بك عبر عملية احتيال أو موقع تصيّد أو توقيع خبيث، فإن الساعات الأولى هي الأهم. يشرح هذا الدليل **ما يمكنك فعله بواقعية**، وبأي ترتيب، وكيف تتجنب خسارة المزيد من الأموال لصالح "خبراء الاسترداد" الذين يستهدفون الضحايا بعد السرقة مباشرة.

نقطة صريحة أولًا: لا يمكن إلغاء معاملات البلوكشين. لا أحد، لا محفظتك ولا Ethereum ولا Lumina Wallet، يستطيع الضغط على زر لعكسها. الاسترداد ممكن أحيانًا، لكن فقط عبر مسارات محددة: تجميد الأموال من قبل منصة تداول أو مُصدِّر عملة مستقرة، وعادةً بعد بلاغ رسمي.

## الخطوة 1: أوقف الضرر (الدقائق الأولى)

قبل محاولة استعادة أي شيء، احمِ ما تبقّى.

- **لا ترسل المزيد من الأموال** إلى أي شخص يعدك بـ"فتح" أموالك أو "إطلاقها" أو "استردادها".
- إذا كانت **عبارة الاسترداد** (recovery phrase) قد تعرّضت للاختراق (كتبتها على موقع ما، أو في تطبيق صرتَ تشك فيه، أو أعطيتها لـ"الدعم الفني")، فأنشئ **محفظة جديدة بعبارة استرداد جديدة** على جهاز تثق به، وانقل الأموال المتبقية إليها.
- إذا كانت السرقة ناتجة عن **موافقة أو توقيع خبيث**، فراجع أذونات الرموز (token approvals) الخاصة بعنوانك باستخدام أداة فحص موثوقة (مثل أداة token approval على Etherscan) وألغِ الأذونات التي لا تعرفها. يمكن لأداة السحب الخبيثة (drainer) الاستمرار في استخدام الإذن إلى أن يُلغى.
- افصل المحفظة عن الموقع المعني، وأزل أي تطبيق أو إضافة متصفح مشبوهة.

## الخطوة 2: اجمع الأدلة

كل خطوة لاحقة تعتمد على معلومات دقيقة. دوّن أو احفظ:

- **هاشات المعاملات** (TxID) الخاصة بالتحويلات المسروقة؛
- عنوانك و**عناوين الاستلام**؛
- التاريخ والوقت والمبالغ؛
- رابط الموقع، واسم التطبيق، وحسابات التواصل الاجتماعي وأسماء المستخدمين المعنية؛
- لقطات شاشة للمحادثات والإعلانات ورسائل البريد الإلكتروني والصفحات التي استخدمتها.

احتفظ بالرسائل الأصلية: لا تحذف المحادثة مع المحتال.

## الخطوة 3: تتبّع الأموال على مستكشف البلوكشين

الصق هاش المعاملة في مستكشف بلوكشين مثل Etherscan. انظر إلى وجهة الأموال بعد ذلك:

- إذا ذهبت إلى عنوان موسوم على أنه **منصة تداول مركزية** (عنوان إيداع لمنصة معروفة)، فهذا أفضل خيط: يمكن للمنصات المنظَّمة تجميد حساب، عادةً بناءً على طلب الشرطة.
- إذا كانت الأصول المسروقة **USDT أو USDC**، فلدى مُصدِّريها القدرة التقنية على تجميد الرموز المحتفظ بها في عنوان ما، عادةً بالتعاون مع جهات إنفاذ القانون. السرعة مهمة، لأن المحتالين يحوّلونها غالبًا بسرعة إلى أصول أخرى.
- إذا مرّت الأموال عبر **خلّاط** (mixer) أو عبر عناوين وسيطة كثيرة، يصبح الاسترداد أصعب بكثير. أبلغ عن الحالة رغم ذلك.

لا يلزم أن تكون خبيرًا: هاشات المعاملات وعناوين الاستلام هي ما سيطلبه المحققون والمنصات.

## الخطوة 4: قدّم بلاغًا رسميًا

البلاغ الرسمي هو ما يجعل التجميد ممكنًا. قدّمه في أقرب وقت:

- **الشرطة** في بلدك، أو جهة الإبلاغ عن الجرائم الإلكترونية فيه (في الولايات المتحدة، مركز IC3 التابع لـ FBI على ic3.gov). اطلب رقم بلاغ أو رقمًا مرجعيًا.
- **منصة التداول** التي استلمت الأموال: تواصل مع دعمها الرسمي عبر موقعها أو تطبيقها (وليس أبدًا عبر رابط أُرسل إليك)، مع هاشات المعاملات ورقم مرجع الشرطة.
- **مُصدِّر العملة المستقرة**، إذا سُرقت USDT أو USDC، عبر موقعه الرسمي.
- **قواعد بيانات الاحتيال العامة** مثل Chainabuse، لتحذير المستخدمين الآخرين من العناوين المعنية.
- **المنصة التي التقيت فيها بالمحتال** (شبكة اجتماعية، متجر تطبيقات، شبكة إعلانات)، حتى يمكن حذف الحساب أو التطبيق أو الإعلان.

## الخطوة 5: احذر من "خبراء الاسترداد"

بعد السرقة مباشرة، يتواصل مع الضحايا غالبًا أشخاص يزعمون أنهم قادرون على "الاختراق المضاد" أو "التتبع والاسترداد" أو "فتح" العملات المسروقة مقابل رسوم مسبقة. عمليًا، هذه العروض هي عملية احتيال ثانية معروفة.

علامات التحذير:

- يتواصلون معك أولًا، غالبًا في التعليقات أو الرسائل الخاصة بعد أن نشرت عن السرقة؛
- يضمنون النتائج أو يذكرون نسبة نجاح دقيقة؛
- يطلبون رسومًا مسبقة أو "ضريبة" أو "غاز" أو "رسوم إفراج"؛
- يطلبون عبارة الاسترداد الخاصة بك أو وصولًا عن بُعد إلى جهازك.

جهات إنفاذ القانون الحقيقية لا تتقاضى منك أي مبلغ لاسترداد أموالك. إذا أردت مساعدة متخصصة، فاختر محاميًا مرخّصًا أو شركة تحقيقات بلوكشين معروفة يمكنك التحقق من هويتها، ولا تدفع أبدًا لغريب تواصل معك. يصف مقالنا عن [عمليات احتيال استرداد العملات الرقمية والدعم المزيف](/ar/blog/faux-support-arnaques-recuperation-crypto) هذه الحيل بالتفصيل.

## أول 24 ساعة في لمحة

| متى | ماذا تفعل |
| --- | --- |
| الدقائق الأولى | توقف عن الدفع لأي شخص، وأمّن الأموال المتبقية، وألغِ الأذونات المشبوهة |
| الساعة الأولى | احفظ هاشات المعاملات والعناوين والروابط ولقطات الشاشة |
| الساعات الأولى | تتبّع الأموال على مستكشف البلوكشين، وحدّد المنصات أو العملات المستقرة |
| في اليوم نفسه | قدّم بلاغًا للشرطة، وتواصل مع المنصة والمُصدِّر عبر القنوات الرسمية |
| الأيام التالية | أبلغ عن العناوين علنًا، وتجاهل عروض "الاسترداد" غير المرغوب فيها |

## ما فرص استرداد عملاتك الرقمية؟

بصراحة، هي محدودة وتعتمد على المسار الذي سلكته الأموال. الحالات التي تُجمَّد فيها الأموال أو تُعاد تجمع عادةً بين ثلاثة أمور: تصرّف الضحية بسرعة، ووصول الأموال إلى منصة تداول منظَّمة أو عملة مستقرة قابلة للتجميد، وتقديم بلاغ رسمي. وعندما لا ينطبق أي من ذلك، يكون الاسترداد نادرًا.

لهذا تكتسب الوقاية أهمية كبيرة: فبمجرد توقيع معاملة خبيثة، لا يوجد زر للتراجع.

## كيف تتجنب ذلك في المرة القادمة

- تحقق مما توقّعه: تبدأ معظم عمليات السحب الخبيث بموافقة أو permit أو معاملة لم تفهمها بالكامل. تحلل Lumina Wallet المعاملات قبل توقيعها وتنبّهك إلى المخاطر المعروفة، لكن لا توجد أداة تكشف كل شيء، ولا تستطيع أي محفظة عكس معاملة بعد حدوثها.
- ثبّت المحافظ من المصادر الرسمية فقط: راجع [كيف تتحقق من أن تطبيق محفظة العملات الرقمية حقيقي](/ar/blog/verifier-app-wallet-crypto-authentique).
- اتبع [قائمة التحقق لأمان محافظ العملات الرقمية](/ar/blog/checklist-securite-wallet-crypto-2026) لفصل مدخراتك عن محفظتك اليومية.

## الأسئلة الشائعة

**هل يمكن عكس معاملة إيثيريوم مسروقة؟**
لا. المعاملات المؤكدة نهائية. المسارات الواقعية الوحيدة هي التجميد من قبل منصة تداول أو مُصدِّر عملة مستقرة، عادةً بعد بلاغ رسمي.

**هل أدفع لخدمة تعد باسترداد عملاتي الرقمية؟**
كن شديد الحذر. العروض غير المطلوبة التي تتضمن رسومًا مسبقة أو نتائج مضمونة هي عملية احتيال معروفة. التحقيقات الحقيقية تمر عبر الشرطة أو المنصة المعنية أو محترف مرخّص يمكن التحقق منه.

**هل يستحق الإبلاغ إذا كان المبلغ صغيرًا؟**
نعم. تساعد البلاغات المحققين على الربط بين القضايا، كما تحذّر البلاغات العلنية في قواعد بيانات الاحتيال المستخدمين الآخرين من العناوين نفسها.

**هل تستطيع Lumina Wallet استرداد أموالي المسروقة؟**
لا. Lumina Wallet محفظة غير وصائية (non-custodial) ولا يمكنها عكس المعاملات أو تجميدها. يمكنها مساعدتك في تأمين محفظة جديدة وفحص المعاملات المستقبلية قبل توقيعها.

## الخلاصة

بعد سرقة العملات الرقمية: أمّن ما تبقّى، واحفظ الأدلة، وتتبّع الأموال، وقدّم البلاغات عبر القنوات الرسمية، وارفض كل عرض "استرداد" مدفوع يصلك. السرعة والبلاغات الرسمية هما ما يمنحك أفضل فرصة، وهما لا يكلّفانك شيئًا.`
  }
};

export default ar;
